/* /assets/baesics-bundle.js — Baesics Bundle-Builder (Pipeline 8.1.1, baesics.de)
   Vanilla ES5 IIFE, keine Abhängigkeiten, wird mit defer geladen.
   Liest die Konfiguration aus <script type="application/json" data-baesics-config>
   (gerendert von sections/baesics-bundle-builder.liquid). Alle JS-Hooks sind
   data-Attribute gemäß Build-Brief (DOM/JS-Kontrakt). Wirft niemals global. */
(function () {
  'use strict';

  var instances = {};
  /* Ref-Count für die globale Body-Klasse baesics-mcb-active (Bottom-Spacer der
     Mobile-Warenkorbleiste). Mehrere Bundle-Instanzen können koexistieren
     (Theme-Editor, kein Schema-limit) — die Klasse erst entfernen, wenn die
     LETZTE Instanz mit Mobile-Leiste abgebaut ist, sonst verliert die
     überlebende Instanz ihren Spacer. */
  var mcbActiveCount = 0;

  /* ---------------------------------------------------------------- utils */

  function esc(s) {
    s = s === null || s === undefined ? '' : String(s);
    return s.replace(/[&<>"']/g, function (c) {
      switch (c) {
        case '&': return '&amp;';
        case '<': return '&lt;';
        case '>': return '&gt;';
        case '"': return '&quot;';
        default: return '&#39;';
      }
    });
  }

  function stripHtml(s) {
    return String(s === null || s === undefined ? '' : s).replace(/<[^>]*>/g, '');
  }

  function pad2(n) {
    n = String(n);
    return n.length < 2 ? '0' + n : n;
  }

  function readStore(key) {
    try { return window.localStorage.getItem(key); } catch (err) { return null; }
  }

  function writeStore(key, value) {
    try { window.localStorage.setItem(key, value); } catch (err) { /* private mode */ }
  }

  /* Standard Shopify money formatting (cents + shop.money_format). */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10);
    if (isNaN(cents)) cents = 0;
    var formatString = format || '€{{amount_with_comma_separator}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }

    var match = formatString.match(placeholderRegex);
    if (!match) return formatString;
    var value = '';
    switch (match[1]) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  /* "Noch {n} {item} wählen" → n einsetzen, {item} = Artikelwort in passender
     Zahl (kommt vom Aufrufer, s. designLabelFor). Alt-Muster "(s)" bleibt
     unterstützt, falls ein gespeicherter Text es noch nutzt. */
  function fillCount(pattern, n, itemWord) {
    return String(pattern || '')
      .split('{n}').join(String(n))
      .split('{item}').join(itemWord || '')
      .split('(s)').join(n === 1 ? '' : 's');
  }

  /* ------------------------------------------------------- voice note (vn) */

  function initVoice(root) {
    var vroot = root.querySelector('[data-bae-voice]');
    if (!vroot) return null;
    var play = vroot.querySelector('[data-bae-vn-play]');
    var wave = vroot.querySelector('[data-bae-vn-wave]');
    var knob = vroot.querySelector('[data-bae-vn-knob]');
    var time = vroot.querySelector('[data-bae-vn-time]');
    var audio = vroot.querySelector('[data-bae-vn-audio]');
    if (!play || !wave || !audio) return null;

    var bars = wave.querySelectorAll('.vn-bar');
    var playLabel = play.getAttribute('aria-label') || 'Sprachnachricht abspielen';
    var dragging = false;
    var VOICE_KEY = 'baesics.voicePos';

    function dur() {
      if (audio.duration && isFinite(audio.duration) && audio.duration > 0) return audio.duration;
      var fallback = parseFloat(wave.getAttribute('aria-valuemax'));
      return fallback && isFinite(fallback) && fallback > 0 ? fallback : 31;
    }

    function fmt(s) {
      s = Math.max(0, Math.round(s));
      return Math.floor(s / 60) + ':' + pad2(s % 60);
    }

    function update() {
      var d = dur();
      var pos = audio.currentTime || 0;
      var progress = d > 0 ? Math.min(1, Math.max(0, pos / d)) : 0;
      for (var i = 0; i < bars.length; i++) {
        if ((i + 0.5) / bars.length <= progress) bars[i].classList.add('on');
        else bars[i].classList.remove('on');
      }
      if (knob) knob.style.left = (progress * 100) + '%';
      if (time) time.textContent = (!audio.paused || pos > 0) ? fmt(pos) : fmt(d);
      wave.setAttribute('aria-valuemax', String(Math.round(d)));
      wave.setAttribute('aria-valuenow', String(Math.round(pos)));
    }

    function seekTo(sec) {
      var d = dur();
      sec = Math.min(d, Math.max(0, sec));
      try { audio.currentTime = sec; } catch (err) { /* not seekable yet */ }
      writeStore(VOICE_KEY, String(sec));
      update();
    }

    function seekFromEvent(e) {
      var rect = wave.getBoundingClientRect();
      if (!rect.width) return;
      var ratio = Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width));
      seekTo(ratio * dur());
    }

    function restorePos() {
      var saved = parseFloat(readStore(VOICE_KEY));
      if (saved && isFinite(saved) && saved > 0 && saved < dur()) {
        try { audio.currentTime = saved; } catch (err) { /* ignore */ }
      }
      update();
    }

    function onPlay() {
      play.classList.add('is-playing');
      play.setAttribute('aria-label', 'Pause');
    }
    function onPause() {
      play.classList.remove('is-playing');
      play.setAttribute('aria-label', playLabel);
      update();
    }
    function onTime() {
      writeStore(VOICE_KEY, String(audio.currentTime || 0));
      update();
    }
    function onEnded() {
      try { audio.currentTime = 0; } catch (err) { /* ignore */ }
      writeStore(VOICE_KEY, '0');
      update();
    }
    function onToggle() {
      if (audio.paused) {
        var p;
        try { p = audio.play(); } catch (err) { p = null; }
        if (p && typeof p.catch === 'function') p.catch(function () { /* autoplay block */ });
      } else {
        audio.pause();
      }
    }
    function onPointerDown(e) {
      dragging = true;
      if (wave.setPointerCapture && e.pointerId !== undefined) {
        try { wave.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
      }
      seekFromEvent(e);
      e.preventDefault();
    }
    function onPointerMove(e) { if (dragging) seekFromEvent(e); }
    function onPointerUp() { dragging = false; }
    function onKey(e) {
      var k = e.key;
      var pos = audio.currentTime || 0;
      if (k === 'ArrowLeft' || k === 'Left') { seekTo(pos - 2); e.preventDefault(); }
      else if (k === 'ArrowRight' || k === 'Right') { seekTo(pos + 2); e.preventDefault(); }
      else if (k === 'Home') { seekTo(0); e.preventDefault(); }
      else if (k === 'End') { seekTo(dur()); e.preventDefault(); }
    }

    audio.addEventListener('loadedmetadata', restorePos);
    audio.addEventListener('play', onPlay);
    audio.addEventListener('pause', onPause);
    audio.addEventListener('timeupdate', onTime);
    audio.addEventListener('ended', onEnded);
    play.addEventListener('click', onToggle);
    wave.addEventListener('pointerdown', onPointerDown);
    wave.addEventListener('pointermove', onPointerMove);
    wave.addEventListener('pointerup', onPointerUp);
    wave.addEventListener('pointercancel', onPointerUp);
    wave.addEventListener('keydown', onKey);

    if (audio.readyState >= 1) restorePos();
    else update();

    return function destroyVoice() {
      try { audio.pause(); } catch (err) { /* ignore */ }
    };
  }

  /* ------------------------------------------------------- bundle builder */

  function createBundle(root) {
    if (root.getAttribute('data-bae-ready') === '1') return null;
    root.setAttribute('data-bae-ready', '1');

    var cfg = null;
    var cfgEl = root.querySelector('[data-baesics-config]');
    if (cfgEl) {
      try { cfg = JSON.parse(cfgEl.textContent); } catch (err) { cfg = null; }
    }
    if (!cfg || !cfg.variants || !cfg.variants.length) return null;

    var sectionId = root.getAttribute('data-section-id') || cfg.sectionId || String(Math.random()).slice(2);

    /* Theme-Editor aktiv? Dann NICHT aus localStorage restaurieren/persistieren —
       sonst überstimmt ein alter gespeicherter Stand die Live-Settings des Owners
       (z. B. "Vorausgewählte Stufe" wirkt scheinbar nicht). Live-Shop unberührt. */
    var inEditor = !!(window.Shopify && window.Shopify.designMode);

    /* i18n mit Fallbacks (Prototyp-Kopie), Liquid liefert die editierbaren Werte. */
    var i18n = {
      chooseN: 'Noch {n} {item} wählen',
      unitLabel: 'Set',
      addToCart: 'In den Warenkorb',
      added: 'Zum Warenkorb hinzugefügt',
      full: 'Auswahl voll, entferne zuerst ein Design',
      soldOut: 'Ausverkauft',
      popular: 'Beliebt',
      catEye: 'Cat Eye',
      of: 'von',
      designLabel: 'Designs',
      designLabelSingular: 'Design',
      slotLabel: 'Design',
      changeLabel: 'Ändern',
      removeLabel: 'Entfernen',
      chooseLabel: 'Design wählen →',
      emptySlot: 'Design auswählen',
      drawerDone: 'Fertig, zurück zum Bundle',
      chooseDesign: 'Design wählen',
      emptyResults: 'Keine Designs in dieser Auswahl.',
      /* Positive Rabatt-Status-Zeile unter dem Kaufen-Button (Bundle-Modus):
         {n} = fehlende Stueck, {item} = Design(s)/Modell(e), {save} = Betrag,
         {pct} = aktiver Prozentsatz. Liquid liefert die editierbaren Werte. */
      dealNext: 'Noch {n} {item} und du sparst {save}',
      dealFreeOn: 'Ein {item} ist gratis, du sparst {save}',
      dealPctOn: 'Mengenrabatt aktiv, du sparst {save}',
      variantAria: 'Variante wählen',
      addLabel: 'Hinzufügen',
      incLabel: 'Eins mehr',
      decLabel: 'Eins weniger',
      qtyAria: 'Menge',
      filterPrev: 'Weitere Filter nach links',
      filterNext: 'Weitere Filter nach rechts',
      /* Staffelpreis-Texte ({n}/{unit}/{pct}-Platzhalter, Liquid liefert die
         editierbaren Werte aus den Section-Settings) */
      stfChoose: 'Farben wählen',
      stfNext: 'Noch {n} {unit} bis {pct}',
      stfStart: 'Ab {n} {unit} sparst du {pct}',
      stfMax: 'Geschafft: {pct} auf dein ganzes Set',
      /* Bundle-Modus Fortschrittsbalken (Owner-Wunsch: SF-Look auf UV/Press-On).
         {n} = naechste Schwelle, {save} = Euro-Vorschau, {pct} = erreichter Satz. */
      unitLabelPlural: 'Sets',
      bundleNext: 'Ab {n} Sets sparst du {save}',
      bundleMax: 'Bestpreis erreicht · {pct}',
      bundleMaxPlain: 'Bester Preis erreicht'
    };
    var key;
    if (cfg.i18n) {
      for (key in cfg.i18n) {
        if (Object.prototype.hasOwnProperty.call(cfg.i18n, key) && cfg.i18n[key]) i18n[key] = cfg.i18n[key];
      }
    }

    /* Rabatt-Anzeige-Regeln aus den Section-Settings (cfg.deal). Fallback =
       aktuelles Press-On-Verhalten (2+1 + ab 6 Stueck 40 %), damit eine alte
       Section-HTML-Version mit neuem JS identisch weiterrechnet. */
    var dealCfg = cfg.deal || { freeEveryN: 3, fixedThreshold: 0, fixedOffCents: 0, percentTiers: '6:40' };
    var dealFreeEveryN = parseInt(dealCfg.freeEveryN, 10) || 0;
    var dealFixedThreshold = parseInt(dealCfg.fixedThreshold, 10) || 0;
    var dealFixedOffCents = parseInt(dealCfg.fixedOffCents, 10) || 0;
    var dealPercentTiers = [];
    String(dealCfg.percentTiers || '').split(',').forEach(function (pair) {
      var parts = pair.split(':');
      var mn = parseInt(parts[0], 10);
      var pc = parseFloat(parts[1]);
      if (isFinite(mn) && mn > 0 && isFinite(pc) && pc > 0) dealPercentTiers.push({ min: mn, pct: pc });
    });

    /* Staffelpreis-Modus (cfg.mode === 'staffel'): freie Stueckzahl statt fester
       Bundle-Stufen. Die Auswahl (state.selections) bestimmt die Menge, die
       Prozent-Stufen bestimmen die Rabatt-Klasse, jede Farbe wird eine echte
       eigene Warenkorb-Zeile. Kein Stufen-Produkt, kein Mengen-Multiplikator. */
    var isStaffel = cfg.mode === 'staffel';
    var staffelCap = 30;
    if (isStaffel) {
      var stfCapRaw = parseInt(cfg.staffelMax, 10);
      if (isFinite(stfCapRaw) && stfCapRaw > 0) staffelCap = stfCapRaw;
    }
    /* Bundle-Modus: technisches Soft-Limit der Auswahl (UI-Schutz, wie
       staffelMax). Die Stufen (3/6) sind MINDESTmengen fuer Rabatte,
       keine Hoechstgrenzen — mehr Auswahl waechst einfach mit. */
    var bundleCap = 30;
    /* Sortierte Kopie der Prozent-Stufen (kleinste zuerst) fuer Leiter + Balken.
       dealPercentTiers bleibt unsortiert — die Preis-Engine scannt ohnehin alle. */
    var stfTiers = dealPercentTiers.slice().sort(function (a, b) { return a.min - b.min; });
    /* Beste erreichte Stufe fuer eine Stueckzahl (null = noch keine).
       WICHTIG: wie die Preis-Engine (discountForPrices) zaehlt der HOECHSTE
       PROZENTSATZ unter den erreichten Schwellen, nicht die hoechste Schwelle —
       sonst koennten Leiter/Rabatt-Label bei unsauber gepflegten Stufen einen
       anderen Rabatt zeigen, als tatsaechlich abgezogen wird. */
    function stfTierFor(count) {
      var hit = null;
      for (var si = 0; si < stfTiers.length; si++) {
        var t = stfTiers[si];
        if (count >= t.min && (!hit || t.pct > hit.pct || (t.pct === hit.pct && t.min > hit.min))) hit = t;
      }
      return hit;
    }
    /* Naechste noch nicht erreichte Stufe (null = Maximum erreicht). */
    function stfNextTier(count) {
      for (var si = 0; si < stfTiers.length; si++) {
        if (stfTiers[si].min > count) return stfTiers[si];
      }
      return null;
    }

    var designs = cfg.designs || [];
    var filters = cfg.filters || [];
    var hideSoldOut = cfg.hideSoldOut !== false; /* Standard: ausverkaufte Designs ausblenden */
    var designMap = {};
    for (var di = 0; di < designs.length; di++) designMap[designs[di].handle] = designs[di];

    /* Screenreader-Live-Region: DOM-stabil am Sektions-Root. Die Drawer-Karten
       werden bei jeder Auswahl komplett neu gerendert; ein aria-live-Span IN den
       Karten wird deshalb nie angekuendigt. Mengen-Aenderungen laufen hierueber. */
    var srLive = document.createElement('div');
    srLive.className = 'bae-sr-live';
    srLive.setAttribute('role', 'status');
    srLive.setAttribute('aria-live', 'polite');
    root.appendChild(srLive);
    function announce(msg) { srLive.textContent = msg; }

    function q(sel) { return root.querySelector(sel); }

    var el = {
      stage: q('[data-bae-stage]'),
      caption: q('[data-bae-caption]'),
      tray: q('[data-bae-tray]'),
      slots: q('[data-bae-slots]'),
      progress: q('[data-bae-progress]'),
      addMore: q('[data-bae-add-more]'),
      atc: q('[data-bae-atc]'),
      atcLabel: q('[data-bae-atc-label]'),
      atcPrice: q('[data-bae-atc-price]'),
      atcNote: q('[data-bae-atc-note]'),
      clear: q('[data-bae-clear]'),
      mobileBar: q('[data-bae-mobile-bar]'),
      mbLabel: q('[data-bae-mb-label]'),
      mbPrice: q('[data-bae-mb-price]'),
      mbDeal: q('[data-bae-mb-deal]'),
      mbCta: q('[data-bae-mb-cta]'),
      mbInfo: q('[data-bae-mb-info]'),
      mbChev: q('[data-bae-mb-chev]'),
      drawer: q('[data-bae-drawer]'),
      backdrop: q('[data-bae-backdrop]'),
      cards: q('[data-bae-cards]'),
      drawerMeta: q('[data-bae-drawer-meta]'),
      drawerCount: q('[data-bae-drawer-count]'),
      drawerSub: q('[data-bae-drawer-sub]'),
      footInfo: q('[data-bae-tray-open]'),
      drawerCta: q('[data-bae-drawer-cta]'),
      /* Auswahl-Tray (zweites Bottom-Sheet ueber dem Drawer) */
      traySheet: q('[data-bae-tray-sheet]'),
      trayRows: q('[data-bae-tray-rows]'),
      toast: q('[data-bae-toast]'),
      infoToggle: q('[data-bae-info-toggle]'),
      infoBubble: q('[data-bae-info-bubble]'),
      addonRow: q('[data-bae-addon]'),
      addonToggle: q('[data-bae-addon-toggle]'),
      /* Staffelpreis-Elemente (nur im Staffel-Markup vorhanden, sonst null) */
      set: q('[data-bae-set]'),
      setCount: q('[data-bae-set-count]'),
      stfProgress: q('[data-bae-stf-progress]'),
      stfNote: q('[data-bae-stf-note]'),
      stfCount: q('[data-bae-stf-count]'),
      stfFill: q('[data-bae-stf-fill]'),
      summary: q('[data-bae-summary]'),
      sumUnitRow: q('[data-bae-sum-unit-row]'),
      sumUnit: q('[data-bae-sum-unit]'),
      sumSub: q('[data-bae-sum-sub]'),
      sumSubtotal: q('[data-bae-sum-subtotal]'),
      sumDiscountRow: q('[data-bae-sum-discount-row]'),
      sumDiscountLabel: q('[data-bae-sum-discount-label]'),
      sumDiscount: q('[data-bae-sum-discount]'),
      sumTotal: q('[data-bae-sum-total]'),
      sumSaved: q('[data-bae-sum-saved]'),
      /* Drawer-Suchfeld (alle Modi, Setting-gesteuert) */
      search: q('[data-bae-search]')
    };

    var storePrefix = 'baesics.' + (cfg.productHandle || 'produkt') + '.';
    var moneyFormat = cfg.moneyFormat || '';

    var state = {
      variantId: null,
      quantity: 1,
      selections: [],
      activeSlot: 0,
      activePhoto: 0,
      tab: 'gallery',
      drawerOpen: false,
      filters: ['all', 'all'],
      busy: false,
      infoOpen: false,
      addon: false,
      /* Schwebendes Galerie-Tray per × weggeklickt (nur diese Seitenansicht,
         bewusst NICHT persistiert — Reload zeigt es wieder). */
      trayDismissed: false,
      /* "6+"-Stufe: zusaetzliche Sets OBEN DRAUF auf die groesste Stufe
         (0 = genau die Stufen-Anzahl). Nur wirksam, solange die offene
         Stufe gewaehlt ist; Stufenwechsel setzt zurueck. */
      extraCount: 0,
      /* Gewaehlte Produkt-Variante je Design-Handle (Groesse/Farbe im Drawer).
         Ein Design in mehreren Slots teilt sich die Wahl (bewusste Vereinfachung).
         Im Zwei-Achsen-Modus (cfg.axes) abgeloest durch slotChoice. */
      variantChoice: {},
      /* Zwei-Achsen-Modus: EIGENE Variante je Paar/Slot ({v: id}), parallel
         zu selections — zwei Orbit koennen verschiedene Farbe+Groesse tragen. */
      slotChoice: [],
      /* Gemerkte Groesse (Vorfilter): belegt jedes NEUE Paar vor. null = egal. */
      sessionSize: null,
      /* Welcher Slot hat seinen Farbe/Groesse-Editor aufgeklappt? (-1 = keiner) */
      slotEdit: -1,
      /* Drawer-Suche (Freitext, kombiniert sich mit den Tag-Filtern). */
      search: '',
      /* Auswahl-Tray (zweites Bottom-Sheet) offen? */
      trayOpen: false
    };
    /* Zuletzt veraendertes Design: nur DESSEN Stepper/Zahl bekommt die
       Einblende-Animation (sonst animiert jeder innerHTML-Rebuild alles). */
    var animHandle = null;
    /* Vorherige Footer-Zaehler: nur GEAENDERTE Ziffern animieren. */
    var prevFootColors = -1;
    var prevFootPieces = -1;
    /* Bundle: zuletzt erreichte Rabatt-Klasse — Konfetti feiert den Aufstieg
       in eine NEUE Klasse (3 = Gratis-Design, 6 = Mengenrabatt), nicht mehr
       das "Volllaufen" einer Stufe (es gibt keine Hoechstmenge mehr). */
    var prevDealRank = 0;
    /* Staffel: zuletzt erreichte Rabatt-Klasse (Prozent) — Konfetti feuert beim
       Aufstieg in eine NEUE Klasse, nicht bei jedem Klick. */
    var prevStfPct = 0;
    var lastFocus = null;
    var toastTimer = null;
    var voiceDestroy = null;
    /* true, sobald JS die Stage überschrieben hat — vorher bleibt das
       server-gerenderte, eager geladene Produktfoto stehen (LCP). */
    var stageDirty = false;

    /* ------------------------------------------------------ state helpers */

    function variantById(id) {
      for (var i = 0; i < cfg.variants.length; i++) {
        if (String(cfg.variants[i].id) === String(id)) return cfg.variants[i];
      }
      return null;
    }

    function variantBySetCount(count) {
      for (var i = 0; i < cfg.variants.length; i++) {
        if (cfg.variants[i].setCount === count) return cfg.variants[i];
      }
      return null;
    }

    function firstAvailableVariant() {
      for (var i = 0; i < cfg.variants.length; i++) {
        if (cfg.variants[i].available) return cfg.variants[i];
      }
      return null;
    }

    function currentVariant() {
      return variantById(state.variantId) || cfg.variants[0];
    }

    /* "6+"-Stufe (cfg.openTier): die groesste Stufe ist nach oben offen.
       Der Warenkorb bekommt ohnehin echte Design-Zeilen und der storeweite
       "ab N = X %"-Rabatt gilt fuer jede Menge ab der Schwelle — hier waechst
       nur die UI (Slots/Preis) mit. */
    var openTier = cfg.openTier || null;
    function maxSetCount() {
      var m = 1;
      for (var i = 0; i < cfg.variants.length; i++) {
        var sc = cfg.variants[i].setCount || 1;
        if (sc > m) m = sc;
      }
      return m;
    }
    function isOpenVariant(v) {
      if (!openTier || !openTier.enabled || !v) return false;
      var sc = v.setCount || 1;
      return sc > 1 && sc === maxSetCount();
    }
    function openExtraMax() {
      if (!openTier || !openTier.enabled) return 0;
      var cap = parseInt(openTier.max, 10);
      var base = maxSetCount();
      if (!isFinite(cap) || cap <= base) return 0;
      return cap - base;
    }

    function bundleSize() {
      /* Staffel: die Menge IST die Auswahl (1 Chip = 1 Stueck), min. 1 fuer
         Preis-Fallbacks. Kapazitaets-Checks nutzen capacity(), nie bundleSize. */
      if (isStaffel) return Math.max(1, state.selections.length);
      var v = currentVariant();
      var n = Math.max(1, (v && v.setCount) || 1);
      if (state.extraCount > 0 && isOpenVariant(v)) n += state.extraCount;
      /* Stufen sind MINDESTmengen: waehlt die Kundin mehr Designs als die
         Stufe vorsieht, waechst das Set einfach mit (7., 8., 9. ...) —
         nie abschneiden, nie sperren. */
      if (state.selections.length > n) n = state.selections.length;
      return n;
    }

    /* Aktive Stufen-Groesse OHNE Auswahl-Wachstum (nur fuer Einzelset-Checks). */
    function tierSetCount() {
      var v = currentVariant();
      return Math.max(1, (v && v.setCount) || 1);
    }

    /* ECHTES Einzelprodukt = die Bundle-Sektion zeigt EIN Produkt ohne
       Stufen (tiers_ready=false: keine 3er/6er-Variante). NUR dann greift der
       Einzelset-Zwang (genau 1 Design = angezeigtes Produkt, kein „mehr wählen").
       Die 1er-KACHEL eines Stufen-Produkts ist KEIN Einzelprodukt — sie ist nur
       ein Frontend-Anker; die Kundin darf dort beliebig mehr wählen, die Stufe
       (und damit der Rabatt) waechst dann mit der Auswahl. Fallback fuer alte,
       gecachte HTML ohne hasTiers: „keine hoehere Stufe vorhanden?". */
    function isSingleProduct() {
      if (isStaffel || (cfg.axes && cfg.axes.enabled)) return false;
      if (cfg.hasTiers === true) return false;
      if (cfg.hasTiers === false) return true;
      return maxSetCount() <= 1;
    }

    /* Obergrenze der Auswahl: reines technisches Soft-Limit (UI-Schutz).
       NUR ein echtes Einzelprodukt (keine Stufen) klemmt auf 1 — die 1er-Kachel
       eines Stufen-Produkts ist nach oben offen (Kundin darf mehr wählen). */
    function capacity() {
      if (isStaffel) return staffelCap;
      if (isSingleProduct()) return 1;
      return bundleCap;
    }

    function complete() {
      /* Kaufbar ab dem ersten Stueck — die Stufen (3/6) sind Rabatt-
         Schwellen, keine Pflicht-Groessen. Der Warenkorb bekommt echte
         Design-Varianten, die Kasse rechnet den Rabatt nach Stueckzahl. */
      return state.selections.length >= 1;
    }

    function savingsFor(v) {
      if (!v || !v.compareAtCents || v.compareAtCents <= v.priceCents) return 0;
      return v.compareAtCents - v.priceCents;
    }

    function cents(value) {
      value = parseInt(value, 10);
      return isNaN(value) ? 0 : value;
    }

    /* Varianten je Design (Groesse/Farbe): nur vorhanden, wenn das Produkt
       mehr als eine Variante hat (Liquid liefert dann designs[].variants). */
    function designVariants(design) {
      return (design && design.variants && design.variants.length > 1) ? design.variants : null;
    }

    function chosenVariant(design) {
      var vs = designVariants(design);
      if (!vs) return null;
      var id = state.variantChoice[design.handle];
      var i;
      if (id) {
        for (i = 0; i < vs.length; i++) {
          if (String(vs[i].id) === String(id)) return vs[i];
        }
      }
      for (i = 0; i < vs.length; i++) {
        if (vs[i].available) return vs[i];
      }
      return vs[0];
    }

    function designVariantId(design) {
      var cv = chosenVariant(design);
      return cv ? cv.id : (design ? design.variantId : null);
    }

    /* ------------------------------------------------------------------
       Zwei-Achsen-Modus (Merino-Pilot, cfg.axes.enabled): Farbe = Swatches,
       Groesse = Segmente, und jedes PAAR (Slot) traegt seine EIGENE Variante
       in state.slotChoice[i] — zwei Orbit koennen Navy/39-42 und Beige/35-38
       sein. Ist axes aus (alle anderen Seiten), ist dieser Block inert und
       state.variantChoice verhaelt sich exakt wie bisher.
       ------------------------------------------------------------------ */
    var axes = !!(cfg.axes && cfg.axes.enabled);
    /* Groessen-Token wie "35-38" (Bindestrich tolerant). Ein Wert, der so
       aussieht, markiert die Groessen-Achse — alles andere ist Farbe. */
    var AX_SIZE_RE = /^\s*\d{2}\s*[-–]\s*\d{2}\s*$/;
    var axesHex = {};
    var axesPat = {};
    (function initAxesMaps() {
      if (!axes) return;
      var i, line, idx, key, val;
      var hexLines = String(cfg.axes.hexMap || '').split(/\r?\n|,(?=\s*[^#\s])/);
      for (i = 0; i < hexLines.length; i++) {
        line = hexLines[i].trim();
        if (!line) continue;
        idx = line.indexOf(':');
        if (idx < 1) continue;
        key = line.slice(0, idx).trim().toLowerCase();
        val = line.slice(idx + 1).trim();
        if (!key || !val) continue;
        var duo = val.split('/');
        axesHex[key] = { hex: duo[0].trim(), hex2: duo[1] ? duo[1].trim() : null };
      }
      var patLines = String(cfg.axes.patternMap || '').split(/\r?\n/);
      for (i = 0; i < patLines.length; i++) {
        line = patLines[i].trim();
        if (!line) continue;
        idx = line.indexOf(':');
        if (idx < 1) continue;
        axesPat[line.slice(0, idx).trim().toLowerCase()] = line.slice(idx + 1).trim().toLowerCase();
      }
    })();

    /* Unbekannte Farbe -> deterministischer, gedaempfter Neutralton (nie ein
       leerer Kreis). Hinweis in der Konsole, damit der Owner die Zeile in der
       Farb-Zuordnung ergaenzen kann. */
    function hexFor(name) {
      var key = String(name || '').trim().toLowerCase();
      if (axesHex[key]) return axesHex[key];
      var h = 0;
      for (var i = 0; i < key.length; i++) h = ((h * 31) + key.charCodeAt(i)) % 360;
      try { if (window.console && console.info) console.info('[baesics] Farbe ohne Hex-Zuordnung: "' + name + '" — bitte im Setting "Farbe → Farbwert" ergänzen.'); } catch (err) { /* ignore */ }
      return { hex: 'hsl(' + h + ', 12%, 62%)', hex2: null };
    }

    function patternFor(handle) {
      var key = String(handle || '').toLowerCase();
      if (axesPat[key]) return axesPat[key];
      /* Teil-Treffer erlauben ("orbit" matcht "merino-socken-orbit"). */
      for (var k in axesPat) {
        if (Object.prototype.hasOwnProperty.call(axesPat, k) && k && key.indexOf(k) !== -1) return axesPat[k];
      }
      return 'plain';
    }

    /* Achsen-Info je Design, einmal berechnet und am Design gecacht:
       welcher Options-Index ist Groesse, welcher Farbe, geordnete Farb-/
       Groessenlisten und ein O(1)-Nachschlag Farbe|Groesse -> Variante. */
    function axisInfo(design) {
      if (!axes || !design || !design.variants || design.variants.length < 2) return null;
      if (design.__axis !== undefined) return design.__axis;
      var names = design.optionNames || [];
      var first = design.variants[0];
      var opts = [first.option1, first.option2, first.option3];
      var sizeIdx = -1, colorIdx = -1, i;
      for (i = 0; i < names.length; i++) {
        if (/gr(ö|oe?)(ß|ss)e|size/i.test(String(names[i]))) sizeIdx = i;
        else if (/farbe|colou?r/i.test(String(names[i])) && colorIdx < 0) colorIdx = i;
      }
      if (sizeIdx < 0) {
        for (i = 0; i < 3; i++) {
          if (opts[i] != null && AX_SIZE_RE.test(String(opts[i]))) { sizeIdx = i; break; }
        }
      }
      if (colorIdx < 0) {
        for (i = 0; i < 3; i++) {
          if (opts[i] != null && i !== sizeIdx) { colorIdx = i; break; }
        }
      }
      var colors = [], sizes = [], byKey = {}, seenC = {}, seenS = {};
      for (i = 0; i < design.variants.length; i++) {
        var v = design.variants[i];
        var vo = [v.option1, v.option2, v.option3];
        var c = colorIdx >= 0 ? vo[colorIdx] : null;
        var s = sizeIdx >= 0 ? vo[sizeIdx] : null;
        if (c != null && !seenC[c]) { seenC[c] = true; colors.push(c); }
        if (s != null && !seenS[s]) { seenS[s] = true; sizes.push(s); }
        byKey[String(c) + '|' + String(s)] = v;
      }
      sizes.sort(function (a, b) { return (parseInt(a, 10) || 0) - (parseInt(b, 10) || 0); });
      design.__axis = { sizeIdx: sizeIdx, colorIdx: colorIdx, colors: colors, sizes: sizes, byKey: byKey };
      return design.__axis;
    }

    function variantForCS(design, color, size) {
      var ai = axisInfo(design);
      return ai ? (ai.byKey[String(color) + '|' + String(size)] || null) : null;
    }

    function colorOfV(design, variant) {
      var ai = axisInfo(design);
      if (!ai || !variant || ai.colorIdx < 0) return null;
      return [variant.option1, variant.option2, variant.option3][ai.colorIdx];
    }

    function sizeOfV(design, variant) {
      var ai = axisInfo(design);
      if (!ai || !variant || ai.sizeIdx < 0) return null;
      return [variant.option1, variant.option2, variant.option3][ai.sizeIdx];
    }

    /* Alle Groessen des Katalogs (Vorfilter-Segmente), numerisch sortiert. */
    function catalogSizes() {
      var out = [], seen = {};
      if (!axes) return out;
      for (var i = 0; i < designs.length; i++) {
        var ai = axisInfo(designs[i]);
        if (!ai) continue;
        for (var s = 0; s < ai.sizes.length; s++) {
          if (!seen[ai.sizes[s]]) { seen[ai.sizes[s]] = true; out.push(ai.sizes[s]); }
        }
      }
      out.sort(function (a, b) { return (parseInt(a, 10) || 0) - (parseInt(b, 10) || 0); });
      return out;
    }

    /* Gibt es fuer dieses Design in der Groesse irgendeine kaufbare Farbe? */
    function designHasSize(design, size) {
      var ai = axisInfo(design);
      if (!ai) return true; /* groessen-neutral: nie ausfiltern */
      if (!size) return true;
      for (var c = 0; c < ai.colors.length; c++) {
        var v = ai.byKey[String(ai.colors[c]) + '|' + String(size)];
        if (v && v.available) return true;
      }
      return false;
    }

    function colorAvailInSize(design, color, size) {
      var ai = axisInfo(design);
      if (!ai) return true;
      if (!size) {
        for (var s = 0; s < ai.sizes.length; s++) {
          var vv = ai.byKey[String(color) + '|' + String(ai.sizes[s])];
          if (vv && vv.available) return true;
        }
        return false;
      }
      var v = ai.byKey[String(color) + '|' + String(size)];
      return !!(v && v.available);
    }

    /* Naechste verfuegbare Groesse fuer eine Farbe (Index-Abstand, bei
       Gleichstand die KLEINERE — Merino-Regel). */
    function nearestSizeFor(design, color, wish) {
      var ai = axisInfo(design);
      if (!ai) return null;
      var best = null, bestDist = 1e9;
      var wIdx = ai.sizes.indexOf(wish);
      for (var s = 0; s < ai.sizes.length; s++) {
        var v = ai.byKey[String(color) + '|' + String(ai.sizes[s])];
        if (!v || !v.available) continue;
        var dist = wIdx < 0 ? s : Math.abs(s - wIdx);
        if (dist < bestDist || (dist === bestDist && s < ai.sizes.indexOf(best))) { best = ai.sizes[s]; bestDist = dist; }
      }
      return best;
    }

    /* Bevorzugte Farbe fuer ein NEUES Paar dieses Designs: letztes Paar
       desselben Designs, sonst erste (in der Session-Groesse) kaufbare Farbe. */
    function prefColorFor(handle) {
      var d = designMap[handle];
      var ai = axisInfo(d);
      if (!ai) return null;
      for (var i = state.selections.length - 1; i >= 0; i--) {
        if (state.selections[i] === handle && state.slotChoice[i]) {
          var pv = variantInDesign(d, state.slotChoice[i].v);
          var pc = pv ? colorOfV(d, pv) : null;
          if (pc && colorAvailInSize(d, pc, state.sessionSize)) return pc;
        }
      }
      for (var c = 0; c < ai.colors.length; c++) {
        if (colorAvailInSize(d, ai.colors[c], state.sessionSize)) return ai.colors[c];
      }
      return ai.colors[0] || null;
    }

    function variantInDesign(design, id) {
      if (!design || !design.variants) return null;
      for (var i = 0; i < design.variants.length; i++) {
        if (String(design.variants[i].id) === String(id)) return design.variants[i];
      }
      return null;
    }

    /* Standard-Variante fuer ein neues Paar (Farbe-Praeferenz + Session-
       Groesse, sonst naechste verfuegbare Kombi). */
    function axDefaultVariant(handle) {
      var d = designMap[handle];
      var ai = axisInfo(d);
      if (!ai) return null;
      /* Stepper-Plus dupliziert das LETZTE Paar dieses Designs EXAKT
         (gleiche Farbe UND Groesse) — nie eine andere Groesse raten. */
      for (var li = state.selections.length - 1; li >= 0; li--) {
        if (state.selections[li] === handle && state.slotChoice[li]) {
          var lv = variantInDesign(d, state.slotChoice[li].v);
          if (lv && lv.available) return lv;
          break;
        }
      }
      var color = prefColorFor(handle);
      if (!color) return null;
      var size = state.sessionSize && colorAvailInSize(d, color, state.sessionSize)
        ? state.sessionSize
        : nearestSizeFor(d, color, state.sessionSize);
      var v = size != null ? ai.byKey[String(color) + '|' + String(size)] : null;
      if (v && v.available) return v;
      /* Fallback: irgendeine kaufbare Variante */
      for (var i = 0; i < d.variants.length; i++) {
        if (d.variants[i].available) return d.variants[i];
      }
      return d.variants[0] || null;
    }

    /* Die Variante des Paars an Slot i (axes). Fallback: Standard. */
    function slotVariantAt(i) {
      if (!axes) return null;
      var d = designMap[state.selections[i]];
      if (!d) return null;
      var ai = axisInfo(d);
      if (!ai) return null;
      var sc = state.slotChoice[i];
      var v = sc ? variantInDesign(d, sc.v) : null;
      return v || axDefaultVariant(state.selections[i]);
    }

    function slotPriceCents(i, design) {
      var v = slotVariantAt(i);
      var raw = v ? cents(v.priceCents) : 0;
      return raw > 0 ? raw : designPriceCents(design);
    }

    /* Slot-Sync: jede Mutation von state.selections spiegelt sich hier.
       axPendingV wird von axAddColor gesetzt (Swatch-Tap = genau diese
       Farbe), sonst greift der Standard. */
    var axPendingV = null;
    function slotSyncPush(handle) {
      if (!axes) return;
      var v = axPendingV || axDefaultVariant(handle);
      axPendingV = null;
      state.slotChoice.push(v ? { v: String(v.id) } : null);
    }
    function slotSyncSplice(idx) {
      if (!axes) return;
      state.slotChoice.splice(idx, 1);
    }
    function slotSyncReset(list) {
      if (!axes) return;
      state.slotChoice = list || [];
    }

    /* Farbe/Groesse eines BESTEHENDEN Paars aendern (Slot-Editor). Haelt die
       jeweils andere Achse, weicht bei nicht kaufbarer Kombi auf die
       naechste verfuegbare Groesse aus (mit Ansage). */
    function slotSet(i, patch) {
      if (!axes || i < 0 || i >= state.selections.length) return;
      var d = designMap[state.selections[i]];
      var ai = axisInfo(d);
      if (!ai) return;
      var cur = slotVariantAt(i);
      var color = patch.color != null ? patch.color : (cur ? colorOfV(d, cur) : prefColorFor(state.selections[i]));
      var size = patch.size != null ? patch.size : (cur ? sizeOfV(d, cur) : state.sessionSize);
      var v = ai.byKey[String(color) + '|' + String(size)];
      var swapped = false;
      if (!v || !v.available) {
        var near = nearestSizeFor(d, color, size);
        if (near == null) { showToast(i18n.soldOut); return; }
        if (near !== size) swapped = true;
        size = near;
        v = ai.byKey[String(color) + '|' + String(size)];
      }
      if (!v) { showToast(i18n.soldOut); return; }
      state.slotChoice[i] = { v: String(v.id) };
      /* Groessen-Wahl am Paar aktualisiert die Session-Groesse ("zuletzt
         genutzt") — das NAECHSTE Paar erbt sie. */
      if (patch.size != null) setSessionSize(size, true);
      persist();
      renderAll();
      var msg = (d.shortTitle || d.title) + ', ' + color + ' · ' + size;
      if (swapped) msg += ' (' + i18n.sizeSoldIn + ', ' + size + ' gewählt)';
      announce(msg);
    }

    function setSessionSize(size, quiet) {
      if (!axes) return;
      state.sessionSize = size || null;
      if (!inEditor) writeStore(storePrefix + 'sessionSize', state.sessionSize || '');
      if (!quiet) {
        renderSizebar();
        renderDrawer();
        announce(state.sessionSize ? (i18n.sizeWord + ' ' + state.sessionSize + ' gemerkt') : (i18n.sizeWord + ': alle'));
      }
    }

    /* Swatch-Tap an der Karte = EIN neues Paar in genau dieser Farbe.
       Ohne gemerkte Groesse wird nichts geraten: Hinweis + Sizebar-Puls. */
    function axAddColor(handle, colorOrNull) {
      var d = designMap[handle];
      if (!d || d.available === false) { showToast(i18n.soldOut); return; }
      var ai = axisInfo(d);
      if (!ai) { addOne(handle); return; }
      if (!state.sessionSize) {
        showToast(i18n.sizeFirst);
        pulseSizebar();
        return;
      }
      var color = colorOrNull || prefColorFor(handle);
      if (!color) { showToast(i18n.soldOut); return; }
      /* KEIN stiller Groessen-Tausch: ist die Farbe in der gemerkten Groesse
         vergriffen, sagen wir das — statt heimlich eine andere Groesse zu
         verkaufen (Socken!). Groesse wechseln kann die Kundin im Vorfilter. */
      if (!colorAvailInSize(d, color, state.sessionSize)) { showToast(color + ': ' + i18n.sizeSoldIn); return; }
      var v = ai.byKey[String(color) + '|' + String(state.sessionSize)];
      if (!v || !v.available) { showToast(i18n.soldOut); return; }
      axPendingV = v;
      addOne(handle);
    }

    function pulseSizebar() {
      var bar = el.drawer ? el.drawer.querySelector('[data-bae-sizebar]') : null;
      if (!bar) return;
      bar.classList.remove('bae-pulse');
      void bar.offsetWidth;
      bar.classList.add('bae-pulse');
      try { bar.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (err) { /* ignore */ }
      var seg = bar.querySelector('[data-bae-size-pre]');
      if (seg && seg.focus) { try { seg.focus({ preventScroll: true }); } catch (err2) { /* ignore */ } }
    }

    /* Groessen-Vorfilter im Drawer: Segmente aus den echten Katalog-
       Groessen + "egal". Ohne gemerkte Groesse ist "egal" aktiv (stoebern),
       Kaufen je Paar verlangt dann zuerst eine Groesse (axAddColor). */
    function renderSizebar() {
      if (!axes || !el.drawer) return;
      var bar = el.drawer.querySelector('[data-bae-sizebar]');
      if (!bar) return;
      var sizes = catalogSizes();
      if (!sizes.length) { bar.setAttribute('hidden', ''); return; }
      bar.removeAttribute('hidden');
      var html = ['<span class="sizebar-label" id="bae-sizebar-label-' + esc(String(cfg.sectionId || '')) + '">' + esc(i18n.sizeAsk) + '</span>',
        '<div class="sizebar-segs" role="group" aria-label="' + esc(i18n.sizeAsk) + '">'];
      for (var i = 0; i < sizes.length; i++) {
        var on = state.sessionSize === sizes[i];
        html.push('<button type="button" class="sizebar-seg' + (on ? ' active' : '') + '" data-bae-size-pre data-size="' + esc(sizes[i]) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' + esc(sizes[i]) + '</button>');
      }
      var allOn = !state.sessionSize;
      html.push('<button type="button" class="sizebar-seg sizebar-seg--all' + (allOn ? ' active' : '') + '" data-bae-size-pre data-size="" aria-pressed="' + (allOn ? 'true' : 'false') + '">' + esc(i18n.sizeAll) + '</button>');
      html.push('</div>');
      if (cfg.axes && cfg.axes.sizeHint) {
        html.push('<span class="sizebar-hint">' + esc(cfg.axes.sizeHint) + '</span>');
      }
      bar.innerHTML = html.join('');
    }

    /* Muster-Kachel (Platzhalter statt Foto): Farbflaeche + dezentes
       SVG-Muster + Name. Gleiche Geometrie wie ein Foto — der spaetere
       Foto-Tausch ist ein reiner Datentausch. */
    var AX_PATTERNS = {
      stripes: '<pattern id="{ID}" width="9" height="9" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><rect width="9" height="9" fill="transparent"/><line x1="0" y1="0" x2="0" y2="9" stroke="{INK}" stroke-width="1.4"/></pattern>',
      snowflake: '<pattern id="{ID}" width="34" height="34" patternUnits="userSpaceOnUse"><g stroke="{INK}" stroke-width="1.3" stroke-linecap="round" fill="none"><path d="M17 5 V29 M7 10 L27 24 M27 10 L7 24"/><path d="M17 9 l-2.4 2.4 M17 9 l2.4 2.4 M17 25 l-2.4 -2.4 M17 25 l2.4 -2.4"/></g></pattern>',
      heart: '<pattern id="{ID}" width="30" height="30" patternUnits="userSpaceOnUse"><path d="M15 21 C 9 16, 7.6 12.4, 10.6 9.9 C 12.6 8.2, 15 9.6, 15 11.7 C 15 9.6, 17.4 8.2, 19.4 9.9 C 22.4 12.4, 21 16, 15 21 Z" fill="{INK}"/></pattern>',
      nordic: '<pattern id="{ID}" width="28" height="24" patternUnits="userSpaceOnUse"><g stroke="{INK}" stroke-width="1.4" fill="none" stroke-linejoin="round" stroke-linecap="round"><path d="M-2 16 L7 8 L16 16 L25 8 L34 16"/></g><rect x="12.6" y="19" width="3" height="3" fill="{INK}" transform="rotate(45 14.1 20.5)"/></pattern>',
      plain: '<pattern id="{ID}" width="12" height="12" patternUnits="userSpaceOnUse"><circle cx="3" cy="3" r="1.1" fill="{INK}"/></pattern>'
    };
    var axTileSeq = 0;
    /* Helle Flaeche -> dunkle Muster-Tinte + dunkler Name; dunkle -> helle. */
    function tileInkFor(hex) {
      var m = /^#?([0-9a-f]{6})$/i.exec(String(hex || '').trim());
      if (!m) return { ink: 'rgba(255,255,255,.35)', text: '#F6F1EA', light: false };
      var n = parseInt(m[1], 16);
      var lum = 0.2126 * ((n >> 16) & 255) + 0.7152 * ((n >> 8) & 255) + 0.0722 * (n & 255);
      return lum > 150
        ? { ink: 'rgba(60,42,40,.22)', text: '#4A3A36', light: true }
        : { ink: 'rgba(246,241,234,.30)', text: '#F6F1EA', light: false };
    }
    function tileHtml(design, colorName, cls, withName) {
      var ai = axisInfo(design);
      var color = colorName || (ai && ai.colors.length ? ai.colors[0] : null);
      var duo = hexFor(color || (design && (design.shortTitle || design.title)) || '');
      var pat = AX_PATTERNS[patternFor(design ? design.handle : '')] || AX_PATTERNS.plain;
      var pid = 'baepat-' + (++axTileSeq) + '-' + Math.abs((String(design && design.handle) + String(color)).length);
      var ink = tileInkFor(duo.hex);
      var bg = duo.hex2
        ? 'background: repeating-linear-gradient(45deg, ' + duo.hex + ' 0 4px, ' + duo.hex2 + ' 4px 8px);'
        : 'background: ' + duo.hex + ';';
      return '<span class="bae-tile ' + (cls || '') + '" style="' + bg + '" aria-hidden="true">' +
        '<svg class="bae-tile-pat" preserveAspectRatio="none"><defs>' +
        pat.replace('{ID}', pid).replace(/\{INK\}/g, ink.ink) +
        '</defs><rect width="100%" height="100%" fill="url(#' + pid + ')"/></svg>' +
        (withName ? '<span class="bae-tile-name" style="color:' + ink.text + '">' + esc(design ? (design.shortTitle || design.title) : '') + '</span>' : '') +
        '</span>';
    }

    /* Kachel ODER Foto — eine Quelle fuer Karten, Slots, Tray, Galerie. */
    function mediaHtml(design, colorName, imgCls, tileCls, withName) {
      if (design && design.swatch) return swatchImg(design, imgCls);
      if (axes && design) return tileHtml(design, colorName, tileCls, withName);
      return '';
    }

    function designPriceCents(design) {
      var cv = chosenVariant(design);
      var raw = cv ? cv.priceCents : (design && design.priceCents !== null && design.priceCents !== undefined ? design.priceCents : 0);
      var price = cents(raw);
      return price > 0 ? price : 0;
    }

    function referenceUnitPriceCents(v) {
      var d = activeDesign();
      var price = designPriceCents(d);
      if (price > 0) return price;

      if (cfg.productHandle && designMap[cfg.productHandle]) {
        price = designPriceCents(designMap[cfg.productHandle]);
        if (price > 0) return price;
      }

      for (var i = 0; i < designs.length; i++) {
        price = designPriceCents(designs[i]);
        if (price > 0) return price;
      }

      if (v && v.setCount) return Math.round(cents(v.priceCents) / Math.max(1, v.setCount));
      return cents(v && v.priceCents);
    }

    function freeCountFor(count) {
      count = parseInt(count, 10);
      if (!isFinite(count) || count < 1 || !dealFreeEveryN) return 0;
      return Math.floor(count / dealFreeEveryN);
    }

    /* Anzeige-Rabatt nach Section-Settings ("Rabatt-Anzeige"). Muss 1:1 zur
       automatischen Admin-Regel des jeweiligen Typs passen:
       - Prozent-Stufen (z. B. Socken 3:10,6:20) haben Vorrang, wenn gepflegt.
       - Sonst fester Betrag je Stueck ab Schwelle (Cap je Stueck = Preis),
         darunter "jedes N-te gratis" (guenstigste zuerst). */
    function discountForPrices(prices) {
      var count = prices.length;
      var i;
      if (dealPercentTiers.length) {
        var pct = 0;
        for (i = 0; i < dealPercentTiers.length; i++) {
          if (count >= dealPercentTiers[i].min && dealPercentTiers[i].pct > pct) pct = dealPercentTiers[i].pct;
        }
        /* Hybrid: passt keine Prozent-Stufe (Menge unter der kleinsten Schwelle),
           greifen darunter weiterhin die Regeln "fester Betrag" / "jedes N-te
           gratis" (z. B. 2+1 unter 6, ab 6 dann Prozent). */
        if (pct) {
          /* WIE SHOPIFY runden: Shopify rundet den RABATTIERTEN STUECKPREIS
             (nicht den Rabattbetrag) und zieht ihn ab. Beweis an der Kasse
             (3 x 14,95 @ 10 %): Stueckpreis 13,46 (= round(14,95 x 0,90)),
             Rabatt je Stueck 1,49 -> gesamt 4,47, Summe 40,38. Wuerde man den
             RABATT runden (round(1,495)=1,50), ergaebe das faelschlich 4,50 /
             40,35 -> Anzeige zeigte mehr Ersparnis als die Kasse (UWG). Beide
             Methoden treffen sich bei 6 x 15 % (Kasse 76,26) nur zufaellig;
             am Halb-Cent (10 %) weichen sie ab. Deshalb hier den Nettopreis
             runden — deckt sich mit der Kachel (sp_piece) UND der Kasse. */
          var pctDiscount = 0;
          for (i = 0; i < count; i++) {
            var netPiece = Math.round(prices[i] * (100 - pct) / 100);
            pctDiscount += prices[i] - netPiece;
          }
          return pctDiscount;
        }
      }
      if (dealFixedThreshold && dealFixedOffCents && count >= dealFixedThreshold) {
        var fixedDiscount = 0;
        for (i = 0; i < count; i++) fixedDiscount += Math.min(prices[i], dealFixedOffCents);
        return fixedDiscount;
      }
      var freeCount = freeCountFor(count);
      if (!freeCount) return 0;
      var sorted = prices.slice().sort(function (a, b) { return a - b; });
      var discount = 0;
      for (i = 0; i < freeCount && i < sorted.length; i++) discount += sorted[i];
      return discount;
    }

    /* Rabatt-Klasse fuer eine Stueckzahl, als steigender Rang: Prozent-Stufe
       (nach Satz) > Festbetrag > Gratis-Stufe(n) > nichts. Wie die Preis-
       Engine (discountForPrices): Prozent verdraengt darunterliegende Regeln.
       Genutzt fuer Konfetti (Aufstieg in neue Klasse) und die Status-Zeile. */
    function dealRankFor(count) {
      var pct = 0;
      for (var i = 0; i < dealPercentTiers.length; i++) {
        if (count >= dealPercentTiers[i].min && dealPercentTiers[i].pct > pct) pct = dealPercentTiers[i].pct;
      }
      if (pct) return 1000 + pct;
      if (dealFixedThreshold && dealFixedOffCents && count >= dealFixedThreshold) return 500;
      var freeN = freeCountFor(count);
      return freeN > 0 ? 100 + freeN : 0;
    }

    /* Aktiver Prozentsatz (0 = keine Prozent-Stufe erreicht). */
    function dealPctFor(count) {
      var rank = dealRankFor(count);
      return rank > 1000 ? rank - 1000 : 0;
    }

    /* Naechste gepflegte Rabatt-Schwelle oberhalb der Stueckzahl (null =
       hoechste Stufe erreicht oder keine Stufen gepflegt). */
    function dealNextMin(count) {
      var cand = [];
      if (dealFreeEveryN > 1) cand.push(dealFreeEveryN);
      if (dealFixedThreshold && dealFixedOffCents) cand.push(dealFixedThreshold);
      for (var i = 0; i < dealPercentTiers.length; i++) cand.push(dealPercentTiers[i].min);
      var next = 0;
      for (var c = 0; c < cand.length; c++) {
        if (cand[c] > count && (!next || cand[c] < next)) next = cand[c];
      }
      return next || null;
    }

    /* mult = Anzahl-Stepper (state.quantity): jede Auswahl liegt mult-mal im
       Warenkorb. Die Rabatt-Engine MUSS ueber die volle Stueckliste rechnen
       (count x mult), sonst weicht ein gestaffelter Rabatt von der Kasse ab
       (z. B. 3 Designs x Anzahl 2 = 6 Stueck = ab-6-Stufe, nicht 2+1 doppelt).
       mult=1 (Normalfall) verhaelt sich exakt wie zuvor. */
    function pricingForCount(count, mult) {
      count = parseInt(count, 10);
      if (!isFinite(count) || count < 1) count = 1;
      mult = parseInt(mult, 10);
      if (!isFinite(mult) || mult < 1) mult = 1;
      var v = variantBySetCount(count) || currentVariant();
      var fallback = referenceUnitPriceCents(v);
      var prices = [];
      for (var m = 0; m < mult; m++) {
        for (var i = 0; i < count; i++) {
          var d = designMap[state.selections[i]];
          /* axes: Preis des KONKRETEN Paars (Slot-Variante), nicht der
             geteilten Design-Wahl — Anzeige == Kasse auch bei Mischpreisen. */
          var price = axes && d ? slotPriceCents(i, d) : designPriceCents(d);
          prices.push(price > 0 ? price : fallback);
        }
      }
      var subtotal = 0;
      for (var pi = 0; pi < prices.length; pi++) subtotal += prices[pi];
      var saving = discountForPrices(prices);
      return {
        setCount: count,
        multiplier: mult,
        subtotalCents: subtotal,
        savingsCents: saving,
        priceCents: Math.max(0, subtotal - saving)
      };
    }

    function currentBundlePricing() {
      /* Preis folgt der ECHTEN Auswahl (genau das landet im Warenkorb) mal
         Anzahl-Stepper, nicht der Stufen-Zielgroesse; leer -> Vorschau der
         aktiven Stufe (mult 1). */
      return pricingForCount(state.selections.length || bundleSize(), state.selections.length ? state.quantity : 1);
    }

    function selectionsBlocked() {
      for (var i = 0; i < state.selections.length; i++) {
        var d = designMap[state.selections[i]];
        if (!d || d.available === false || !d.variantId) return true;
        /* axes: auch die konkrete Paar-Variante (Farbe+Groesse) muss kaufbar sein. */
        if (axes) {
          var sv = slotVariantAt(i);
          if (!sv || sv.available === false) return true;
        }
      }
      return false;
    }

    function money(cents) { return formatMoney(cents, moneyFormat); }
    function moneyText(cents) { return stripHtml(money(cents)); }

    /* Singular/Plural-Label: "1 Design" vs. "N Designs". */
    function designLabelFor(count) {
      return count === 1 ? (i18n.designLabelSingular || i18n.designLabel) : i18n.designLabel;
    }

    function countOf(handle) {
      var n = 0;
      for (var i = 0; i < state.selections.length; i++) {
        if (state.selections[i] === handle) n++;
      }
      return n;
    }

    function metaFor(design) {
      if (!design || !design.tags) return '';
      var parts = [];
      for (var g = 0; g < filters.length; g++) {
        var values = filters[g].values || [];
        for (var vi = 0; vi < values.length; vi++) {
          if (design.tags.indexOf(String(values[vi]).toLowerCase().trim()) !== -1) {
            parts.push(values[vi]);
            break;
          }
        }
      }
      return parts.join(' · ');
    }

    function clampActive() {
      if (state.activeSlot >= state.selections.length || state.activeSlot < 0) {
        state.activeSlot = 0;
        state.activePhoto = 0;
      }
    }

    function activeDesign() {
      clampActive();
      return designMap[state.selections[state.activeSlot]] || null;
    }

    function persist() {
      if (inEditor) return; /* im Editor nichts zementieren (s. inEditor oben) */
      writeStore(storePrefix + 'selections', JSON.stringify(state.selections));
      writeStore(storePrefix + 'variantId', String(state.variantId));
      writeStore(storePrefix + 'bundleSize', String(bundleSize())); /* Legacy-Fallback */
      writeStore(storePrefix + 'activeDesign', String(state.activeSlot));
      writeStore(storePrefix + 'variantChoice', JSON.stringify(state.variantChoice));
      writeStore(storePrefix + 'extraCount', String(state.extraCount));
      if (axes) writeStore(storePrefix + 'slotChoice', JSON.stringify(state.slotChoice));
      if (cfg.addon) writeStore(storePrefix + 'addon', state.addon ? '1' : '0');
    }

    function closestIn(node, sel) {
      while (node && node.nodeType === 1 && node !== root.parentNode) {
        if (node.matches && node.matches(sel)) return node;
        node = node.parentNode;
      }
      return null;
    }

    /* ------------------------------------------------------ initial state */

    (function restoreState() {
      /* Zuerst per exakter Varianten-ID restaurieren (eindeutig). Fällt nur auf
         die Set-Count-Suche zurück, wenn kein variantId gespeichert ist (Alt-
         Stand). variantBySetCount liefert den ERSTEN Treffer und könnte bei zwei
         Varianten mit gleichem set_count die falsche wählen — daher ID zuerst. */
      var storedId = inEditor ? null : readStore(storePrefix + 'variantId');
      var storedSize = inEditor ? NaN : parseInt(readStore(storePrefix + 'bundleSize'), 10);
      var v = (storedId ? variantById(storedId) : null) ||
        (isFinite(storedSize) ? variantBySetCount(storedSize) : null) ||
        variantById(cfg.defaultVariantId) ||
        firstAvailableVariant() ||
        cfg.variants[0];
      state.variantId = v.id;

      /* "6+"-Extra-Menge VOR den Selections wiederherstellen: der Trim
         weiter unten rechnet mit bundleSize() und wuerde sonst gespeicherte
         Slots 7..n wegschneiden. Nur gueltig auf der offenen Stufe. */
      var storedExtra = inEditor ? NaN : parseInt(readStore(storePrefix + 'extraCount'), 10);
      if (isFinite(storedExtra) && storedExtra > 0 && isOpenVariant(v)) {
        state.extraCount = Math.max(0, Math.min(openExtraMax(), storedExtra));
      }

      /* axes: Session-Groesse VOR den Selections (Default-Varianten der
         Paare haengen daran). Ungueltige Token (Owner hat Groessen geaendert)
         fallen still auf "egal". */
      if (axes) {
        var storedSess = inEditor ? null : readStore(storePrefix + 'sessionSize');
        if (storedSess && catalogSizes().indexOf(storedSess) !== -1) state.sessionSize = storedSess;
      }

      var raw = inEditor ? null : readStore(storePrefix + 'selections');
      var firstVisit = raw === null; /* B4: nur echter Erstbesuch, nicht "bewusst geleert" */
      /* axes: welche gespeicherten Indizes ueberlebt haben — haelt slotChoice
         nach dem Verwerfen ausverkaufter Handles korrekt ausgerichtet. */
      var keptIdx = [];
      if (raw) {
        try {
          var parsed = JSON.parse(raw);
          if (Object.prototype.toString.call(parsed) === '[object Array]') {
            for (var i = 0; i < parsed.length; i++) {
              var d = designMap[parsed[i]];
              if (d && d.available !== false) {
                state.selections.push(parsed[i]);
                keptIdx.push(i);
              }
            }
          }
        } catch (err) { state.selections = []; keptIdx = []; }
      }

      /* Gewaehlte Varianten (Groesse/Farbe) je Design wiederherstellen. */
      var rawVC = inEditor ? null : readStore(storePrefix + 'variantChoice');
      if (rawVC) {
        try {
          var parsedVC = JSON.parse(rawVC);
          if (parsedVC && typeof parsedVC === 'object') {
            for (var vck in parsedVC) {
              if (Object.prototype.hasOwnProperty.call(parsedVC, vck) && designMap[vck]) {
                state.variantChoice[vck] = String(parsedVC[vck]);
              }
            }
          }
        } catch (err2) { /* ignorieren, Standard greift */ }
      }

      /* axes: Paar-Varianten (slotChoice) wiederherstellen — ueber keptIdx
         auf die ueberlebenden Selections gemappt, Varianten-IDs gegen das
         jeweilige Design validiert. Migration: fehlt ein Eintrag, greift die
         alte geteilte variantChoice[handle] (Alt-Stand vor dem Umbau). */
      if (axes) {
        var rawSC = inEditor ? null : readStore(storePrefix + 'slotChoice');
        var parsedSC = null;
        if (rawSC) {
          try {
            var scArr = JSON.parse(rawSC);
            if (Object.prototype.toString.call(scArr) === '[object Array]') parsedSC = scArr;
          } catch (err3) { parsedSC = null; }
        }
        state.slotChoice = [];
        for (var si = 0; si < state.selections.length; si++) {
          var sHandle = state.selections[si];
          var sDesign = designMap[sHandle];
          var entry = parsedSC ? parsedSC[keptIdx[si]] : null;
          var vId = entry && entry.v ? String(entry.v) : null;
          if (!vId && state.variantChoice[sHandle]) vId = String(state.variantChoice[sHandle]);
          var vObj = vId ? variantInDesign(sDesign, vId) : null;
          if (!vObj || vObj.available === false) vObj = axDefaultVariant(sHandle);
          state.slotChoice.push(vObj ? { v: String(vObj.id) } : null);
        }
      }

      /* Deep-Link ?design=<handle>: Bundle ueberschreibt Slot 1; Staffel
         HAENGT AN (kein fester Slot — ein geteilter Farb-Link darf die
         gespeicherte Auswahl nicht stillschweigend ersetzen). */
      var urlDesign = null;
      var urlVariant = null;
      try {
        if (typeof window.URLSearchParams === 'function') {
          var _usp = new window.URLSearchParams(window.location.search);
          urlDesign = _usp.get('design');
          urlVariant = _usp.get('variant');
        }
      } catch (err) { urlDesign = null; urlVariant = null; }
      /* Shopifys nativer Varianten-Link (?variant=<id>) waehlt im Varianten-
         Katalog (Staffel, z. B. Federbrosche) die passende Farbe vor: die
         Design-Keys sind dort "v<variantId>". Nur wenn KEIN ?design= gesetzt
         ist (design hat Vorrang) und der Key wirklich existiert — Bundle-/
         axes-Modus (andere Key-Schemata) bleibt dadurch unberuehrt, und ein
         ausverkauftes/verstecktes Design (nicht in designMap) greift nicht. */
      if (!urlDesign && urlVariant) {
        var vKey = 'v' + String(urlVariant).replace(/[^0-9]/g, '');
        if (designMap[vKey]) urlDesign = vKey;
      }
      if (urlDesign && designMap[urlDesign] && designMap[urlDesign].available !== false) {
        if (isStaffel) {
          if (state.selections.indexOf(urlDesign) === -1 && state.selections.length < capacity()) {
            state.selections.push(urlDesign);
          }
          var dlIdx = state.selections.indexOf(urlDesign);
          state.activeSlot = dlIdx >= 0 ? dlIdx : 0;
          state.activePhoto = 0;
        } else {
          if (state.selections.length) {
            state.selections[0] = urlDesign;
            if (axes) {
              var dlv = axDefaultVariant(urlDesign);
              state.slotChoice[0] = dlv ? { v: String(dlv.id) } : null;
            }
          } else {
            state.selections.push(urlDesign);
            slotSyncPush(urlDesign);
          }
          state.activeSlot = 0;
          state.activePhoto = 0;
        }
      } else if (!isStaffel && !axes && firstVisit && !state.selections.length && cfg.productHandle && designMap[cfg.productHandle] &&
        designMap[cfg.productHandle].available !== false) {
        /* Produkt selbst im Katalog + Slot 1 leer → automatisch vorwählen.
           (Staffel startet bewusst leer: Traeger-Produkt ist kein Design.
           axes ebenfalls: kein Paar ohne bewusste Groessen-Wahl vorwaehlen.) */
        state.selections.push(cfg.productHandle);
        /* Landung auf einer einzelnen Farbe zeigt die EINZELSET-Ansicht
           (1er-Stufe aktiv, ein Slot) statt der Default-3er-Stufe mit zwei
           leeren Slots — die Kundin sieht ihr gewaehltes Einzelset und kann
           von dort hochwaehlen (syncTierToCount ankert bei >=3 wieder hoch).
           Nur wenn eine 1er-Variante existiert; sonst Default beibehalten. */
        var soloV = variantBySetCount(1);
        if (soloV) state.variantId = soloV.id;
      }

      if (isStaffel || axes) {
        /* Staffel + axes: kein Einzelset-Zwang, nur weiches Limit. */
        if (state.selections.length > capacity()) {
          state.selections = state.selections.slice(0, capacity());
          if (axes) state.slotChoice = state.slotChoice.slice(0, capacity());
        }
      } else if (isSingleProduct()) {
        /* Echtes Einzelprodukt (keine Stufen) = angezeigtes Produkt, immer. */
        enforceSingle();
      } else if (state.selections.length > capacity()) {
        /* Nur das technische Soft-Limit schneidet — Stufen (3/6) sind
           Mindestmengen, gespeicherte Mehr-Auswahl bleibt vollstaendig. */
        state.selections = state.selections.slice(0, capacity());
      }

      var storedSlot = inEditor ? NaN : parseInt(readStore(storePrefix + 'activeDesign'), 10);
      if (isFinite(storedSlot) && storedSlot >= 0 && storedSlot < state.selections.length && !urlDesign) {
        state.activeSlot = storedSlot;
      }

      /* Add-on-Upsell (optionaler Block): Live den gespeicherten Haken
         wiederherstellen, sonst die Vorauswahl aus den Section-Settings. Im
         Editor immer die Settings (kein localStorage, wie überall sonst). */
      if (cfg.addon) {
        var storedAddon = inEditor ? null : readStore(storePrefix + 'addon');
        if (storedAddon === '1') state.addon = true;
        else if (storedAddon === '0') state.addon = false;
        else state.addon = !!cfg.addon.preselect;
      }

      prevDealRank = dealRankFor(state.selections.length);
      var initTier = stfTierFor(state.selections.length);
      prevStfPct = initTier ? initTier.pct : 0;
    })();

    /* ------------------------------------------------------------- toast */

    function showToast(msg) {
      if (!el.toast) return;
      el.toast.textContent = stripHtml(msg);
      el.toast.classList.add('show');
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { el.toast.classList.remove('show'); }, 2200);
    }

    /* Kundentaugliche Meldung aus einem Cart-API-Fehler ziehen. Shopify
       liefert description als String ODER Objekt; message nur aus plain
       JSON-Fehlerobjekten uebernehmen. Engine-Fehler (SyntaxError von
       Nicht-JSON, TypeError "Failed to fetch" bei Netzabbruch) sind
       Error-Instanzen mit englischem Text, die NIE dem Kunden zeigen,
       stattdessen der deutsche Fallback. */
    function cartErrorMessage(err) {
      var msg = '';
      if (err) {
        if (typeof err.description === 'string') {
          msg = err.description;
        } else if (err.description && typeof err.description === 'object') {
          for (var k in err.description) {
            if (Object.prototype.hasOwnProperty.call(err.description, k)) {
              msg = String(err.description[k]);
              break;
            }
          }
        } else if (typeof err.message === 'string' && !(err instanceof Error)) {
          msg = err.message;
        }
      }
      return msg || 'Leider ist ein Fehler aufgetreten. Bitte versuche es erneut.';
    }

    /* ------------------------------------------------------------ renders */

    function swatchImg(design, cls) {
      if (!design || !design.swatch) return '';
      return '<img class="' + cls + '" src="' + esc(design.swatch) + '" alt="' +
        esc(design.alt || design.title) + '" loading="lazy">';
    }

    function renderTiers() {
      var tiers = root.querySelectorAll('[data-bae-tier]');
      for (var i = 0; i < tiers.length; i++) {
        var active = String(tiers[i].getAttribute('data-variant-id')) === String(state.variantId);
        if (active) tiers[i].classList.add('active');
        else tiers[i].classList.remove('active');
        tiers[i].setAttribute('aria-pressed', active ? 'true' : 'false');
        /* Ausverkaufte Stufe sichtbar markieren (wählbar bleibt sie, damit man
           Preis/Set sieht — der Kaufen-Button ist dann aber gesperrt, s. renderCta). */
        var tv = variantById(tiers[i].getAttribute('data-variant-id'));
        if (tv && tv.available === false) tiers[i].classList.add('sold-out');
        else tiers[i].classList.remove('sold-out');
        if (tv) {
          var tierPricing = pricingForCount(tv.setCount || 1);
          var priceEl = tiers[i].querySelector('.tier-price');
          var perSetEl = tiers[i].querySelector('.tier-perset');
          var perSetMoney = moneyText(Math.round(tierPricing.priceCents / tierPricing.setCount));
          /* Muss den Liquid-Render spiegeln (sonst ueberschreibt das JS die
             Preis-Anzeige): 'perset' = nur Pro-Set-Preis mit "Nur"-Vorsatz. */
          if (cfg && cfg.tierPriceDisplay === 'perset') {
            if (priceEl) priceEl.innerHTML = '<span class="tier-only">Nur</span> ' + perSetMoney;
            if (perSetEl) perSetEl.textContent = 'pro ' + i18n.unitLabel;
          } else {
            if (priceEl) priceEl.innerHTML = priceHtml(tv, 'tier-list', 1, tierPricing);
            if (perSetEl) perSetEl.textContent = perSetMoney + ' pro ' + i18n.unitLabel;
          }
          renderTierBadge(tiers[i], tierPricing);
          renderTierSaving(tiers[i], tv, tierPricing);
        }
      }
    }

    /* R6c: absolute Euro-Ersparnis unter dem Pro-Set-Preis — NUR wenn das Badge
       die Ersparnis nicht ohnehin fuehrt (sonst doppelt beim 3er) und die Stufe
       > 1 Set ist. Macht die grosse Ersparnis der obersten Stufe (z. B. 6er)
       explizit, damit sie nicht nur als Streichpreis versteckt bleibt. */
    function renderTierSaving(tier, tv, pricing) {
      var saveEl = tier.querySelector('.tier-saving');
      var template = tier.getAttribute('data-bae-tier-badge-template') || '';
      var badgeHasSaving = template.indexOf('{saving}') !== -1;
      var show = pricing && pricing.savingsCents > 0 && !badgeHasSaving && tv && (tv.setCount || 1) > 1;
      if (show) {
        if (!saveEl) {
          saveEl = document.createElement('span');
          saveEl.className = 'tier-saving';
          var bottom = tier.querySelector('.tier-bottom');
          if (bottom) bottom.appendChild(saveEl);
          else tier.appendChild(saveEl);
        }
        saveEl.textContent = 'Du sparst ' + moneyText(pricing.savingsCents);
        saveEl.style.display = '';
      } else if (saveEl) {
        saveEl.style.display = 'none';
      }
    }

    function renderTierBadge(tier, pricing) {
      if (!tier || !pricing) return;
      var badge = tier.querySelector('.tier-badge');
      var template = tier.getAttribute('data-bae-tier-badge-template') || '';
      var text = '';
      if (template) {
        text = template;
        if (text.indexOf('{saving}') !== -1) {
          text = pricing.savingsCents > 0 ? text.split('{saving}').join(moneyText(pricing.savingsCents)) : '';
        }
        if (text && text.indexOf('{perset}') !== -1) {
          text = text.split('{perset}').join(moneyText(Math.round(pricing.priceCents / pricing.setCount)));
        }
      }

      if (text) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'tier-badge';
          var top = tier.querySelector('.tier-top');
          if (top) tier.insertBefore(badge, top);
          else tier.insertBefore(badge, tier.firstChild);
        }
        badge.textContent = stripHtml(text);
        badge.style.display = '';
      } else if (badge) {
        badge.style.display = 'none';
      }
    }

    /* Erweitern-Zeile der offenen 6+-Stufe (sitzt unter dem letzten
       Set-Slot): nur sichtbar, wenn die groesste Stufe aktiv ist.
       Wert = GESAMTE Set-Anzahl. */
    function renderExtra() {
      var row = root.querySelector('[data-bae-extra]');
      if (!row) return;
      var v = currentVariant();
      var show = isOpenVariant(v) && openExtraMax() > 0;
      if (show) {
        row.removeAttribute('hidden');
        row.style.display = '';
      } else {
        row.setAttribute('hidden', '');
        row.style.display = 'none';
        return;
      }
      /* Eingeklappt solange nicht erweitert (extraCount 0): nur das Plus +
         Hinweis sichtbar, KEIN Zaehler — die groesste Stufe soll wie jede
         andere Bundle-Karte wirken (Owner-Kontrakt). Erst nach dem ersten
         Plus-Klick zeigt die Zeile Minus + Gesamtzahl. */
      row.classList.toggle('is-collapsed', state.extraCount === 0);
      var val = row.querySelector('[data-bae-extra-val]');
      if (val) val.textContent = bundleSize();
      var dec = row.querySelector('[data-bae-extra-dec]');
      var inc = row.querySelector('[data-bae-extra-inc]');
      var hadFocus = document.activeElement;
      if (dec) dec.disabled = state.extraCount <= 0;
      if (inc) inc.disabled = state.extraCount >= openExtraMax();
      /* Fokus-Rettung (Muster Design-Stepper): wird der gerade fokussierte
         Knopf an der Grenze deaktiviert, wandert der Fokus zum Gegenstueck,
         sonst faellt er auf body und Tastatur-Nutzer verlieren die Stelle. */
      if (inc && dec) {
        if (hadFocus === inc && inc.disabled && !dec.disabled) dec.focus();
        else if (hadFocus === dec && dec.disabled && !inc.disabled) inc.focus();
      }
    }

    function setExtraCount(n) {
      if (!isOpenVariant(currentVariant())) return;
      n = parseInt(n, 10);
      if (!isFinite(n)) n = 0;
      n = Math.max(0, Math.min(openExtraMax(), n));
      if (n === state.extraCount) return;
      state.extraCount = n;
      /* Verkleinern schneidet KEINE Auswahl mehr ab: die Groesse waechst
         elastisch mit der Auswahl (bundleSize), gewaehlte Designs bleiben.
         Konfetti haengt an der Rabatt-Klasse (Stueckzahl), nicht am Ziel. */
      /* Grammatik-sicher fuer Set UND Paar ("7 Set" waere falsch). */
      announce(i18n.unitLabel + '-Anzahl: ' + bundleSize());
      afterSelectionChange();
    }

    /* Staffel: „Dein Set" — 1 Chip je Stueck (gleiche Farbe mehrfach = mehrere
       Chips). Thumbnail zeigt die Farbe in der Galerie (data-bae-slot-view),
       × entfernt das Stueck (data-bae-remove), die Plus-Kachel oeffnet den
       Drawer. Ersetzt die festen Slots des Bundle-Modus. */
    /* Auswahl GRUPPIERT: 1 Chip je Farbe, Menge als Badge (30x dieselbe Farbe
       = 1 Chip mit "30x", nicht 30 Chips). Wird von Set-Bereich, Tray und
       Drawer-Leiste geteilt. */
    function groupedSelections() {
      var groups = [];
      var seen = {};
      for (var i = 0; i < state.selections.length; i++) {
        var h = state.selections[i];
        /* axes: nach Handle+Variante gruppieren — Orbit Navy/39-42 und
           Orbit Beige/35-38 sind ZWEI Zeilen (sichtbares Mix-and-Match). */
        var key = h;
        var sv = null;
        if (axes) {
          sv = slotVariantAt(i);
          key = h + '|' + (sv ? String(sv.id) : '');
        }
        if (!seen[key]) {
          seen[key] = { handle: h, qty: 0, firstIndex: i, variant: sv };
          groups.push(seen[key]);
        }
        seen[key].qty += 1;
      }
      return groups;
    }

    /* axes: letztes Paar der Gruppe (gleicher Handle + gleiche Variante)
       entfernen bzw. das Paar an firstIndex duplizieren (+1 identisch). */
    function groupKeyAt(i) {
      var sv = slotVariantAt(i);
      return state.selections[i] + '|' + (sv ? String(sv.id) : '');
    }
    function removeOneOfGroup(firstIndex) {
      var key = groupKeyAt(firstIndex);
      for (var i = state.selections.length - 1; i >= 0; i--) {
        if (groupKeyAt(i) === key) { removeAt(i); return; }
      }
    }
    function addOneOfGroup(firstIndex) {
      if (firstIndex < 0 || firstIndex >= state.selections.length) return;
      var handle = state.selections[firstIndex];
      var sv = slotVariantAt(firstIndex);
      if (!sv || sv.available === false) { showToast(i18n.soldOut); return; }
      axPendingV = sv;
      addOne(handle);
    }

    /* Merker fuer die Pop-Animation: nur der NEU hinzugekommene Chip animiert
       (Klasse is-new), nicht alle bei jedem innerHTML-Rebuild. -1 = erster
       Render (Boot/Restore animiert nie). */
    var renderedSetLen = -1;
    function renderSetChips() {
      if (!el.set) return;
      var grew = renderedSetLen !== -1 && state.selections.length > renderedSetLen;
      var lastHandle = grew ? state.selections[state.selections.length - 1] : null;
      var activeHandle = state.selections[state.activeSlot] || null;
      var groups = groupedSelections();
      var html = [];
      for (var gi = 0; gi < groups.length; gi++) {
        var grp = groups[gi];
        var d = designMap[grp.handle];
        if (!d) continue;
        var nameEsc = esc(d.shortTitle || d.title);
        var isActive = grp.handle === activeHandle;
        var isNew = grp.handle === lastHandle;
        html.push(
          '<div class="stf-chip' + (isActive ? ' is-active' : '') + (isNew ? ' is-new' : '') + '">' +
          '<span class="stf-chip-thumb" data-bae-slot-view="' + grp.firstIndex + '" role="button" tabindex="0" aria-label="' +
          nameEsc + ' ansehen">' +
          swatchImg(d, 'stf-chip-img') +
          (grp.qty > 1 ? '<span class="stf-chip-qty">' + grp.qty + '×</span>' : '') +
          '</span>' +
          '<button type="button" class="stf-chip-remove" data-bae-remove-one="' + esc(grp.handle) + '" aria-label="' +
          nameEsc + ' ' + esc(i18n.removeLabel.toLowerCase()) + '">' +
          '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
          '</button>' +
          '<span class="stf-chip-name">' + nameEsc + '</span>' +
          '</div>'
        );
      }
      if (state.selections.length < staffelCap) {
        html.push(
          '<button type="button" class="stf-chip stf-chip-add" data-bae-open-drawer aria-label="' + esc(i18n.chooseDesign) + '">' +
          '<span class="stf-chip-thumb"><span class="stf-chip-plus" aria-hidden="true">+</span></span>' +
          /* Leer-Zustand = klarer CTA "Farbe auswaehlen"; sobald schon Farben
             gewaehlt sind, reicht das kurze Wort (Kontext ist dann klar). */
          '<span class="stf-chip-name">' + esc((state.selections.length === 0 ? i18n.emptySlot : i18n.designLabelSingular) || '') + '</span>' +
          '</button>'
        );
      }
      el.set.innerHTML = html.join('');
      renderedSetLen = state.selections.length;
    }

    function renderSlots() {
      if (isStaffel) { renderSetChips(); return; }
      if (!el.slots) return;
      var n = bundleSize();
      var html = [];
      for (var i = 0; i < n; i++) {
        var d = designMap[state.selections[i]];
        if (d) {
          /* Slot-Meta: gewaehlte Variante (Groesse/Farbe) zuerst, dann Tag-Infos.
             axes: die EIGENE Paar-Variante ("Navy · 39-42") statt der geteilten. */
          var meta = metaFor(d);
          var axSv = axes ? slotVariantAt(i) : null;
          var axColor = axSv ? colorOfV(d, axSv) : null;
          var axSize = axSv ? sizeOfV(d, axSv) : null;
          if (axes && axSv) {
            var pairTxt = [axColor, axSize].filter(function (x) { return x != null; }).join(' · ') || axSv.title;
            meta = meta ? pairTxt + ' · ' + meta : pairTxt;
          } else {
            var slotCv = chosenVariant(d);
            if (slotCv) meta = meta ? slotCv.title + ' · ' + meta : slotCv.title;
          }
          /* Thumbnail + Text = eigenes Tap-Ziel: zeigt DIESES Design in der
             Galerie (Ersatz fürs schwebende Tray, das auf Mobile weg ist).
             Ändern/Entfernen bleiben eigene Buttons rechts. */
          var editorOpen = axes && state.slotEdit === i;
          var editorHtml = '';
          if (editorOpen) {
            var ai = axisInfo(d);
            if (ai) {
              var ed = ['<div class="slot-editor" data-bae-slot-editor>'];
              if (ai.colors.length) {
                ed.push('<div class="slot-editor-row"><span class="slot-editor-label">' + esc(i18n.colorWord) + '</span><span class="slot-editor-swatches">');
                for (var ci = 0; ci < ai.colors.length; ci++) {
                  var cName = ai.colors[ci];
                  var cDuo = hexFor(cName);
                  var cOn = cName === axColor;
                  var cOff = !colorAvailInSize(d, cName, axSize);
                  ed.push('<button type="button" class="bae-sw' + (cOn ? ' is-active' : '') + (cOff ? ' is-off' : '') + '" data-bae-slot-color="' + i + '" data-color="' + esc(cName) + '" style="--sw:' + esc(cDuo.hex) + (cDuo.hex2 ? ';--sw2:' + esc(cDuo.hex2) : '') + '" aria-pressed="' + (cOn ? 'true' : 'false') + '" aria-label="' + esc(cName + (cOff ? ', ' + i18n.sizeSoldIn : '')) + '"></button>');
                }
                ed.push('</span></div>');
              }
              if (ai.sizes.length) {
                ed.push('<div class="slot-editor-row"><span class="slot-editor-label">' + esc(i18n.sizeWord) + '</span><span class="slot-editor-sizes">');
                for (var szi = 0; szi < ai.sizes.length; szi++) {
                  var sName = ai.sizes[szi];
                  var sOn = sName === axSize;
                  var sV = axColor != null ? variantForCS(d, axColor, sName) : null;
                  var sOff = !sV || sV.available === false;
                  ed.push('<button type="button" class="bae-size' + (sOn ? ' is-active' : '') + (sOff ? ' is-off' : '') + '" data-bae-slot-size="' + i + '" data-size="' + esc(sName) + '" aria-pressed="' + (sOn ? 'true' : 'false') + '"' + (sOff ? ' aria-disabled="true"' : '') + '>' + esc(sName) + '</button>');
                }
                ed.push('</span></div>');
              }
              ed.push('</div>');
              editorHtml = ed.join('');
            }
          }
          html.push(
            '<div class="slot-row filled' + (editorOpen ? ' is-editing' : '') + '">' +
            '<div class="slot-view" data-bae-slot-view="' + i + '" role="button" tabindex="0" aria-label="' +
            esc(i18n.unitLabel + ' ' + pad2(i + 1) + ': ' + (d.shortTitle || d.title) + ' ansehen') + '">' +
            '<div class="slot-thumb">' + mediaHtml(d, axColor, 'slot-thumb-img', 'bae-tile--thumb', false) + '</div>' +
            '<div class="slot-info">' +
            '<div class="slot-kicker">' + esc(i18n.unitLabel) + ' ' + pad2(i + 1) + '</div>' +
            '<div class="slot-name">' + esc(d.shortTitle || d.title) + '</div>' +
            (meta ? '<div class="slot-meta">' + esc(meta) + '</div>' : '') +
            '</div>' +
            '</div>' +
            '<div class="slot-actions">' +
            (axes && axisInfo(d)
              ? '<button type="button" class="slot-action" data-bae-slot-edit="' + i + '" aria-expanded="' + (editorOpen ? 'true' : 'false') + '">' + esc(i18n.editPair) + '</button>'
              : '<button type="button" class="slot-action change" data-bae-open-drawer>' + esc(i18n.changeLabel) + '</button>') +
            '<button type="button" class="slot-action slot-action--remove" data-bae-remove="' + i + '">' + esc(i18n.removeLabel) + '</button>' +
            '</div>' +
            editorHtml +
            '</div>'
          );
        } else {
          /* Leerer Slot: Thumbnail + Text öffnen den Drawer (wie der Button). */
          html.push(
            '<div class="slot-row">' +
            '<div class="slot-view" data-bae-open-drawer role="button" tabindex="0" aria-label="' +
            esc(i18n.unitLabel + ' ' + pad2(i + 1) + ': ' + i18n.chooseDesign) + '">' +
            '<div class="slot-thumb">' + pad2(i + 1) + '</div>' +
            '<div class="slot-info">' +
            '<div class="slot-kicker">' + esc(i18n.unitLabel) + ' ' + pad2(i + 1) + '</div>' +
            '<div class="slot-name empty">' + esc(i18n.emptySlot) + '</div>' +
            '</div>' +
            '</div>' +
            '<button type="button" class="slot-action" data-bae-open-drawer>' + esc(i18n.chooseLabel) + '</button>' +
            '</div>'
          );
        }
      }
      el.slots.innerHTML = html.join('');
    }

    function renderTray() {
      if (!el.tray) return;
      var n = bundleSize();
      var wrap = closestIn(el.tray, '.bundle-tray') || el.tray;
      /* Per × weggeklickt: versteckt lassen, egal welcher Modus. */
      if (state.trayDismissed) {
        wrap.setAttribute('hidden', '');
        wrap.style.display = 'none';
        return;
      }
      if (isStaffel) {
        /* Staffel: Tray immer sichtbar (laedt zum Fuellen ein), Chips gruppiert
           je Farbe mit Mengen-Badge, Plus-Chip oeffnet den Drawer. */
        wrap.removeAttribute('hidden');
        wrap.style.display = '';
        var sCount = wrap.querySelector('[data-bae-tray-count]');
        if (sCount) sCount.textContent = String(state.selections.length);
        var sGroups = groupedSelections();
        var sActive = state.selections[state.activeSlot] || null;
        var sHtml = [];
        for (var sgi = 0; sgi < sGroups.length; sgi++) {
          var sg = sGroups[sgi];
          var sd = designMap[sg.handle];
          if (!sd) continue;
          sHtml.push(
            '<button type="button" class="bundle-chip' + (sg.handle === sActive ? ' active' : '') + '" data-bae-chip="' + sg.firstIndex + '"' +
            ' aria-pressed="' + (sg.handle === sActive ? 'true' : 'false') + '" title="' + esc(sd.shortTitle || sd.title) + '">' +
            '<span class="bundle-chip-nail">' + swatchImg(sd, 'bundle-chip-img') + '</span>' +
            (sg.qty > 1 ? '<span class="bundle-chip-num">' + sg.qty + '</span>' : '') +
            '</button>'
          );
        }
        if (state.selections.length < staffelCap) {
          sHtml.push(
            '<button type="button" class="bundle-chip empty" data-bae-open-drawer title="' + esc(i18n.chooseDesign) + '">' +
            '<span class="bundle-chip-plus">+</span>' +
            '</button>'
          );
        }
        el.tray.innerHTML = sHtml.join('');
        return;
      }
      if (n > 1) wrap.removeAttribute('hidden');
      wrap.style.display = n > 1 ? '' : 'none';
      var countEl = wrap.querySelector('[data-bae-tray-count]');
      if (countEl) {
        countEl.textContent = (state.selections.length >= n && n > 1)
          ? String(state.selections.length)
          : state.selections.length + '/' + n;
      }
      var html = [];
      for (var i = 0; i < n; i++) {
        var d = designMap[state.selections[i]];
        if (d) {
          var active = i === state.activeSlot;
          var chipColor = null;
          if (axes) {
            var chipV = slotVariantAt(i);
            if (chipV) chipColor = colorOfV(d, chipV);
          }
          html.push(
            '<button type="button" class="bundle-chip' + (active ? ' active' : '') + '" data-bae-chip="' + i + '"' +
            ' aria-pressed="' + (active ? 'true' : 'false') + '" title="' + esc(d.shortTitle || d.title) + '">' +
            '<span class="bundle-chip-nail">' + mediaHtml(d, chipColor, 'bundle-chip-img', 'bae-tile--thumb', false) + '</span>' +
            '<span class="bundle-chip-num">' + (i + 1) + '</span>' +
            '</button>'
          );
        } else {
          html.push(
            '<button type="button" class="bundle-chip empty" data-bae-open-drawer title="' + esc(i18n.chooseDesign) + '">' +
            '<span class="bundle-chip-plus">+</span>' +
            '</button>'
          );
        }
      }
      el.tray.innerHTML = html.join('');
    }

    function activePhotos(design) {
      if (!design) return [];
      if (design.photos && design.photos.length) return design.photos;
      return design.swatch ? [design.swatch] : [];
    }

    /* Auf Mobile (einspaltig) liegt die Galerie oben, die Slots darunter — beim
       Antippen eines Slots sanft zur Galerie hochscrollen, damit man das gewählte
       Design auch sieht. Desktop: Galerie ist sticky/immer sichtbar. */
    function revealGalleryOnMobile() {
      if (!el.stage) return;
      var mobile = window.matchMedia && window.matchMedia('(max-width: 980px)').matches;
      if (!mobile) return;
      var target = closestIn(el.stage, '.gallery-hero') || el.stage;
      if (target && target.scrollIntoView) {
        try { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        catch (err) { try { target.scrollIntoView(); } catch (err2) { /* ignore */ } }
      }
    }

    /* Nach der Stufen-Wahl sanft zu „Schritt 2" (Design-Slots) scrollen, damit
       klar wird: jetzt Designs auswaehlen. Nur aus dem echten Klick-Handler
       aufgerufen (nicht bei init/restore). scroll-margin-top am Ziel haelt
       Abstand zu den Sticky-Bars. */
    /* Hoehe der klebenden Kopfzeilen: die Elemente ganz oben im Sichtfenster
       abfragen statt Klassennamen zu raten (Header, Promo-Leiste, Vorschaubalken). */
    /* Hoehe der oben klebenden Leisten. Bewusst ueber die Bauhoehe von
       Kopfzeile und Promo-Leiste statt ueber ihre Position: Pipelines Kopfzeile
       versteckt sich beim Runterscrollen und taucht beim Hochscrollen wieder
       auf — ihre Hoehe muss trotzdem reserviert bleiben, sonst rutscht das
       Sprungziel unter die Leiste. */
    function stickyOffset() {
      var off = 0;
      try {
        var head = document.querySelector('header.theme__header') || document.querySelector('header');
        if (head && head.offsetHeight > 0 && head.offsetHeight < 200) off += head.offsetHeight;
        var promo = document.querySelector('.promo-bar');
        if (promo && promo.offsetHeight > 0 && promo.offsetHeight < 120) off += promo.offsetHeight;
      } catch (err) { /* ignore */ }
      if (off <= 0 || off > 260) off = 120;
      return off;
    }

    /* Sprungziel der Farbreihe: der Mengenvorteil (Schritt 1) — von dort liest
       sich die Seite in der gedachten Reihenfolge weiter. Owner-Entscheid. */
    function scrollToTiers() {
      var target = root.querySelector('.tiers-label') ||
                   root.querySelector('[data-bae-stf-tier]') ||
                   root.querySelector('.slots-label--staffel');
      scrollToElement(target);
    }

    function scrollToElement(target) {
      if (!target) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function wantedTop() {
        var pageY = window.pageYOffset || document.documentElement.scrollTop || 0;
        var top = target.getBoundingClientRect().top + pageY - stickyOffset() - 12;
        return top < 0 ? 0 : top;
      }
      var aim = wantedTop();
      try { window.scrollTo({ top: aim, behavior: reduce ? 'auto' : 'smooth' }); }
      catch (err) { window.scrollTo(0, aim); }
      /* Fotos ueber der Zielmarke laden nach und schieben das Layout — deshalb
         zweimal nachjustieren, aber nur wenn nicht selbst weitergescrollt wird. */
      function correct() {
        var pageY = window.pageYOffset || document.documentElement.scrollTop || 0;
        if (Math.abs(pageY - aim) > 240) return;
        var next = wantedTop();
        if (Math.abs(next - pageY) < 8) return;
        aim = next;
        try { window.scrollTo({ top: next, behavior: 'auto' }); }
        catch (err) { window.scrollTo(0, next); }
      }
      setTimeout(correct, 600);
      setTimeout(correct, 1200);
    }

    function scrollToSlots() {
      var target = root.querySelector('.slots-label--staffel') ||
                   root.querySelector('.slots-label') || el.slots;
      if (!target) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      /* Bewusst NICHT scrollIntoView: auf diesen Seiten steht
         `html { overflow-x: clip }`, damit bewegt Chrome die Seite gar nicht. */
      function wantedTop() {
        var pageY = window.pageYOffset || document.documentElement.scrollTop || 0;
        var top = target.getBoundingClientRect().top + pageY - stickyOffset() - 12;
        return top < 0 ? 0 : top;
      }
      var aim = wantedTop();
      try { window.scrollTo({ top: aim, behavior: reduce ? 'auto' : 'smooth' }); }
      catch (err) { window.scrollTo(0, aim); }
      /* Fotos ueber der Zielmarke laden nach und schieben das Layout — sonst
         landet man eine Etage zu hoch (beim Mengenvorteil statt der Auswahl).
         Zweimal nachjustieren, aber nur wenn die Kundin nicht selbst weiterscrollt. */
      function correct() {
        var pageY = window.pageYOffset || document.documentElement.scrollTop || 0;
        if (Math.abs(pageY - aim) > 240) return;
        var next = wantedTop();
        if (Math.abs(next - pageY) < 8) return;
        aim = next;
        try { window.scrollTo({ top: next, behavior: 'auto' }); }
        catch (err) { window.scrollTo(0, next); }
      }
      setTimeout(correct, 600);
      setTimeout(correct, 1200);
    }

    function renderGallery() {
      var d = activeDesign();
      /* Farbreihe ist reine Vorschau (Owner-Entscheid): ohne eigene Auswahl
         bestimmt die zuletzt angetippte Farbe, was in Buehne und Miniaturen
         steht. Gekauft wird ausschliesslich im Auswahl-Block darunter. */
      var previewD = (!d && state.previewHandle) ? designMap[state.previewHandle] : null;
      var gd = d || previewD;
      var photos = activePhotos(gd);
      /* Eigener Bildindex fuer Galerie und Farb-Vorschau: `activePhoto` gehoert
         der Auswahl-Logik und wird von ihr zurueckgesetzt — beim Blaettern ohne
         eigene Auswahl sprang die Buehne dadurch immer auf Foto 1 zurueck. */
      var gIdx = d ? state.activePhoto : (state.galleryPhoto || 0);
      if (photos.length && gIdx >= photos.length) gIdx = 0;
      if (d && state.activePhoto >= photos.length) state.activePhoto = 0;

      /* axes: das aktive Paar (Farbe) bestimmt die Muster-Kachel — die Buehne
         "faerbt sich mit", ganz ohne Foto. */
      var axStageD = axes ? activeDesign() : null;
      var axStageAi = axStageD ? axisInfo(axStageD) : null;
      var axStageColor = null, axStageSize = null;
      if (axStageAi) {
        var axStageV = slotVariantAt(state.activeSlot);
        if (axStageV) { axStageColor = colorOfV(axStageD, axStageV); axStageSize = sizeOfV(axStageD, axStageV); }
      }

      if (el.stage) {
        if (gd && photos.length) {
          el.stage.innerHTML = '<div class="gallery-photo"><img class="gallery-photo-img" src="' +
            esc(photos[gIdx]) + '" alt="' + esc(gd.alt || gd.title) + '"></div>';
          stageDirty = true;
        } else if (axStageAi && d) {
          var stageCap = [axStageColor, axStageSize].filter(function (x) { return x != null; }).join(' · ');
          el.stage.innerHTML = '<div class="gallery-photo bae-tilewrap">' +
            tileHtml(d, axStageColor, 'bae-tile--stage', true) +
            (stageCap ? '<span class="bae-tile-caption">' + esc(stageCap) + '</span>' : '') +
            '</div>';
          stageDirty = true;
        } else if (!gd && hostPhotoAt(gIdx)) {
          /* Keine Farbe gewaehlt: eigene Produktgalerie. Beim allerersten Aufruf
             bleibt das server-gerenderte Foto stehen (Ladezeit), erst ein Klick
             auf eine Miniatur tauscht die Buehne. */
          if (gIdx || stageDirty) {
            el.stage.innerHTML = '<div class="gallery-photo"><img class="gallery-photo-img" src="' +
              esc(hostPhotoAt(gIdx)) + '" alt="' + esc(hostAltText()) + '"></div>';
            stageDirty = true;
          }
        } else if (stageDirty || state.selections.length) {
          el.stage.innerHTML = '<div class="gallery-photo empty"><span class="gallery-photo-label">' +
            esc(d ? (d.shortTitle || d.title) : i18n.chooseDesign) + '</span></div>';
          stageDirty = true;
        }
        /* sonst: Erstbesuch ohne Auswahl → server-gerendertes Foto behalten */
      }

      var thumbs = root.querySelectorAll('[data-bae-thumb]');
      for (var i = 0; i < thumbs.length; i++) {
        var idx = parseInt(thumbs[i].getAttribute('data-bae-thumb'), 10) || 0;
        var host = thumbs[i].getAttribute('data-bae-host');
        var has = gd && idx < photos.length;
        var onHost = !gd && !!host;
        thumbs[i].disabled = !has && !onHost;
        thumbs[i].hidden = false;
        if (has) {
          thumbs[i].innerHTML = '<span class="thumb-photo"><img src="' + esc(photos[idx]) + '" alt="' +
            esc(gd.alt || gd.title) + '" loading="lazy"></span>';
        } else if (onHost) {
          /* Erstbesuch oder Auswahl geleert: eigene Produktgalerie stehen lassen
             bzw. wiederherstellen — nie wieder nackte Ziffern-Kaestchen. */
          if (!thumbs[i].querySelector('img')) {
            thumbs[i].innerHTML = '<span class="thumb-photo"><img src="' + esc(host) + '" alt="' +
              esc(hostAltText()) + '" loading="lazy"></span>';
          }
        } else if (axStageAi && d && idx < axStageAi.colors.length) {
          /* Farb-Vorschau statt nackter Ziffern-Kaestchen (dekorativ). */
          thumbs[i].innerHTML = tileHtml(d, axStageAi.colors[idx], 'bae-tile--thumb', false);
        } else if (host) {
          /* Farbe gewaehlt, aber sie hat weniger Fotos als die Produktgalerie:
             Kachel ausblenden statt eine leere Ziffer zu zeigen. */
          thumbs[i].hidden = true;
        } else {
          thumbs[i].innerHTML = '<span class="gallery-thumb-ph">' + (idx + 1) + '</span>';
        }
        var thumbActive = (has || onHost) && idx === gIdx;
        if (thumbActive) thumbs[i].classList.add('active');
        else thumbs[i].classList.remove('active');
      }

      /* Schiene kann mehr Fotos enthalten als sichtbar sind (Desktop ist ihre
         Hoehe an die Buehne gebunden). Klasse setzt den weichen Auslauf unten,
         damit man sieht, dass es weitergeht. */
      var railEl = root.querySelector('.gallery-thumbs');
      if (railEl) {
        var scrollable = railEl.scrollHeight > railEl.clientHeight + 4 ||
                         railEl.scrollWidth > railEl.clientWidth + 4;
        if (scrollable) railEl.classList.add('is-scrollable');
        else railEl.classList.remove('is-scrollable');
      }

      renderColorRow();
      renderCaption();
      renderTray();
    }

    /* Farbreihe unter der Buehne (Staffel): gewaehlte Farben markieren und die
       Menge als Badge zeigen. Das Hinzufuegen selbst laeuft ueber den globalen
       [data-bae-add]-Handler, hier wird nur der Zustand gespiegelt. */
    /* Alt-Text der eigenen Produktgalerie (steht an den server-gerenderten
       Miniaturen, damit hier kein zweiter Titel gepflegt werden muss). */
    function hostAltText() {
      var t = root.querySelector('[data-bae-thumb][data-bae-host] img');
      return (t && t.getAttribute('alt')) || '';
    }

    /* Foto der eigenen Produktgalerie an Position i (Attribut der Miniatur). */
    function hostPhotoAt(i) {
      var t = root.querySelector('[data-bae-thumb="' + i + '"]');
      return t ? t.getAttribute('data-bae-host') : null;
    }

    /* ---- Wischen auf der Buehne (Owner-Wunsch) --------------------------
       Am Handy erwartet man, dass ein Wisch nach links das naechste Foto
       bringt. Bewusst eigene Handler statt einer Galerie-Bibliothek: die
       Buehne ist nur EIN Bild, das wir ohnehin schon austauschen. */
    function galleryPhotoCount() {
      var d = activeDesign();
      var gd = d || (state.previewHandle ? designMap[state.previewHandle] : null);
      if (gd) return activePhotos(gd).length;
      return root.querySelectorAll('[data-bae-thumb][data-bae-host]').length;
    }

    function stepGalleryPhoto(dir) {
      var n = galleryPhotoCount();
      if (n < 2) return;
      var d = activeDesign();
      var cur = d ? (state.activePhoto || 0) : (state.galleryPhoto || 0);
      var next = cur + dir;
      if (next < 0) next = n - 1;
      if (next >= n) next = 0;
      if (d) state.activePhoto = next;
      else state.galleryPhoto = next;
      renderGallery();
      revealActiveThumb();
    }

    /* Aktive Miniatur in den sichtbaren Bereich holen. Bewusst ueber
       scrollLeft/scrollTop statt scrollIntoView — letzteres bewegt auf diesen
       Seiten nichts (html { overflow-x: clip }). */
    function revealActiveThumb() {
      var rail = root.querySelector('.gallery-thumbs');
      if (!rail) return;
      var active = rail.querySelector('[data-bae-thumb].active');
      if (!active) return;
      if (rail.scrollWidth > rail.clientWidth + 4) {
        var left = active.offsetLeft - (rail.clientWidth - active.offsetWidth) / 2;
        rail.scrollLeft = left < 0 ? 0 : left;
      } else if (rail.scrollHeight > rail.clientHeight + 4) {
        var top = active.offsetTop - (rail.clientHeight - active.offsetHeight) / 2;
        rail.scrollTop = top < 0 ? 0 : top;
      }
    }

    function bindGallerySwipe() {
      var hero = root.querySelector('.gallery-hero') || el.stage;
      if (!hero) return;
      var x0 = 0, y0 = 0, tracking = false;
      hero.addEventListener('touchstart', function (e) {
        if (!e.touches || e.touches.length !== 1) { tracking = false; return; }
        tracking = true;
        x0 = e.touches[0].clientX;
        y0 = e.touches[0].clientY;
      }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var t = e.changedTouches && e.changedTouches[0];
        if (!t) return;
        var dx = t.clientX - x0;
        var dy = t.clientY - y0;
        /* Nur eindeutig waagerechte Gesten, sonst kaempft es mit dem Scrollen. */
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
        stepGalleryPhoto(dx < 0 ? 1 : -1);
      }, { passive: true });
      /* Am Desktop mit Tastatur: Pfeil links/rechts, wenn die Buehne den Fokus hat. */
      hero.setAttribute('tabindex', '0');
      hero.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { stepGalleryPhoto(1); e.preventDefault(); }
        else if (e.key === 'ArrowLeft') { stepGalleryPhoto(-1); e.preventDefault(); }
      });
    }

    /* Eigener Scrollbalken der Farbreihe: Breite und Position des Griffs
       spiegeln den Scrollstand, Ziehen und Klicken scrollen die Reihe. */
    function syncColorBar() {
      var track = root.querySelector('[data-bae-colorrow-track]');
      var thumb = root.querySelector('[data-bae-cr-thumb]');
      var bar = root.querySelector('[data-bae-cr-bar]');
      if (!track || !thumb || !bar) return;
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 1) { bar.hidden = true; return; }
      bar.hidden = false;
      var ratio = track.clientWidth / track.scrollWidth;
      var w = Math.max(36, Math.round(bar.clientWidth * ratio));
      var left = Math.round((bar.clientWidth - w) * (track.scrollLeft / max));
      thumb.style.width = w + 'px';
      thumb.style.left = left + 'px';
    }

    function bindColorBar() {
      var track = root.querySelector('[data-bae-colorrow-track]');
      var bar = root.querySelector('[data-bae-cr-bar]');
      if (!track || !bar) return;
      track.addEventListener('scroll', syncColorBar, { passive: true });
      window.addEventListener('resize', syncColorBar);
      var dragging = false;
      function scrollFromPointer(clientX) {
        var thumb = root.querySelector('[data-bae-cr-thumb]');
        var rect = bar.getBoundingClientRect();
        var w = thumb ? thumb.offsetWidth : 36;
        var span = rect.width - w;
        if (span <= 0) return;
        var x = clientX - rect.left - w / 2;
        if (x < 0) x = 0;
        if (x > span) x = span;
        track.scrollLeft = (x / span) * (track.scrollWidth - track.clientWidth);
      }
      bar.addEventListener('pointerdown', function (e) {
        dragging = true;
        try { bar.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
        scrollFromPointer(e.clientX);
      });
      bar.addEventListener('pointermove', function (e) { if (dragging) scrollFromPointer(e.clientX); });
      bar.addEventListener('pointerup', function () { dragging = false; });
      bar.addEventListener('pointercancel', function () { dragging = false; });
      syncColorBar();
    }

    function renderColorRow() {
      var chips = root.querySelectorAll('[data-bae-cr]');
      if (!chips.length) return;
      var d = activeDesign();
      var shown = d ? d.handle : (state.previewHandle || null);
      for (var i = 0; i < chips.length; i++) {
        var handle = chips[i].getAttribute('data-bae-cr');
        var isShown = handle === shown;
        if (countOf(handle) > 0) chips[i].classList.add('is-picked');
        else chips[i].classList.remove('is-picked');
        if (isShown) chips[i].classList.add('is-active');
        else chips[i].classList.remove('is-active');
        chips[i].setAttribute('aria-current', isShown ? 'true' : 'false');
      }
      syncColorBar();
      var nameEl = root.querySelector('[data-bae-cr-name]');
      if (nameEl) {
        var sd = shown ? designMap[shown] : null;
        nameEl.textContent = sd ? (' · ' + (sd.shortTitle || sd.title)) : '';
      }
    }

    function renderCaption() {
      if (!el.caption) return;
      var n = bundleSize();
      if (state.tab === 'inside') {
        el.caption.textContent = i18n.insideCaption || 'Alles, was im Set enthalten ist';
        return;
      }
      var d = activeDesign();
      el.caption.textContent = d
        ? (d.shortTitle || d.title) + ' · ' + i18n.slotLabel + ' ' + (state.activeSlot + 1) + ' ' + i18n.of + ' ' + n
        : i18n.chooseDesign + ' · 0 ' + i18n.of + ' ' + n;
    }

    function renderProgress() {
      var n = bundleSize();
      var count = state.selections.length;
      /* Stufen sind MINDESTmengen — die Kundin darf jederzeit weitere Sets
         dazulegen. Bei solchen Produkten kein irrefuehrender „x/1"-Nenner mehr
         (las sich wie eine Obergrenze): reine Anzahl + Bordeaux-Hinweis
         „mehr hinzufuegen". Nur ein echtes Einzelprodukt behaelt den Zaehler. */
      var canAddMore = !isStaffel && !isSingleProduct();
      if (el.progress) {
        if (canAddMore) {
          el.progress.textContent = count ? count + ' ' + designLabelFor(count) : '';
        } else {
          /* Ab Erreichen der Stufe zaehlt nur noch die echte Anzahl weiter
             ("7 Designs" statt "7/7") — kein Voll-Signal, Stufen sind Minima. */
          el.progress.textContent = (!isStaffel && count >= n && n > 1)
            ? count + ' ' + designLabelFor(count)
            : count + '/' + n;
        }
      }
      if (el.addMore) {
        var showAdd = canAddMore && count < capacity();
        el.addMore.hidden = !showAdd;
        el.addMore.style.display = showAdd ? '' : 'none';
      }
      /* Staffel: Zaehler im „Dein Set"-Label (" · 3"), kein x/y. */
      if (el.setCount) el.setCount.textContent = state.selections.length ? ' · ' + state.selections.length : '';
      if (el.clear) {
        if (state.selections.length) el.clear.removeAttribute('hidden');
        el.clear.style.display = state.selections.length ? '' : 'none';
      }
    }

    /* ---- Staffel-Renderer: Leiter, Balken, Preis-Übersicht ---- */

    /* Aktive Kachel = beste erreichte Schwelle; unter der kleinsten Schwelle
       ist die neutrale „1"-Kachel aktiv. Beginnt die kleinste Schwelle selbst
       bei 1 (Rabatt ab dem ersten Stueck), leuchtet bei LEEREM Set keine
       Kachel — eine Rabatt-Kachel darf ohne Auswahl nicht aktiv wirken. */
    function renderLadder() {
      var tiles = root.querySelectorAll('[data-bae-stf-tier]');
      if (!tiles.length) return;
      var count = state.selections.length;
      var act = stfTierFor(count);
      var actMin;
      if (act) actMin = act.min;
      else if (count === 0 && stfTiers.length && stfTiers[0].min === 1) actMin = -1;
      else actMin = 1;
      for (var i = 0; i < tiles.length; i++) {
        var min = parseInt(tiles[i].getAttribute('data-min'), 10) || 1;
        var on = min === actMin;
        if (on) tiles[i].classList.add('active');
        else tiles[i].classList.remove('active');
        if (on) tiles[i].setAttribute('aria-current', 'true');
        else tiles[i].removeAttribute('aria-current');
      }
    }

    /* {n}/{unit} als Text ersetzen, {pct}/{save} als fette Auszeichnung.
       {pct} = Rabattsatz (Vorzeichen liefert der Aufrufer), {save} = ersparter
       Euro-Betrag (Owner-Wunsch: konkrete Euro motivieren stärker als Prozent).
       Vorlage wird escaped — Settings sind reiner Text. */
    function fillStf(tpl, n, pctHtml, saveHtml) {
      return esc(String(tpl || ''))
        .split('{n}').join(String(n))
        .split('{unit}').join(esc(i18n.unitLabel))
        .split('{pct}').join('<strong>' + (pctHtml || '') + '</strong>')
        .split('{save}').join('<strong>' + (saveHtml || '') + '</strong>');
    }

    /* Ersparnis in Cent, wenn der Kunde genau n Stück zum Referenz-Stückpreis
       hätte — für die "du sparst X €"-Vorschau der nächsten/ersten Stufe.
       Nutzt dieselbe Preis-Engine (discountForPrices, je-Stück-Rundung wie
       Shopify), also Anzeige == Kasse. */
    function savingsAtCount(n) {
      n = parseInt(n, 10);
      if (!isFinite(n) || n < 1) return 0;
      var u = referenceUnitPriceCents(currentVariant());
      if (!(u > 0)) return 0;
      var arr = [];
      for (var i = 0; i < n; i++) arr.push(u);
      return discountForPrices(arr);
    }

    function renderStfProgress() {
      if (!isStaffel) return;
      if (!el.stfFill && !el.stfNote && !el.stfCount) return;
      var count = state.selections.length;
      var next = stfNextTier(count);
      /* Maximum-Anzeige: TATSAECHLICH angewandter Satz (stfTierFor = hoechster
         Prozentsatz unter den erreichten, wie die Preis-Engine). */
      var maxTier = stfTierFor(count);
      var html = '';
      if (stfTiers.length) {
        if (count === 0) {
          html = fillStf(i18n.stfStart, stfTiers[0].min, stfTiers[0].pct + ' %', moneyText(savingsAtCount(stfTiers[0].min)));
        } else if (next) {
          html = fillStf(i18n.stfNext, next.min - count, '−' + next.pct + ' %', moneyText(savingsAtCount(next.min)));
        } else if (maxTier) {
          html = fillStf(i18n.stfMax, 0, '−' + maxTier.pct + ' %', moneyText(pricingForCount(count).savingsCents));
        }
      }
      /* Hoechste Stufe erreicht: gruener Haken vor der "Geschafft"-Zeile
         (Owner-Wunsch: Erfolgs-Moment statt trockener Rabatt-Angabe). */
      var stfDone = stfTiers.length > 0 && count > 0 && !next;
      if (stfDone && html) {
        html = '<span class="stf-done-ico" aria-hidden="true">' +
          '<svg viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="8.4" stroke="currentColor" stroke-width="1.6"/><path d="M6.4 10.4l2.4 2.4 4.8-5.2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</span>' + html;
      }
      if (el.stfProgress) el.stfProgress.classList.toggle('is-done', stfDone);
      if (el.stfNote) el.stfNote.innerHTML = html;
      if (el.stfCount) el.stfCount.textContent = count + ' ' + i18n.unitLabel;
      if (el.stfFill) {
        /* Monoton: Fortschritt relativ zur HOECHSTEN Schwelle (count/maxMin).
           Die "bis zur naechsten Schwelle"-Rechnung wuerde beim Erreichen einer
           Stufe ZURUECKspringen (2/3 = 67 % -> 3/6 = 50 %) — der Balken darf
           beim Hinzufuegen nie schrumpfen. */
        var ratio = 0;
        if (stfTiers.length && count > 0) {
          var mmax = stfTiers[stfTiers.length - 1].min;
          ratio = mmax > 0 ? count / mmax : 1;
        }
        el.stfFill.style.width = (Math.max(0, Math.min(1, ratio)) * 100) + '%';
      }
    }

    /* Bundle-Modus-Balken (Owner-Wunsch: SF-Look auf UV/Press-On). Misst die
       AKTIVE Set-Anzahl (Stufe/Stepper, bundleSize) gegen die naechste Rabatt-
       Schwelle ueber ALLE Deal-Typen (2+1-frei, Festbetrag, Prozent). Nutzt
       dieselben .stf-progress-Elemente wie der Staffel-Balken (pro Seite
       eindeutig, da if/elsif). Getrennt von renderStfProgress, weil die
       Bundle-Schwellen (freeEveryN) nicht in stfTiers stehen. */
    function renderBundleProgress() {
      if (isStaffel) return;
      if (!el.stfProgress) return;
      var ths = [];
      if (dealFreeEveryN > 1) ths.push(dealFreeEveryN);
      if (dealFixedThreshold > 1 && dealFixedOffCents > 0) ths.push(dealFixedThreshold);
      for (var i = 0; i < stfTiers.length; i++) ths.push(stfTiers[i].min);
      ths = ths.filter(function (v, ix, a) { return v > 1 && a.indexOf(v) === ix; })
               .sort(function (a, b) { return a - b; });
      if (!ths.length) { el.stfProgress.hidden = true; return; }
      el.stfProgress.hidden = false;
      var topMin = ths[ths.length - 1];
      /* Effektive Stueckzahl EXAKT wie die Preis-Engine (currentBundlePricing):
         Basis = echte Auswahl (leer -> aktive Stufe als Vorschau), mal
         Anzahl-Stepper. Sonst weicht der Balken von Preisbox/Kasse ab —
         Live-Test-Fund: 1 Design × Anzahl 4 = 4 Stueck, NICHT bundleSize×4. */
      var base = state.selections.length || bundleSize();
      var mult = state.selections.length ? (state.quantity > 1 ? state.quantity : 1) : 1;
      var count = base * mult;
      var next = 0;
      for (var c = 0; c < ths.length; c++) { if (ths[c] > count) { next = ths[c]; break; } }
      var html;
      if (next) {
        html = fillStf(i18n.bundleNext, next, '', moneyText(savingsAtCount(next)));
      } else {
        var pct = dealPctFor(count);
        html = pct > 0
          ? fillStf(i18n.bundleMax, count, '−' + pct + ' %', '')
          : esc(i18n.bundleMaxPlain || 'Bester Preis erreicht');
      }
      var done = !next;
      if (done && html) {
        html = '<span class="stf-done-ico" aria-hidden="true">' +
          '<svg viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="8.4" stroke="currentColor" stroke-width="1.6"/><path d="M6.4 10.4l2.4 2.4 4.8-5.2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</span>' + html;
      }
      el.stfProgress.classList.toggle('is-done', done);
      if (el.stfNote) el.stfNote.innerHTML = html;
      if (el.stfCount) el.stfCount.textContent = count + ' ' + (count === 1 ? i18n.unitLabel : (i18n.unitLabelPlural || i18n.unitLabel));
      if (el.stfFill) el.stfFill.style.width = (Math.max(0, Math.min(1, topMin > 0 ? count / topMin : 0)) * 100) + '%';
    }

    /* Preis-Übersicht: JS fuellt nur Werte, Beschriftungen sind server-
       gerendert (Liquid). Ab dem ersten Stueck sichtbar. */
    function renderSummary() {
      if (!el.summary) return;
      var count = state.selections.length;
      /* Anzahl-bewusst (Bundle-Stepper): Werte == Kasse. */
      var pricing = currentBundlePricing();
      var sav = pricing.savingsCents;
      /* R6b: Im Bundle-Modus nur zeigen, wenn es etwas zu sparen gibt (sonst
         doppelt zum CTA-Preis). Staffel: ab dem ersten Stueck (wie bisher). */
      if (!count || (!isStaffel && sav <= 0)) { el.summary.hidden = true; return; }
      el.summary.hidden = false;
      var mult = pricing.multiplier > 0 ? pricing.multiplier : 1;
      var effCount = count * mult; /* echte Stueckzahl im Warenkorb */
      /* Stueckpreis-Zeile nur bei einheitlichem Einzelpreis (sonst irrefuehrend). */
      var uni = null;
      var mixed = false;
      for (var i = 0; i < count; i++) {
        var d = designMap[state.selections[i]];
        var p = designPriceCents(d);
        if (!(p > 0)) p = referenceUnitPriceCents(currentVariant());
        if (uni === null) uni = p;
        else if (uni !== p) { mixed = true; break; }
      }
      if (el.sumUnitRow) el.sumUnitRow.hidden = mixed;
      if (el.sumUnit && !mixed) el.sumUnit.textContent = moneyText(uni || 0);
      if (el.sumSub) {
        el.sumSub.textContent = mixed
          ? effCount + ' ' + designLabelFor(effCount)
          : effCount + ' × ' + moneyText(uni || 0);
      }
      if (el.sumSubtotal) el.sumSubtotal.textContent = moneyText(pricing.subtotalCents);
      if (el.sumDiscountRow) {
        if (sav > 0) {
          el.sumDiscountRow.hidden = false;
          /* Prozent wie die Preis-Engine: gepflegte Prozent-Stufe zuerst, sonst
             aus Betrag/Zwischensumme gerundet (deckt 2+1/Festbetrag ab). */
          var pct = dealPctFor(effCount) || Math.round((sav / Math.max(1, pricing.subtotalCents)) * 100);
          if (el.sumDiscountLabel) {
            var baseLabel = el.sumDiscountLabel.getAttribute('data-label') || '';
            el.sumDiscountLabel.textContent = baseLabel + ' (−' + pct + ' %)';
          }
          if (el.sumDiscount) el.sumDiscount.textContent = '−' + moneyText(sav);
        } else {
          el.sumDiscountRow.hidden = true;
        }
      }
      if (el.sumTotal) el.sumTotal.textContent = moneyText(pricing.priceCents);
      if (el.sumSaved) {
        if (sav > 0) {
          el.sumSaved.hidden = false;
          el.sumSaved.textContent = 'Du sparst ' + moneyText(sav);
        } else {
          el.sumSaved.hidden = true;
        }
      }
    }

    /* Add-on-Upsell: spiegelt nur den Auswahl-Zustand ins DOM (Klasse +
       aria-pressed). Preis/Bild/Text sind server-gerendert (statisch); der
       Haken reitet in submitCart als eigene Warenkorb-Zeile mit. */
    function renderAddon() {
      if (!el.addonRow) return;
      el.addonRow.classList.toggle('is-selected', !!state.addon);
      if (el.addonToggle) el.addonToggle.setAttribute('aria-pressed', state.addon ? 'true' : 'false');
    }

    /* extraCents: fixer Aufschlag (Add-on-Upsell, Menge 1) — wandert auf BEIDE
       Seiten (Preis + Streichpreis), damit die Ersparnis unveraendert bleibt. */
    function priceHtml(v, strikeClass, qty, pricing, extraCents) {
      qty = qty && qty > 0 ? qty : 1;
      extraCents = extraCents > 0 ? extraCents : 0;
      var priceCents = pricing ? pricing.priceCents : cents(v && v.priceCents);
      var compareCents = pricing ? pricing.subtotalCents : cents(v && v.compareAtCents);
      var sav = pricing ? pricing.savingsCents : savingsFor(v);
      var out = money(priceCents * qty + extraCents);
      if (sav > 0) {
        if (strikeClass) {
          out += ' <span class="' + strikeClass + '">' + money(compareCents * qty + extraCents) + '</span>';
        } else {
          out += ' <span style="margin-left:8px;opacity:.7;text-decoration:line-through;font-weight:400">' +
            money(compareCents * qty + extraCents) + '</span>';
        }
      }
      return out;
    }

    /* Add-on angehakt + kaufbar → sein Preis (Cent) fliesst live in die
       CTA-/Mobile-Bar-Anzeige ein (gleiche Summe wie spaeter im Warenkorb). */
    function addonExtraCents() {
      if (!state.addon || !cfg.addon || cfg.addon.available === false) return 0;
      var p = parseInt(cfg.addon.priceCents, 10);
      return isFinite(p) && p > 0 ? p : 0;
    }

    /* Anzahl-Zähler: wie viele KOMPLETTE Bundles gekauft werden (Kunde will
       ggf. mehrere Sets derselben Konfiguration). Preis/Ersparnis-Anzeige
       und die Warenkorb-Menge multiplizieren sich damit. */
    function setQty(n) {
      n = parseInt(n, 10);
      if (!isFinite(n)) n = 1;
      state.quantity = Math.max(1, Math.min(99, n));
      renderCta();
      renderMobileBar();
    }
    function renderQty() {
      var valEl = root.querySelector('[data-bae-qty-val]');
      if (valEl) valEl.textContent = state.quantity;
      var dec = root.querySelector('[data-bae-qty-dec]');
      if (dec) dec.disabled = state.quantity <= 1;
      var inc = root.querySelector('[data-bae-qty-inc]');
      if (inc) inc.disabled = state.quantity >= 99;
    }

    /* Platzhalter der Rabatt-Status-Zeile fuellen ({n}/{item} als Text,
       {save}/{pct} fett). Vorlage wird escaped — Settings sind reiner Text. */
    function fillDeal(tpl, n, itemWord, saveHtml, pctText) {
      return esc(String(tpl || ''))
        .split('{n}').join(String(n))
        .split('{item}').join(esc(itemWord || ''))
        .split('{pct}').join('<strong>' + esc(pctText || '') + '</strong>')
        .split('{save}').join('<strong>' + (saveHtml || '') + '</strong>');
    }

    /* Positive Rabatt-Status-Zeile (Bundle): "was ist aktiv" + "was kommt als
       naechstes" — ersetzt jede Voll/Entfernen-Logik. Leer bei 0 Auswahl.
       Rechnet ueber die ECHTE Warenkorb-Stueckzahl (Auswahl x Anzahl-Stepper),
       damit die Rabatt-Klasse zur Kasse passt. pricing.savingsCents ist bereits
       die volle Ersparnis (inkl. Anzahl), daher NICHT erneut multiplizieren. */
    function dealNoteHtml(count, pricing) {
      if (isStaffel || count < 1) return '';
      var mult = pricing && pricing.multiplier > 0 ? pricing.multiplier : 1;
      var eff = count * mult;
      var parts = [];
      if (pricing.savingsCents > 0) {
        var actPct = dealPctFor(eff);
        /* Prozent- und Festbetrag-Stufe sprechen als "Mengenrabatt",
           die Gratis-Stufe (2+1) als "Ein Design ist gratis". */
        var onTpl = (actPct || dealRankFor(eff) === 500) ? i18n.dealPctOn : i18n.dealFreeOn;
        parts.push(fillDeal(onTpl, eff, i18n.designLabelSingular || i18n.designLabel,
          moneyText(pricing.savingsCents), actPct ? '−' + actPct + ' %' : ''));
      }
      /* Teaser "noch n bis zur naechsten Stufe" nur bei Anzahl 1: mit
         Anzahl-Stepper > 1 addiert ein weiteres Design mult Stueck auf einmal,
         eine Stueck-Angabe in Design-Einheiten waere dann irrefuehrend. */
      if (mult === 1) {
        var nextMin = dealNextMin(eff);
        /* Teaser nur, wenn die naechste Stufe wirklich MEHR spart (Schutz vor
           unsauber gepflegten Stufen); Vergleich einheitlich per Referenzpreis. */
        if (nextMin && savingsAtCount(nextMin) > savingsAtCount(eff)) {
          var missing = nextMin - eff;
          parts.push(fillDeal(i18n.dealNext, missing, designLabelFor(missing),
            moneyText(savingsAtCount(nextMin)), ''));
        }
      }
      return parts.join('<span aria-hidden="true"> · </span>');
    }

    /* R6a: KOMPAKTE Ein-Zeilen-Fassung fuer die Handy-Leiste (kein Platz fuer
       zwei Segmente). Aktiver Rabatt zuerst ("Du sparst X"), sonst der Anreiz
       zur naechsten Stufe ("Noch N bis mehr Rabatt"). Reiner Text (kein HTML). */
    function dealNoteCompact(count, pricing) {
      if (isStaffel || count < 1) return '';
      if (pricing && pricing.savingsCents > 0) {
        return 'Du sparst ' + moneyText(pricing.savingsCents);
      }
      var mult = pricing && pricing.multiplier > 0 ? pricing.multiplier : 1;
      var eff = count * mult;
      var nextMin = dealNextMin(eff);
      if (nextMin && savingsAtCount(nextMin) > savingsAtCount(eff)) {
        /* Ersparnis ZUERST: die Handy-Leiste kappt rechts per Ellipsis — der
           motivierende Euro-Betrag muss immer sichtbar bleiben. Vorher stand er
           am Ende ("Noch 2 Designs bis €24,95 Rabatt") und wurde als "…Ra"
           abgeschnitten — genau der Wert, der ueberzeugt, ging verloren. */
        return moneyText(savingsAtCount(nextMin)) + ' sparen ab ' + nextMin + ' ' + designLabelFor(nextMin);
      }
      return '';
    }

    function renderCta() {
      var v = currentVariant();
      var isComplete = complete();
      var remaining = bundleSize() - state.selections.length;
      var pricing = currentBundlePricing();
      /* Gekauft werden echte Design-Varianten. Der CTA ist nur gesperrt, wenn
         eine gewaehlte Design-Line nicht kaufbar ist oder keine Variant-ID hat. */
      var soldOut = isComplete && selectionsBlocked();

      if (el.atc) {
        el.atc.disabled = !isComplete || state.busy || soldOut;
        if (isComplete && !soldOut) el.atc.classList.add('pulse');
        else el.atc.classList.remove('pulse');
        if (soldOut) el.atc.classList.add('sold-out');
        else el.atc.classList.remove('sold-out');
      }
      if (el.atcLabel) {
        el.atcLabel.textContent = (isComplete && soldOut) ? i18n.soldOut
          : (isComplete ? i18n.addToCart
            : (isStaffel ? i18n.stfChoose : fillCount(i18n.chooseN, remaining, designLabelFor(remaining))));
      }
      renderQty();
      /* pricing enthaelt den Anzahl-Stepper bereits (pricingForCount mult) —
         priceHtml daher mit qty 1 aufrufen, sonst doppelte Multiplikation. */
      if (el.atcPrice) el.atcPrice.innerHTML = isComplete ? priceHtml(v, 'cta-list', 1, pricing, addonExtraCents()) : '';
      if (el.atcNote) {
        /* Staffel: Ersparnis steht in der Preis-Übersicht — Note waere doppelt. */
        var noteHtml = dealNoteHtml(state.selections.length, pricing);
        if (noteHtml) {
          el.atcNote.innerHTML = noteHtml;
          el.atcNote.removeAttribute('hidden');
          el.atcNote.style.display = '';
        } else {
          el.atcNote.style.display = 'none';
        }
      }
      /* Sekundär-Button "Designs öffnen →" nur solange unvollständig. */
      var secondary = root.querySelector('.cta-row [data-bae-open-drawer]');
      if (secondary && secondary !== el.atc) {
        secondary.style.display = isComplete ? 'none' : '';
      }
      /* Hidden input der No-JS-Form synchron halten. */
      var form = el.atc ? el.atc.closest('form') : null;
      if (form) {
        var idInput = form.querySelector('input[name="id"], select[name="id"]');
        if (idInput) idInput.value = v.id;
      }
    }

    function renderMobileBar() {
      if (!el.mobileBar) return;
      var v = currentVariant();
      var n = bundleSize();
      var count = state.selections.length;
      var isComplete = complete();
      var pricing = currentBundlePricing();
      var soldOut = isComplete && selectionsBlocked();
      if (el.mbLabel) {
        /* Gefuellte Auswahl: EXAKT die Zeile aus dem Drawer-Fuss (geteilte
           Quelle selectionSummary) — „3 Farben · 4 Stück" statt der alten reinen
           Stueckzahl, die bei Mehrfach-Wahl falsch zaehlte („4 Farben", obwohl
           nur 3 Farben gewaehlt waren). */
        var mbSummary = selectionSummary(plainNum, true);
        if (mbSummary) {
          el.mbLabel.innerHTML = mbSummary;
        } else {
          /* Leer-Zustand: Stufen sind Mindestmengen — kein irrefuehrender
             "x/1"-Nenner (las sich wie eine Obergrenze: "1/1 Design"). Bei
             Stufen-/Staffel-Produkten reine Anzahl; nur ein echtes Einzelprodukt
             mit fester Groesse behaelt den Nenner. Deckt sich mit renderProgress. */
          var mbCanAddMore = !isStaffel && !isSingleProduct();
          el.mbLabel.textContent = (mbCanAddMore || isStaffel || (count >= n && n > 1))
            ? count + ' ' + designLabelFor(count)
            : count + '/' + n + ' ' + designLabelFor(count);
        }
      }
      /* Info-Block ist ein Knopf: er fuehrt zurueck in den Drawer. Der Pfeil
         (Affordanz) erscheint nur, wenn es schon etwas zu bearbeiten gibt. */
      /* classList statt .hidden: das hidden-IDL-Attribut gibt es auf SVG-Elementen
         nicht — el.svg.hidden = true setzt nur eine tote JS-Eigenschaft. */
      if (el.mbChev) el.mbChev.classList.toggle('is-off', count < 1);
      if (el.mbInfo) {
        el.mbInfo.classList.toggle('is-empty', count < 1);
        el.mbInfo.setAttribute('aria-label', count < 1
          ? i18n.chooseDesign
          : ((window.matchMedia && window.matchMedia('(hover: hover)').matches) ? i18n.editHintFine : i18n.editHint));
      }
      /* pricing enthaelt den Anzahl-Stepper bereits — qty 1 (s. renderCta). */
      if (el.mbPrice) el.mbPrice.innerHTML = priceHtml(v, 'mcb-list', 1, pricing, addonExtraCents());
      /* R6a: Ersparnis/Stufen-Anreiz kompakt in der Handy-Leiste. */
      if (el.mbDeal) {
        var mbDealTxt = dealNoteCompact(count, pricing);
        if (mbDealTxt) {
          el.mbDeal.textContent = mbDealTxt;
          el.mbDeal.removeAttribute('hidden');
        } else {
          el.mbDeal.setAttribute('hidden', '');
        }
      }
      if (el.mbCta) {
        el.mbCta.textContent = isComplete ? (soldOut ? i18n.soldOut : i18n.addToCart) : i18n.chooseDesign;
        if (isComplete && !soldOut) el.mbCta.classList.add('pulse');
        else el.mbCta.classList.remove('pulse');
        /* Unvollständig → Button öffnet den Drawer (nicht gesperrt); vollständig +
           ausverkauft → sperren. */
        el.mbCta.disabled = state.busy || (isComplete && soldOut);
      }
    }

    /* ------------------------------------------------------------- drawer */

    function filterMatches(design, groupIndex) {
      var v = state.filters[groupIndex];
      if (!v || v === 'all') return true;
      return !!(design.tags && design.tags.indexOf(v) !== -1);
    }

    /* Suchtext normalisieren: Kleinschreibung, Umlaute/Akzente entschärfen
       ("grun" findet "Grün"), ß → ss. normalize() defensiv (alte Engines). */
    function normText(s) {
      s = String(s === null || s === undefined ? '' : s).toLowerCase();
      s = s.split('ß').join('ss');
      /* Kombinationszeichen U+0300 bis U+036F entfernen (per Unicode-Escape,
         damit die Quelldatei keine rohen Kombinationszeichen enthaelt). */
      if (String.prototype.normalize) {
        try { s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (err) { /* ignore */ }
      }
      return s;
    }

    function searchMatches(design) {
      if (!state.search) return true;
      if (!design._hay) {
        design._hay = normText(
          (design.title || '') + ' ' + (design.shortTitle || '') + ' ' +
          ((design.tags || []).join ? design.tags.join(' ') : '') + ' ' +
          (design.keywords || '')
        );
      }
      return design._hay.indexOf(state.search) !== -1;
    }

    function filteredDesigns() {
      var favs = [];
      var out = [];
      var soldOut = [];
      /* favFirst: nur im Varianten-Katalog mit gepflegten Lieblingsfarben aktiv
         (Liquid setzt cfg.favFirst). Sonst bleibt popular ohne Reihenfolge-Effekt
         — die Tag-Kataloge (Press-On/UV) behalten ihre Reihenfolge. */
      var favFirst = cfg.favFirst === true;
      for (var i = 0; i < designs.length; i++) {
        var unavailable = designs[i].available === false;
        /* Ausverkaufte Designs auf Wunsch ganz ausblenden (nur kaufbare zeigen). */
        if (hideSoldOut && unavailable) continue;
        if (!searchMatches(designs[i])) continue;
        if (filterMatches(designs[i], 0) && filterMatches(designs[i], 1)) {
          /* Reihenfolge: Lieblingsfarben (kaufbar) zuerst, dann restliche
             kaufbare, ausverkaufte ans Ende — jeweils stabile Partition. */
          if (unavailable) soldOut.push(designs[i]);
          else if (favFirst && designs[i].popular) favs.push(designs[i]);
          else out.push(designs[i]);
        }
      }
      return favs.concat(out, soldOut);
    }

    function renderFilterChips() {
      var groups = root.querySelectorAll('[data-bae-filter-group]');
      for (var g = 0; g < groups.length; g++) {
        var groupIndex = parseInt(groups[g].getAttribute('data-bae-filter-group'), 10) || 0;
        var chips = groups[g].querySelectorAll('[data-bae-filter-chip]');
        for (var c = 0; c < chips.length; c++) {
          var raw = (chips[c].getAttribute('data-value') || '').toLowerCase().trim();
          var value = raw === '' ? 'all' : raw;
          var active = state.filters[groupIndex] === value;
          if (active) chips[c].classList.add('active');
          else chips[c].classList.remove('active');
          chips[c].setAttribute('aria-pressed', active ? 'true' : 'false');
          /* Zähler nur für Gruppe 0 (Subfilter-Tabs haben laut Spec keine),
             gerechnet über den gesamten Katalog. */
          if (groupIndex !== 1) {
            var count = 0;
            for (var i = 0; i < designs.length; i++) {
              var d = designs[i];
              /* Zähler nur über kaufbare Designs, wenn Ausverkaufte ausgeblendet sind. */
              if (hideSoldOut && d.available === false) continue;
              /* Aktive Suche zaehlt mit — sonst verspricht der Chip mehr
                 Karten, als das Grid nach dem Filtern zeigt. */
              if (!searchMatches(d)) continue;
              if (value === 'all' || !!(d.tags && d.tags.indexOf(value) !== -1)) count++;
            }
            /* Contract 5: leere, nicht-aktive Chips (außer "all") ausblenden. */
            chips[c].hidden = (value !== 'all' && count === 0 && !active);
            var countEl = chips[c].querySelector('.count');
            if (!countEl) {
              /* Contract 5: echtes Leerzeichen vor dem Count-Pill als eigener Textknoten. */
              chips[c].appendChild(document.createTextNode(' '));
              countEl = document.createElement('span');
              countEl.className = 'count';
              chips[c].appendChild(countEl);
            }
            countEl.textContent = String(count);
          }
        }
      }
      /* Chip-Breiten haben sich evtl. geändert (Zähler, hidden) → Pfeile neu. */
      updateFilterNav();
    }

    /* Scroll-Pfeile für die Filter-Chip-Reihen: die Reihe scrollt ohne
       sichtbaren Balken (bewusst) — ohne Affordance wirkt ein angeschnittener
       Chip („Blau & Gr…“) wie eine Sackgasse. JS legt eine Shell um jede
       Reihe und blendet je Seite einen Pfeil ein, solange dort Chips verdeckt
       sind. Ohne JS bleibt die Reihe normal wischbar (progressive enhancement). */
    var filterShells = [];
    function buildFilterNav(dir, label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'drawer-filters-nav drawer-filters-nav--' + dir;
      b.setAttribute('data-bae-filter-nav', dir);
      b.setAttribute('aria-label', label);
      b.hidden = true;
      b.innerHTML = dir === 'prev'
        ? '<svg viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M7.5 2.5 4 6l3.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        : '<svg viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M4.5 2.5 8 6l-3.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      return b;
    }
    function focusFilterChip(row) {
      var chip = row.querySelector('[data-bae-filter-chip].active') || row.querySelector('[data-bae-filter-chip]');
      if (chip && chip.focus) { try { chip.focus({ preventScroll: true }); } catch (e) { chip.focus(); } }
    }
    function updateFilterNav() {
      for (var i = 0; i < filterShells.length; i++) {
        var s = filterShells[i];
        var max = s.row.scrollWidth - s.row.clientWidth;
        var hasPrev = max > 1 && s.row.scrollLeft > 1;
        var hasNext = max > 1 && s.row.scrollLeft < max - 1;
        /* Fokus-Rettung: verliert ein fokussierter Pfeil gerade seine Sicht-
           barkeit (Scroll-Ende erreicht → wird hidden = display:none), Fokus auf
           den Gegen-Pfeil (falls sichtbar) bzw. den aktiven Filter-Chip legen —
           sonst faellt der Fokus auf <body> (WCAG 2.4.3 Focus Order). */
        if (!hasNext && !s.next.hidden && document.activeElement === s.next) {
          if (hasPrev) s.prev.focus(); else focusFilterChip(s.row);
        }
        if (!hasPrev && !s.prev.hidden && document.activeElement === s.prev) {
          if (hasNext) s.next.focus(); else focusFilterChip(s.row);
        }
        s.prev.hidden = !hasPrev;
        s.next.hidden = !hasNext;
        s.shell.classList.toggle('has-prev', hasPrev);
        s.shell.classList.toggle('has-next', hasNext);
      }
    }
    function initFilterScrollers() {
      var rows = root.querySelectorAll('.drawer-filters');
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        /* Editor-Re-Init auf demselben DOM: nie doppelt einpacken. */
        if (row.parentNode && row.parentNode.classList &&
            row.parentNode.classList.contains('drawer-filters-shell')) continue;
        var shell = document.createElement('div');
        shell.className = 'drawer-filters-shell';
        row.parentNode.insertBefore(shell, row);
        shell.appendChild(row);
        var prev = buildFilterNav('prev', i18n.filterPrev);
        var next = buildFilterNav('next', i18n.filterNext);
        shell.appendChild(prev);
        shell.appendChild(next);
        row.addEventListener('scroll', updateFilterNav);
        filterShells.push({ shell: shell, row: row, prev: prev, next: next });
      }
      if (filterShells.length) {
        window.addEventListener('resize', updateFilterNav);
        updateFilterNav();
      }
    }

    function renderCards() {
      if (!el.cards) return;
      var list = filteredDesigns();
      if (el.drawerMeta) el.drawerMeta.textContent = list.length + ' ' + designLabelFor(list.length);
      if (!list.length) {
        el.cards.innerHTML = '<div class="design-grid-empty" style="padding:60px 20px;text-align:center;color:var(--bae-ink-mute,#8B7A7C);font-size:13px">' +
          esc(i18n.emptyResults) + '</div>';
        return;
      }
      var html = [];
      var n = capacity();
      var atCap = state.selections.length >= n;
      /* Redesign-Regel 1a: BELIEBT hoechstens auf jeder 4. Kachel — die
         Favoriten-Sortierung clustert Favoriten vorn, ohne Deckel wuerde die
         erste Bildschirmseite zur Badge-Wand. Abstand zaehlt ueber ALLE Badges
         (auch Bestseller), damit nie zwei Baender direkt nebeneinander sitzen. */
      var lastFlagAt = -4;
      for (var i = 0; i < list.length; i++) {
        var d = list[i];
        var hEsc = esc(d.handle);
        var nameEsc = esc(d.shortTitle || d.title);
        var qty = countOf(d.handle);
        var unavailable = d.available === false;
        /* Kein weiteres Stueck moeglich, wenn alle Slots belegt sind (nur Mehrfach-Sets).
           Beim Einzelset ersetzt ein Tippen die Auswahl, daher nie gesperrt. */
        var lockAddNew = (n > 1) && atCap;
        var lockInc = (n <= 1) ? true : lockAddNew;
        /* Voll-Zustand: aria-disabled statt disabled, damit der Klick noch den
           "Auswahl voll"-Hinweis ausloesen kann (stummes disabled = keine
           Rueckmeldung). Nur das Einzelset sperrt Plus hart (Ersatz-Semantik). */
        var incLockAttr = (n <= 1) ? ' disabled' : (lockInc ? ' aria-disabled="true"' : '');
        var incLockCls = (n > 1 && lockInc) ? ' is-locked' : '';
        var addLockAttr = lockAddNew ? ' aria-disabled="true"' : '';
        var addLockCls = lockAddNew ? ' is-locked' : '';
        /* Badge-Wort wandert in den zugaenglichen Namen („Schwarz – Bestseller"),
           das sichtbare Band selbst ist aria-hidden (Redesign-Regel 1a/3). */
        var flagWord = d.bestseller ? i18n.bestseller : (d.catEye ? i18n.catEye : (d.popular ? i18n.popular : ''));
        var ariaName = nameEsc + (flagWord ? ' – ' + esc(flagWord) : '');
        var addAria = ariaName + ' ' + i18n.addLabel.toLowerCase();
        /* Nur das zuletzt angefasste Design animiert (Zahl + Morph). */
        var animCls = (animHandle === d.handle) ? ' bae-anim-in' : '';
        var ctl;
        if (unavailable) {
          ctl = '';
        } else if (qty > 0) {
          /* Menge >= 1: Stepper in der NAMENSZEILE (− Zahl +), 2px-Radius,
             schrumpft nie (flex:none) — lange Namen enden mit Ellipsis. */
          ctl =
            '<div class="design-stepper' + animCls + '" role="group" aria-label="' + esc(i18n.qtyAria) + ' ' + nameEsc + '">' +
              '<button type="button" class="design-step design-step--dec" data-bae-dec="' + hEsc + '" aria-label="' + esc(i18n.decLabel) + ', ' + nameEsc + '">' +
                '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3.5 8h9" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>' +
              '</button>' +
              '<span class="design-step-count"><span class="bae-num' + animCls + '">' + qty + '</span></span>' +
              '<button type="button" class="design-step design-step--inc' + incLockCls + '" data-bae-inc="' + hEsc + '"' + incLockAttr + ' aria-label="' + esc(i18n.incLabel) + ', ' + nameEsc + '">' +
                '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M8 3.5v9M3.5 8h9" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>' +
              '</button>' +
            '</div>';
        } else {
          /* Menge 0: quadratisches "+" rechts neben dem Namen. Klick -> Stepper.
             Auch die ganze Karte ist Tap-Ziel (s. Klick-Delegation). */
          ctl =
            '<button type="button" class="design-add' + addLockCls + animCls + '" data-bae-add="' + hEsc + '"' + addLockAttr + ' aria-label="' + addAria + '">' +
              '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M8 3.5v9M3.5 8h9" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>' +
            '</button>';
        }
        /* Varianten-Picker: axes = Farb-SWATCHES direkt an der Karte (jeder
           Tap legt EIN Paar in genau dieser Farbe, Groesse aus dem Vorfilter).
           Sonst (Alt-Verhalten anderer Seiten): ein Select je Design, gilt
           fuer alle Slots gemeinsam. */
        var pickerHtml = '';
        var dvs = designVariants(d);
        var cardAxis = axes ? axisInfo(d) : null;
        if (cardAxis && !unavailable && cardAxis.colors.length) {
          var swRow = ['<div class="design-colors" role="group" aria-label="' + esc(i18n.colorWord) + ', ' + nameEsc + '">'];
          for (var ci2 = 0; ci2 < cardAxis.colors.length; ci2++) {
            var swName = cardAxis.colors[ci2];
            var swDuo = hexFor(swName);
            var swOff = !colorAvailInSize(d, swName, state.sessionSize);
            /* aktiv = mindestens ein Paar dieses Designs traegt die Farbe */
            var swOn = false;
            for (var pi2 = 0; pi2 < state.selections.length; pi2++) {
              if (state.selections[pi2] !== d.handle) continue;
              var pv2 = slotVariantAt(pi2);
              if (pv2 && colorOfV(d, pv2) === swName) { swOn = true; break; }
            }
            swRow.push('<button type="button" class="bae-sw' + (swOn ? ' is-active' : '') + (swOff ? ' is-off' : '') + '" data-bae-swadd="' + hEsc + '" data-color="' + esc(swName) + '" style="--sw:' + esc(swDuo.hex) + (swDuo.hex2 ? ';--sw2:' + esc(swDuo.hex2) : '') + '" aria-label="' + esc(swName + (swOff ? ', ' + i18n.sizeSoldIn : ', ' + i18n.addLabel.toLowerCase())) + '" title="' + esc(swName) + '"></button>');
          }
          swRow.push('</div>');
          pickerHtml = swRow.join('');
        } else if (qty > 0 && !unavailable && dvs && !cardAxis) {
          var cvSel = chosenVariant(d);
          pickerHtml = '<select class="design-variant" data-bae-variant="' + hEsc + '" aria-label="' + esc(i18n.variantAria) + ', ' + nameEsc + '">';
          for (var dvi = 0; dvi < dvs.length; dvi++) {
            pickerHtml +=
              '<option value="' + esc(String(dvs[dvi].id)) + '"' +
              (cvSel && String(cvSel.id) === String(dvs[dvi].id) ? ' selected' : '') +
              (dvs[dvi].available ? '' : ' disabled') + '>' +
              esc(dvs[dvi].title) + (dvs[dvi].available ? '' : ' · ' + esc(i18n.soldOut)) +
              '</option>';
          }
          pickerHtml += '</select>';
        }
        /* Badge oben links AUF dem Bild (Freisteller-Weiss), max. eines je Kachel:
           BESTSELLER (burgund, genau eines im Katalog) schlaegt BELIEBT (frosted).
           BELIEBT zusaetzlich nur, wenn die letzten 3 Kacheln badge-frei waren. */
        var flagHtml = '';
        if (!unavailable) {
          if (d.bestseller) {
            flagHtml = '<span class="design-flag design-flag--best" aria-hidden="true">' + esc(i18n.bestseller) + '</span>';
            lastFlagAt = i;
          } else if (d.catEye) {
            /* Cat Eye immer badgen (Owner-Wunsch: hervorheben), unabhaengig vom Abstand. */
            flagHtml = '<span class="design-flag design-flag--cat" aria-hidden="true">' + esc(i18n.catEye) + '</span>';
            lastFlagAt = i;
          } else if (d.popular && (i - lastFlagAt) >= 4) {
            flagHtml = '<span class="design-flag design-flag--pop" aria-hidden="true">' + esc(i18n.popular) + '</span>';
            lastFlagAt = i;
          }
        }
        if (unavailable) flagHtml = '<span class="design-flag design-flag--soldout" aria-hidden="true">' + esc(i18n.soldOut) + '</span>';
        /* axes: in der gemerkten Groesse komplett vergriffene Designs ruhig
           abdunkeln (nie entfernen — Karte bleibt sicht- und fokussierbar).
           Kachel-Farbe = Farbe des letzten Paars dieses Designs ("faerbt
           sich mit"), sonst die erste Katalog-Farbe. */
        var dimmed = cardAxis && state.sessionSize && !designHasSize(d, state.sessionSize);
        var cardColor = null;
        if (cardAxis && qty > 0) {
          for (var cpi = state.selections.length - 1; cpi >= 0; cpi--) {
            if (state.selections[cpi] === d.handle) {
              var cpv = slotVariantAt(cpi);
              if (cpv) cardColor = colorOfV(d, cpv);
              break;
            }
          }
        }
        html.push(
          '<div class="design-card' + (qty > 0 ? ' selected' : '') + (unavailable ? ' sold-out' : '') + (pickerHtml ? ' has-variants' : '') + (dimmed ? ' is-dimmed' : '') + '" data-bae-handle="' + hEsc + '">' +
          '<span class="design-swatch">' +
          mediaHtml(d, cardColor, 'design-swatch-img', 'bae-tile--card', false) +
          '</span>' +
          /* Badge (oben links) + Zähler/„+" (oben rechts) liegen AUF dem Bild in
             DERSELBEN Reihe (Karten-Kinder, absolut positioniert; gleiche Höhe).
             Der Name steht darunter — klein, Caps, Mono, dicht am Bild. */
          flagHtml +
          ctl +
          '<span class="design-meta">' +
          '<span class="design-name" title="' + esc(d.title) + '">' + nameEsc + '</span>' +
          '</span>' +
          (unavailable ? '<span class="design-tags">' + esc(i18n.soldOut) + '</span>' : '') +
          pickerHtml +
          '</div>'
        );
      }
      el.cards.innerHTML = html.join('');
      /* Tastaturfokus nach dem Neu-Rendern zurueck auf DENSELBEN Bedienknopf.
         _focusCtl merkt sich, was gedrueckt wurde: nach Minus muss der Fokus
         wieder auf Minus (sonst Ping-Pong: Enter auf Minus -> Fokus auf Plus
         -> naechstes Enter erhoeht wieder, 0 ist nie erreichbar). */
      if (state._focusHandle) {
        var fh = state._focusHandle;
        var fc = state._focusCtl;
        state._focusHandle = null;
        state._focusCtl = null;
        var selInc = '.design-step--inc[data-bae-inc="' + fh + '"]:not([disabled]):not(.is-locked)';
        var selDec = '.design-step--dec[data-bae-dec="' + fh + '"]';
        var selAdd = '.design-add[data-bae-add="' + fh + '"]:not([disabled]):not(.is-locked)';
        var selVar = '.design-variant[data-bae-variant="' + fh + '"]';
        var order = (fc === 'variant') ? [selVar, selInc, selDec, selAdd]
          : (fc === 'dec') ? [selDec, selAdd, selInc, selVar]
          : [selInc, selDec, selAdd, selVar];
        var fbtn = null;
        for (var foi = 0; foi < order.length && !fbtn; foi++) fbtn = el.cards.querySelector(order[foi]);
        if (fbtn && typeof fbtn.focus === 'function') {
          try { fbtn.focus({ preventScroll: true }); } catch (fe) { fbtn.focus(); }
        }
      }
      /* Animations-Marker verbraucht: naechster Rebuild (Filter, Suche) animiert nichts. */
      animHandle = null;
    }

    /* Chevron im Footer: zeigt „hier gibt es ein Tray zu oeffnen". */
    var FOOT_CHEVRON = '<svg class="drawer-foot-chev" viewBox="0 0 10 6" aria-hidden="true" focusable="false"><polyline points="1,5 5,1 9,5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    /* Zahl fuer den Footer: nur bei GEAENDERTEM Wert einblenden-animieren. */
    function footNum(n, prev) {
      return '<span class="bae-num' + (prev !== -1 && prev !== n ? ' bae-anim-in' : '') + '">' + n + '</span>';
    }

    /* EINE Quelle fuer die Auswahl-Zeile („3 Farben · 4 Stück"): Drawer-Fuss und
       Handy-Warenkorb-Leiste zeigen exakt denselben Satz. numFn kapselt allein,
       WIE eine Zahl ausgegeben wird — der Fuss animiert die Ziffer, die Leiste
       schreibt sie schlicht. Leere Auswahl liefert '' zurueck; beide Orte haben
       dafuer ihren eigenen Leer-Text. */
    function selectionSummary(numFn, compact) {
      var n = bundleSize();
      var pieces = state.selections.length;
      var colors = groupedSelections().length;
      if (pieces < 1) return '';
      /* compact (Handy-Leiste): ohne das schliessende „gewählt". Die Zeile steht
         dort als kleine Kopfzeile ueber dem Preis — mit dem Wort liefe sie auf
         schmalen Geraeten ins „…" („3 Designs · 4 Sets gewä|"). */
      var tail = compact ? '' : ' ' + esc(i18n.chosenWord);
      if (isStaffel) {
        /* „1 Farbe gewählt" bzw. „3 Farben · 4 Stück" (Farben/Stueck getrennt). */
        return (colors === 1 && pieces === 1)
          ? numFn(1, 'colors') + ' ' + esc(i18n.designLabelSingular) + tail
          : numFn(colors, 'colors') + ' ' + esc(designLabelFor(colors)) + ' · ' + numFn(pieces, 'pieces') + ' ' + esc(i18n.unitLabel);
      }
      if (axes) {
        /* Merino (axes): Paar-Semantik + eigene Einheit — bewusst UNVERAENDERT,
           damit der SF-Umbau nicht auf Merino leckt. */
        return (pieces >= n && n > 1)
          ? numFn(pieces, 'pieces') + ' ' + esc(designLabelFor(pieces)) + tail
          : numFn(pieces, 'pieces') + ' ' + esc(i18n.of) + ' ' + n + tail;
      }
      if (colors === pieces) {
        /* Alle Designs verschieden (Normalfall Press-On/UV): eine klare Zahl
           „3 Designs gewählt" — nicht „3 Designs · 3 Sets". */
        return numFn(pieces, 'pieces') + ' ' + esc(pieces === 1 ? i18n.designLabelSingular : designLabelFor(pieces)) + tail;
      }
      /* Mehrfach-Wahl (dasselbe Design mehrmals): zwei-teilig — „2 Designs · 3 Sets gewählt". */
      return numFn(colors, 'colors') + ' ' + esc(designLabelFor(colors)) + ' · ' +
             numFn(pieces, 'pieces') + ' ' + esc(pieces === 1 ? i18n.unitLabel : (i18n.unitLabelPlural || i18n.unitLabel)) + tail;
    }

    /* Zahl schlicht (Handy-Leiste): kein Einblende-Effekt, nur escapte Ziffer. */
    function plainNum(nv) { return esc(String(nv)); }

    /* Sticky-Footer, EINE Komponente mit drei Zustaenden (leer/einzeln/mehrfach).
       Staffel zaehlt Farben und Stueck getrennt; Bundle behaelt sein Ziel „x von N".
       Der CTA verschwindet nie — leer ist er nur inaktiv (kein Layout-Sprung). */
    function renderDrawerFoot() {
      var n = bundleSize();
      var pieces = state.selections.length;
      var colors = groupedSelections().length;
      var isEmpty = pieces < 1;
      /* Tray lohnt nur, wenn es etwas zu bearbeiten gibt (Einzelset: nichts). */
      var trayable = !isEmpty && (isStaffel || n > 1);
      var hintWord = (window.matchMedia && window.matchMedia('(hover: hover)').matches) ? i18n.editHintFine : i18n.editHint;
      if (el.drawerCount) {
        /* Text kommt aus der GETEILTEN Quelle (selectionSummary) — dieselbe
           Zeile steht in der Handy-Warenkorb-Leiste. Nur die Ziffern-Animation
           ist hier eigen (footNum), darum die numFn. */
        var main = isEmpty ? esc(i18n.emptyTitle) : selectionSummary(function (nv, which) {
          return footNum(nv, which === 'colors' ? prevFootColors : prevFootPieces);
        });
        /* Text in EINEN Block kapseln: text-overflow:ellipsis greift nicht auf
           dem inline-flex-Container (der Text + Chevron nebeneinander haelt).
           Ohne diesen Wrapper schnitt der Zaehler bei langem CTA hart mitten im
           Wort ab ("3 SETS G|") statt sauber mit "…". */
        el.drawerCount.innerHTML = '<span class="drawer-foot-txt">' + main + '</span>' + (trayable ? FOOT_CHEVRON : '');
      }
      if (el.drawerSub) {
        el.drawerSub.textContent = isEmpty ? i18n.emptySub : (trayable ? hintWord : '');
        el.drawerSub.hidden = !isEmpty && !trayable;
      }
      if (el.footInfo) {
        el.footInfo.disabled = !trayable;
        el.footInfo.classList.toggle('is-empty', isEmpty);
      }
      prevFootColors = isEmpty ? -1 : colors;
      prevFootPieces = isEmpty ? -1 : pieces;
      /* CTA(s): Footer + Tray teilen sich Zustand und Text. */
      var ctaText, ctaOff;
      if (isStaffel) {
        ctaOff = pieces < 1;
        ctaText = ctaOff ? i18n.stfChoose : i18n.drawerDone;
      } else {
        var isComplete = complete();
        ctaOff = !isComplete;
        var drawerRemaining = n - pieces;
        ctaText = isComplete ? i18n.drawerDone : fillCount(i18n.chooseN, drawerRemaining, designLabelFor(drawerRemaining));
      }
      var ctas = root.querySelectorAll('[data-bae-drawer-cta]');
      for (var ci = 0; ci < ctas.length; ci++) {
        ctas[ci].disabled = ctaOff;
        ctas[ci].textContent = ctaText;
      }
    }

    /* ---- Auswahl-Tray: zweites Bottom-Sheet ueber dem Drawer („Deine Auswahl").
       Eine Zeile je Farbe/Design: Thumb 44px, voller Name, Stepper. Bewusst
       OHNE Bestseller/Beliebt-Badges (Owner: Kunden in der eigenen Auswahl
       nicht verunsichern). − bei Menge 1 entfernt die Zeile; leeres Tray
       schliesst sich selbst. ---- */
    var trayLastFocus = null;
    var trayHideTimer = null;

    function renderTraySheet() {
      if (!el.trayRows) return;
      var groups = groupedSelections();
      if (state.trayOpen && groups.length < 1) { closeTray(); return; }
      var n = capacity();
      var atCap = state.selections.length >= n;
      var lockInc = (n <= 1) || ((n > 1) && atCap);
      var rows = [];
      for (var gi = 0; gi < groups.length; gi++) {
        var g = groups[gi];
        var d = designMap[g.handle];
        if (!d) continue;
        var hEsc = esc(g.handle);
        var nameEsc = esc(d.title);
        /* axes: Untertitel "Navy · 39-42" je Gruppe (Bug: Tray verbarg
           Farbe/Groesse) + Stepper wirkt auf GENAU diese Variante. */
        var gColor = null, gSub = '';
        if (axes && g.variant) {
          gColor = colorOfV(d, g.variant);
          var gSize = sizeOfV(d, g.variant);
          gSub = [gColor, gSize].filter(function (x) { return x != null; }).join(' · ') || g.variant.title;
        }
        var decAttr = axes ? 'data-bae-gdec="' + g.firstIndex + '"' : 'data-bae-dec="' + hEsc + '"';
        var incAttr = axes ? 'data-bae-ginc="' + g.firstIndex + '"' : 'data-bae-inc="' + hEsc + '"';
        var rowAria = nameEsc + (gSub ? ', ' + esc(gSub) : '');
        rows.push(
          '<div class="tray-row">' +
          '<span class="tray-row-thumb">' + mediaHtml(d, gColor, 'tray-row-img', 'bae-tile--thumb', false) + '</span>' +
          '<span class="tray-row-info">' +
          '<span class="tray-row-name">' + nameEsc + '</span>' +
          (gSub ? '<span class="tray-row-sub">' + esc(gSub) + '</span>' : '') +
          '</span>' +
          '<div class="design-stepper" role="group" aria-label="' + esc(i18n.qtyAria) + ' ' + rowAria + '">' +
            '<button type="button" class="design-step design-step--dec" ' + decAttr + ' aria-label="' + esc(i18n.decLabel) + ', ' + rowAria + '">' +
              '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3.5 8h9" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>' +
            '</button>' +
            '<span class="design-step-count"><span class="bae-num' + (animHandle === g.handle ? ' bae-anim-in' : '') + '">' + g.qty + '</span></span>' +
            '<button type="button" class="design-step design-step--inc' + (lockInc ? ' is-locked' : '') + '" ' + incAttr + (lockInc ? ' aria-disabled="true"' : '') + ' aria-label="' + esc(i18n.incLabel) + ', ' + rowAria + '">' +
              '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M8 3.5v9M3.5 8h9" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>' +
            '</button>' +
          '</div>' +
          '</div>'
        );
      }
      el.trayRows.innerHTML = rows.join('');
    }

    function openTray() {
      if (!el.traySheet || state.selections.length < 1) return;
      state.trayOpen = true;
      if (trayHideTimer) { clearTimeout(trayHideTimer); trayHideTimer = null; }
      renderTraySheet();
      el.traySheet.hidden = false;
      /* Erzwungener Reflow statt rAF: nagelt den Transition-Startpunkt fest,
         auch wenn der Tab gedrosselt ist (rAF feuert dann nicht zuverlaessig). */
      void el.traySheet.offsetHeight;
      el.traySheet.classList.add('open');
      trayLastFocus = document.activeElement;
      var closeBtn = el.traySheet.querySelector('.drawer-tray-close');
      if (closeBtn && closeBtn.focus) {
        try { closeBtn.focus({ preventScroll: true }); } catch (err) { /* ignore */ }
      }
    }

    function closeTray() {
      if (!el.traySheet || !state.trayOpen) return;
      state.trayOpen = false;
      el.traySheet.classList.remove('open');
      /* Nach der Ausblende-Transition wirklich verstecken (display:none). */
      trayHideTimer = setTimeout(function () {
        trayHideTimer = null;
        if (!state.trayOpen) el.traySheet.hidden = true;
      }, 260);
      if (trayLastFocus && trayLastFocus.focus && document.contains(trayLastFocus)) {
        try { trayLastFocus.focus({ preventScroll: true }); } catch (err) { /* ignore */ }
      }
      trayLastFocus = null;
    }

    function renderDrawer() {
      if (!el.drawer) return;
      renderSizebar();
      renderFilterChips();
      renderCards();
      renderDrawerFoot();
      renderTraySheet();
    }

    function onDocKeydown(e) {
      if (!state.drawerOpen || !el.drawer) return;
      if (e.key === 'Escape' || e.key === 'Esc') {
        /* ESC schliesst zuerst das Auswahl-Tray, erst der zweite ESC den Drawer. */
        if (state.trayOpen) { closeTray(); return; }
        closeDrawer();
        return;
      }
      if (e.key !== 'Tab') return;
      var sel = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
      var nodes = el.drawer.querySelectorAll(sel);
      var list = [];
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].offsetWidth || nodes[i].offsetHeight || nodes[i].getClientRects().length) list.push(nodes[i]);
      }
      if (!list.length) { e.preventDefault(); return; }
      var first = list[0];
      var last = list[list.length - 1];
      var activeEl = document.activeElement;
      var insideDrawer = el.drawer.contains(activeEl);
      if (e.shiftKey && (activeEl === first || !insideDrawer)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && (activeEl === last || !insideDrawer)) {
        e.preventDefault();
        first.focus();
      }
    }

    /* Modal-Neutralisierung: solange der Drawer offen ist, alle Geschwister-Knoten
       (Titel/Produktbereich/Mobile-Leiste) für Maus UND Assistive-Tech stilllegen.
       aria-modal allein reicht nicht (iOS-VoiceOver-Rotor/virtueller Cursor läuft
       sonst hinter dem Backdrop in Stufen/ATC). inert deckt moderne Browser ab,
       aria-hidden ist der Fallback. Der Drawer-Portal-Knoten wird nie stillgelegt.
       Im Theme-Editor NICHT anfassen (wie Scroll-Lock — kein Einsperren riskieren). */
    function setBackgroundInert(on) {
      if (inEditor || !el.drawer) return;
      /* Der Drawer-Portal liegt NICHT direkt unter root, sondern zusammen mit
         product-wrap/mobile-cartbar/toast im .section-padding-Wrapper. Über die
         Geschwister DES PORTALS iterieren (nicht root.children), sonst wird nichts
         stillgelegt bzw. der Container mit dem Drawer fälschlich übersprungen. */
      var portal = (el.drawer.closest && el.drawer.closest('.drawer-portal')) || el.drawer;
      var container = portal.parentNode;
      if (!container) return;
      var kids = container.children;
      for (var i = 0; i < kids.length; i++) {
        var k = kids[i];
        if (k === portal || k.contains(el.drawer)) continue; /* Drawer-Portal aktiv lassen */
        if (el.toast && (k === el.toast || k.contains(el.toast))) continue; /* aria-live-Toast hörbar lassen */
        if (on) {
          try { k.setAttribute('inert', ''); } catch (err) { /* ignore */ }
          k.setAttribute('aria-hidden', 'true');
        } else {
          try { k.removeAttribute('inert'); } catch (err) { /* ignore */ }
          k.removeAttribute('aria-hidden');
        }
      }
    }

    function openDrawer() {
      if (!el.drawer || state.drawerOpen) return;
      state.drawerOpen = true;
      state.filters = ['all', 'all']; /* B5: frischer Katalogblick bei jedem Öffnen */
      state.search = '';
      if (el.search) el.search.value = '';
      /* Frischer Blick = Chip-Reihe wieder am Anfang („Alle" sichtbar). */
      for (var fsi = 0; fsi < filterShells.length; fsi++) filterShells[fsi].row.scrollLeft = 0;
      renderDrawer();
      el.drawer.classList.add('open');
      el.drawer.setAttribute('aria-hidden', 'false');
      if (el.backdrop) el.backdrop.classList.add('open');
      if (el.mobileBar) el.mobileBar.classList.add('mcb-hidden'); /* Contract 2 */
      setBackgroundInert(true);
      lastFocus = document.activeElement;
      /* Im Theme-Editor NIE den Body-Scroll sperren. Sonst kann eine Editor-
         Interaktion den Nutzer im offenen Drawer einsperren ("nichts mehr
         klickbar, Editor neu laden"). Der Drawer öffnet/schließt trotzdem normal;
         Editor-Events (closeAllDrawers) räumen ihn zusätzlich weg. */
      if (!inEditor) {
        document.body.classList.add('baesics-drawer-open'); /* Contract 3: CSS-Hook bleibt */
        /* Contract 3: Scroll-Lock an Pipelines Manager delegieren, kein Inline-overflow. */
        var drawerBody = el.drawer.querySelector('.drawer-body');
        document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true, detail: drawerBody }));
      }
      document.addEventListener('keydown', onDocKeydown, true);
      var focusTarget = el.drawer.querySelector('[data-bae-drawer-close]');
      if (focusTarget && focusTarget.focus) {
        try { focusTarget.focus({ preventScroll: true }); } catch (err) {
          try { focusTarget.focus(); } catch (err2) { /* ignore */ }
        }
      }
    }

    function closeDrawer() {
      if (!el.drawer || !state.drawerOpen) return;
      if (state.trayOpen) closeTray();
      state.drawerOpen = false;
      el.drawer.classList.remove('open');
      el.drawer.setAttribute('aria-hidden', 'true');
      if (el.backdrop) el.backdrop.classList.remove('open');
      if (el.mobileBar) el.mobileBar.classList.remove('mcb-hidden'); /* Contract 2 */
      setBackgroundInert(false);
      document.body.classList.remove('baesics-drawer-open');
      /* Contract 3: Unlock an Pipelines Manager delegieren. */
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
      document.removeEventListener('keydown', onDocKeydown, true);
      if (lastFocus && lastFocus.focus) {
        try { lastFocus.focus({ preventScroll: true }); } catch (err) {
          try { lastFocus.focus(); } catch (err2) { /* ignore */ }
        }
      }
      lastFocus = null;
    }

    /* Erzwungenes Schließen (Theme-Editor): auch wenn state.drawerOpen bereits
       false ist (verwaister offener Drawer nach Section-Reload). Räumt DOM +
       Body-Scroll-Lock auf, damit die Bearbeitung nie im offenen Drawer hängt. */
    function forceCloseDrawer() {
      state.drawerOpen = true; /* Guard in closeDrawer überstimmen */
      closeDrawer();
      if (el.drawer) el.drawer.classList.remove('open');
      if (el.backdrop) el.backdrop.classList.remove('open');
    }

    /* ---------------------------------------------------------- mutations */

    function renderAll() {
      clampActive();
      updateSingleMode();
      renderTiers();
      renderExtra();
      renderLadder();
      renderStfProgress();
      renderBundleProgress();
      renderSummary();
      renderSlots();
      renderGallery();
      renderProgress();
      renderCta();
      renderMobileBar();
      renderAddon();
      renderDrawer();
    }

    function checkCompletion() {
      /* Staffel: Konfetti beim Erreichen einer NEUEN Rabatt-Klasse (statt
         "Bundle voll" — ein volles Set gibt es hier nicht). */
      if (isStaffel) {
        var it = stfTierFor(state.selections.length);
        var pctNow = it ? it.pct : 0;
        if (pctNow > prevStfPct && window.BaesicsPromo && typeof window.BaesicsPromo.confetti === 'function') {
          var tgt = el.stfFill || el.atc || root;
          var rr = tgt.getBoundingClientRect();
          try { window.BaesicsPromo.confetti(rr.left + rr.width / 2, rr.top + rr.height / 2); } catch (err) { /* ignore */ }
        }
        prevStfPct = pctNow;
        return;
      }
      /* Bundle: gleiche Idee — Konfetti beim AUFSTIEG in eine neue Rabatt-
         Klasse (3 = Gratis-Design, 6 = Mengenrabatt). Ein "Bundle voll"
         gibt es nicht mehr, die Stufen sind Mindestmengen. */
      var rank = dealRankFor(state.selections.length);
      if (rank > prevDealRank && window.BaesicsPromo && typeof window.BaesicsPromo.confetti === 'function') {
        var target = el.atc || root;
        var r = target.getBoundingClientRect();
        try { window.BaesicsPromo.confetti(r.left + r.width / 2, r.top + r.height / 2); } catch (err) { /* ignore */ }
      }
      prevDealRank = rank;
    }

    /* Stufen-Anker automatisch MITWACHSEN lassen: erreicht die Auswahl die
       Groesse einer hoeheren Stufe (z. B. 6), wird deren Karte aktiv — die
       Seite zeigt immer die beste erreichte Angebotsstufe. Nie automatisch
       verkleinern und nie aufs Einzelset springen; die Auswahl bleibt
       IMMER vollstaendig erhalten (kein Abschneiden beim Stufenwechsel). */
    function syncTierToCount() {
      if (isStaffel) return;
      /* Echtes Einzelprodukt hat keine hoehere Stufe — nichts zu synchen.
         Die 1er-Kachel eines Stufen-Produkts DARF hochwandern (Anker folgt
         der Auswahl), deshalb hier NICHT mehr bei curSc<=1 abbrechen. */
      if (isSingleProduct()) return;
      var curSc = tierSetCount();
      var count = state.selections.length;
      var best = null;
      for (var i = 0; i < cfg.variants.length; i++) {
        var v = cfg.variants[i];
        var sc = v.setCount || 1;
        if (sc > curSc && sc <= count && (!best || sc > (best.setCount || 1))) best = v;
      }
      if (best) {
        state.variantId = best.id;
        if (!isOpenVariant(best)) state.extraCount = 0;
      }
    }

    function afterSelectionChange() {
      clampActive();
      syncTierToCount();
      persist();
      renderAll();
      checkCompletion();
    }

    /* Ein Stueck des Designs hinzufuegen. Einzelset: Tippen waehlt/ersetzt das
       eine Design. Mehrfach-Set: an den naechsten freien Slot anhaengen. */
    function addOne(handle) {
      var d = designMap[handle];
      if (!d || d.available === false) return;
      var n = capacity();
      if (!isStaffel && n <= 1) {
        if (state.selections.length === 1 && state.selections[0] === handle) return;
        state.selections = [handle];
        slotSyncReset([]);
        slotSyncPush(handle);
        state.activeSlot = 0;
        state.activePhoto = 0;
        state._focusHandle = handle;
        state._focusCtl = 'inc';
        animHandle = handle;
        afterSelectionChange();
        announce((d.shortTitle || d.title) + ', ' + i18n.qtyAria + ' 1');
        return;
      }
      /* Kein announce() zusaetzlich zum Toast: der Toast ist selbst eine
         polite Live-Region, doppelt = doppelte Screenreader-Ansage. */
      if (state.selections.length >= n) { axPendingV = null; showToast(i18n.full); return; }
      state.selections.push(handle);
      slotSyncPush(handle);
      state.activeSlot = state.selections.length - 1;
      state.activePhoto = 0;
      state._focusHandle = handle;
      state._focusCtl = 'inc';
      animHandle = handle;
      afterSelectionChange();
      announce((d.shortTitle || d.title) + ', ' + i18n.qtyAria + ' ' + countOf(handle));
    }

    /* Ein Stueck des Designs entfernen (letztes Vorkommen). */
    function removeOne(handle) {
      var idx = -1;
      for (var i = state.selections.length - 1; i >= 0; i--) {
        if (state.selections[i] === handle) { idx = i; break; }
      }
      if (idx < 0) return;
      state.selections.splice(idx, 1);
      slotSyncSplice(idx);
      /* Aktiven Index mitschieben (gleiche Regel wie removeAt). */
      if (idx < state.activeSlot) state.activeSlot -= 1;
      else if (idx === state.activeSlot) state.activePhoto = 0;
      state._focusHandle = handle;
      state._focusCtl = 'dec';
      animHandle = handle;
      afterSelectionChange();
      var d = designMap[handle];
      if (d) announce((d.shortTitle || d.title) + ', ' + i18n.qtyAria + ' ' + countOf(handle));
    }

    function removeAt(index) {
      if (index < 0 || index >= state.selections.length) return;
      var handle = state.selections[index];
      state.selections.splice(index, 1);
      slotSyncSplice(index);
      if (state.slotEdit === index) state.slotEdit = -1;
      else if (state.slotEdit > index) state.slotEdit -= 1;
      /* Aktiven Index mitschieben: Entfernen VOR dem aktiven Eintrag darf die
         Galerie nicht stillschweigend auf eine andere Farbe springen lassen
         (Array rueckt links auf). clampActive faengt den Ueberlauf ab. */
      if (index < state.activeSlot) state.activeSlot -= 1;
      else if (index === state.activeSlot) state.activePhoto = 0;
      afterSelectionChange();
      var d = designMap[handle];
      if (d) announce((d.shortTitle || d.title) + ', ' + i18n.qtyAria + ' ' + countOf(handle));
    }

    function clearAll() {
      state.selections = [];
      slotSyncReset([]);
      state.slotEdit = -1;
      state.activeSlot = 0;
      state.activePhoto = 0;
      afterSelectionChange();
    }

    /* Beim Einzelset (1 Set) IST das eine Design das angezeigte Produkt —
       keine Auswahl, kein Wechsel. Verhindert "Rubin-Seite, aber Babyboomer im Set". */
    function singleHandle() {
      /* Einzelset IST das angezeigte Produkt. Nur wenn dieses im Design-Katalog
         liegt (dann existiert eine Variante zum Routen) UND kaufbar ist, wird es
         vorgewählt. KEIN Fallback auf ein fremdes Design — das würde ein falsches
         oder ausverkauftes Produkt in den Warenkorb legen. Ohne gültiges
         Single-Design bleibt die Auswahl leer und der Kaufen-Button deaktiviert. */
      if (cfg.productHandle && designMap[cfg.productHandle] &&
        designMap[cfg.productHandle].available !== false) {
        return cfg.productHandle;
      }
      return null;
    }

    function enforceSingle() {
      if (isStaffel || axes) return; /* Staffel/axes kennen kein Einzelset-Erzwingen */
      var h = singleHandle();
      state.selections = h ? [h] : [];
      state.activeSlot = 0;
      state.activePhoto = 0;
    }

    function updateSingleMode() {
      if (isStaffel || axes) { root.removeAttribute('data-bae-single'); return; }
      /* Single-Layout (versteckt „mehr wählen") NUR bei echtem Einzelprodukt,
         nicht auf der 1er-Kachel eines Stufen-Produkts. */
      if (isSingleProduct()) root.setAttribute('data-bae-single', '');
      else root.removeAttribute('data-bae-single');
    }

    function setVariant(variantId, evt) {
      var v = variantById(variantId);
      if (!v) return;
      var changed = String(state.variantId) !== String(v.id);
      state.variantId = v.id;
      /* Weg von der offenen Stufe = Extra-Menge verfallen lassen (zurueck
         auf die Stufe = wieder bei der Basis-Anzahl starten). */
      if (!isOpenVariant(v)) state.extraCount = 0;
      if (changed) {
        var sav = pricingForCount(v.setCount || 1).savingsCents;
        if (sav > 0 && window.BaesicsPromo && typeof window.BaesicsPromo.savingsPop === 'function') {
          var x = evt && evt.clientX ? evt.clientX : 0;
          var y = evt && evt.clientY ? evt.clientY : 0;
          if (!x && !y && evt && evt.target && evt.target.getBoundingClientRect) {
            var r = evt.target.getBoundingClientRect();
            x = r.left + r.width / 2;
            y = r.top + r.height / 2;
          }
          try {
            window.BaesicsPromo.savingsPop(x, y, '−' + moneyText(sav) + ' gespart');
          } catch (err) { /* ignore */ }
        }
      }
      /* Nur ein echtes Einzelprodukt erzwingt „genau 1". Die 1er-Kachel eines
         Stufen-Produkts behaelt die schon gewaehlte Auswahl (Stufen sind
         Mindestmengen, bundleSize waechst mit; nichts wird abgeschnitten). */
      if (isSingleProduct()) enforceSingle();
      afterSelectionChange();
    }

    function setTab(name) {
      state.tab = name === 'inside' ? 'inside' : 'gallery';
      var tabs = root.querySelectorAll('[data-bae-tab]');
      for (var i = 0; i < tabs.length; i++) {
        var active = tabs[i].getAttribute('data-bae-tab') === state.tab;
        if (active) tabs[i].classList.add('active');
        else tabs[i].classList.remove('active');
        /* Liquid rendert die Tabs als Toggle-Buttons (role="group" + aria-pressed). */
        tabs[i].setAttribute('aria-pressed', active ? 'true' : 'false');
      }
      var galleryPanel = root.querySelector('[data-bae-pane="gallery"]');
      var insidePanel = root.querySelector('[data-bae-pane="inside"]');
      if (galleryPanel) {
        if (state.tab === 'gallery') galleryPanel.removeAttribute('hidden');
        galleryPanel.style.display = state.tab === 'gallery' ? '' : 'none';
      }
      if (insidePanel) {
        if (state.tab === 'inside') insidePanel.removeAttribute('hidden');
        insidePanel.style.display = state.tab === 'inside' ? '' : 'none';
      }
      renderCaption();
    }

    /* --------------------------------------------------------------- cart */

    /* R1: Nach erfolgreichem Add die native Warenkorb-Bestaetigung des Themes
       zeigen. Setting cfg.afterAdd steuert den Weg (Standard 'drawer'):
       - 'drawer': Pipelines Warenkorb-Drawer oeffnen (Slide-in + „Zur Kasse").
       - 'cartpage': zur Warenkorbseite navigieren.
       - 'toast': nichts oeffnen (der kleine Hinweis bleibt).
       Rueckgabe true = selbst behandelt (Aufrufer zeigt KEINEN Toast).
       Robust: findet das Theme keinen Drawer, faellt es auf den Toast zurueck. */
    function revealCartFeedback() {
      var mode = (cfg.afterAdd || 'drawer');
      if (mode === 'toast') return false;
      if (mode === 'cartpage') {
        try { window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart'; return true; }
        catch (err) { return false; }
      }
      /* mode 'drawer': Pipelines Warenkorb-Drawer per nativem Event oeffnen.
         Kleiner Tick, damit der theme:cart:change-Listener den Drawer-Inhalt
         zuerst aktualisiert (sonst evtl. kurz alter Stand). */
      var cd = document.querySelector('[data-drawer="drawer-cart"]');
      if (!cd) return false;
      setTimeout(function () {
        try { cd.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false })); }
        catch (err) { /* ignore — Toast-Fallback ist bereits vorbei, aber Add war erfolgreich */ }
      }, 60);
      return true;
    }

    function submitCart() {
      if (!complete() || state.busy) return;
      /* Echte Design-Varianten statt Bundle-SKU: Bestand und Order-Lines
         laufen pro gewaehltem Design. */
      var qty = state.quantity > 0 ? state.quantity : 1;
      /* Dasselbe Design kann in mehreren Slots liegen (gewollt, z. B. 3× Rubin).
         Gleiche variantId zu EINER Cart-Zeile mit summierter Menge bündeln:
         sonst entstünden mehrere Zeilen mit identischer Variante (nur die
         verborgene _slot-Property unterschiede sie), was den Warenkorb unnötig
         aufbläht. Slots werden in der verborgenen Property zusammengeführt. */
      var byVariant = {};
      var order = [];
      for (var i = 0; i < state.selections.length; i++) {
        var d = designMap[state.selections[i]];
        var chosenId = d ? designVariantId(d) : null;
        if (!d || d.available === false || !chosenId) {
          showToast(i18n.soldOut);
          return;
        }
        var vid = String(chosenId);
        if (!byVariant[vid]) {
          byVariant[vid] = { id: chosenId, quantity: 0, slots: [] };
          order.push(vid);
        }
        byVariant[vid].quantity += qty;
        byVariant[vid].slots.push(i + 1);
      }
      var items = [];
      for (var oi = 0; oi < order.length; oi++) {
        var entry = byVariant[order[oi]];
        var line = { id: entry.id, quantity: entry.quantity };
        /* Staffel: echte unabhaengige Produkt-Zeilen, keine Bundle-Marker. */
        if (!isStaffel) {
          line.properties = {
            /* ECHTE Stueckzahl der Auswahl (nicht die Stufen-Zielgroesse) —
               Stufen sind Mindestmengen, gekauft wird, was gewaehlt ist. */
            '_baesics_bundle_size': String(state.selections.length),
            '_baesics_bundle_slot': entry.slots.join(', ')
          };
        }
        items.push(line);
      }
      if (!items.length) {
        showToast(i18n.soldOut);
        return;
      }
      /* Optionales Add-on (z. B. Klebesticker): als EIGENE Warenkorb-Zeile mit
         anhaengen, wenn angehakt und kaufbar. Menge fix 1 (einmalig), unabhaengig
         von der Bundle-Menge. */
      if (state.addon && cfg.addon && cfg.addon.variantId && cfg.addon.available !== false) {
        items.push({
          id: cfg.addon.variantId,
          quantity: 1,
          properties: { '_baesics_addon': '1' }
        });
      }
      state.busy = true;
      if (el.atc) {
        el.atc.disabled = true;
        el.atc.classList.add('loading');
      }
      if (el.mbCta) el.mbCta.disabled = true;

      function done() {
        state.busy = false;
        if (el.atc) el.atc.classList.remove('loading');
        renderCta();
        renderMobileBar();
        renderAddon();
      }

      var payload = null;
      try {
        payload = JSON.stringify({ items: items });
      } catch (err) {
        done();
        return;
      }

      /* try/catch um den fetch-Aufruf selbst: wirft window.fetch synchron
         (fehlend / durch CSP- oder Extension-Shim), bliebe sonst state.busy
         für immer true und der Button dauerhaft gesperrt. */
      try {
      window.fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: payload
      })
        .then(function (res) {
          if (!res.ok) {
            /* Fehler-Body defensiv parsen: Nicht-JSON (CDN/WAF) wirft sonst einen
               SyntaxError statt des Shopify-Fehlerobjekts. */
            return res.json().then(function (errJson) { throw errJson; }, function () { throw { description: '' }; });
          }
          return res.json();
        })
        .then(function () {
          /* /cart.js ist nur Anreicherung — der Add war bereits erfolgreich.
             Scheitert dieser zweite Request (Session/CDN/Rate-Limit), NICHT den
             ganzen Add als Fehler behandeln: null durchreichen, damit unten
             trotzdem Erfolg gezeigt, der Drawer geschlossen und theme:cart:change
             gefeuert wird (Pipeline holt den Cart dann selbst). */
          return window.fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (res) { return res.ok ? res.json() : null; })
            .catch(function () { return null; });
        })
        .then(function (cart) {
          /* Contract 3: erst schließen (Bundle-Unlock), dann Cart-Change dispatchen. */
          if (state.drawerOpen) closeDrawer();
          document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true, detail: { cart: cart } }));
          /* R1: nach erfolgreichem Add die Kundin nicht im Nichts stehen lassen —
             den nativen Pipeline-Warenkorb-Drawer oeffnen (Bestaetigung + Weg zur
             Kasse). Faellt auf den Toast zurueck, wenn das Theme keinen Drawer
             hat oder das Setting Toast/Warenkorbseite waehlt. */
          if (!revealCartFeedback()) showToast(i18n.added);
          state.quantity = 1; /* nach dem Hinzufügen zurück auf 1 */
          state.addon = false; /* Add-on nach dem Hinzufügen wieder abwählen */
          persist();
          done();
        })
        .catch(function (err) {
          showToast(cartErrorMessage(err));
          done();
        });
      } catch (err) {
        /* Synchroner Wurf aus window.fetch → busy lösen, Button wieder freigeben. */
        showToast('Leider ist ein Fehler aufgetreten. Bitte versuche es erneut.');
        done();
      }
    }

    /* --------------------------------------------------------- event wire */

    /* ---------------------------------------------------------- info-popover */
    /* Kleine „?"-Sprechblase (was sind Press-Ons?). Klick öffnet; danach schließt
       JEDER Klick außerhalb des Toggles (der Toggle selbst wird von onRootClick
       geregelt) + Escape. Kein Fokus-Trap nötig — nur kurzer Infotext. */
    function onInfoDocClick(e) {
      if (el.infoToggle && el.infoToggle.contains(e.target)) return;
      closeInfo();
    }
    function onInfoKeydown(e) { if (e.key === 'Escape' || e.key === 'Esc') closeInfo(); }
    var infoBindTimer = null;
    function openInfo() {
      if (!el.infoBubble || state.infoOpen) return;
      state.infoOpen = true;
      el.infoBubble.classList.add('open');
      if (el.infoToggle) el.infoToggle.setAttribute('aria-expanded', 'true');
      /* Listener erst nach dem aktuellen Klick binden, sonst schließt der
         Öffnungs-Klick sofort wieder. Timer-ID merken: schließt/zerstört die
         Instanz VOR dem Feuern (z. B. shopify:section:load), muss die verspätete
         Bindung abgebrochen werden, sonst haften die document-Listener an der
         toten Instanz (Leak pro Editor-Reload). */
      if (infoBindTimer) clearTimeout(infoBindTimer);
      infoBindTimer = setTimeout(function () {
        infoBindTimer = null;
        if (!state.infoOpen) return; /* zwischenzeitlich geschlossen */
        document.addEventListener('click', onInfoDocClick);
        document.addEventListener('keydown', onInfoKeydown, true);
      }, 0);
    }
    function closeInfo() {
      if (infoBindTimer) { clearTimeout(infoBindTimer); infoBindTimer = null; }
      if (!state.infoOpen) return;
      state.infoOpen = false;
      if (el.infoBubble) el.infoBubble.classList.remove('open');
      if (el.infoToggle) el.infoToggle.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', onInfoDocClick);
      document.removeEventListener('keydown', onInfoKeydown, true);
    }

    function onRootClick(e) {
      var t;
      t = closestIn(e.target, '[data-bae-info-toggle]');
      if (t) { if (state.infoOpen) closeInfo(); else openInfo(); return; }
      t = closestIn(e.target, '[data-bae-addon-toggle]');
      if (t) {
        state.addon = !state.addon;
        persist();
        renderAddon();
        /* Preis auf CTA + Mobile-Leiste sofort mitziehen (Owner-Kontrakt:
           Anhaken = Button zeigt Gesamtsumme inkl. Add-on, nicht erst im Cart). */
        renderCta();
        renderMobileBar();
        return;
      }
      t = closestIn(e.target, '[data-bae-qty-dec]');
      if (t) { if (!t.disabled) setQty(state.quantity - 1); return; }
      t = closestIn(e.target, '[data-bae-qty-inc]');
      if (t) { if (!t.disabled) setQty(state.quantity + 1); return; }
      t = closestIn(e.target, '[data-bae-extra-dec]');
      if (t) { if (!t.disabled) setExtraCount(state.extraCount - 1); return; }
      t = closestIn(e.target, '[data-bae-extra-inc]');
      if (t) { if (!t.disabled) setExtraCount(state.extraCount + 1); return; }
      t = closestIn(e.target, '[data-bae-stf-tier]');
      if (t) { openDrawer(); return; }
      t = closestIn(e.target, '[data-bae-tier]');
      if (t) { setVariant(t.getAttribute('data-variant-id'), e); scrollToSlots(); return; }
      t = closestIn(e.target, '[data-bae-tab]');
      if (t) { setTab(t.getAttribute('data-bae-tab')); return; }
      t = closestIn(e.target, '[data-bae-cr-choose]');
      if (t) {
        /* Desktop: Auswahl-Fenster oeffnen (Owner-Entscheid) — dort ist es ein
           Seitenpanel neben der Seite. Handy: zum Mengenvorteil scrollen, ein
           Vollbild-Fenster direkt aus der Galerie heraus waere zu abrupt. */
        var crWide = window.matchMedia && window.matchMedia('(min-width: 981px)').matches;
        if (crWide) openDrawer();
        else scrollToTiers();
        return;
      }
      t = closestIn(e.target, '[data-bae-cr]');
      if (t) {
        var crHandle = t.getAttribute('data-bae-cr');
        if (designMap[crHandle]) {
          state.previewHandle = crHandle;
          state.activePhoto = 0;
          state.galleryPhoto = 0;
          renderGallery();
        }
        return;
      }
      t = closestIn(e.target, '[data-bae-thumb]');
      if (t) {
        if (!t.disabled) {
          var thumbIdx = parseInt(t.getAttribute('data-bae-thumb'), 10) || 0;
          if (activeDesign()) state.activePhoto = thumbIdx;
          else state.galleryPhoto = thumbIdx;
          renderGallery();
        }
        return;
      }
      t = closestIn(e.target, '[data-bae-chip]');
      if (t) {
        state.activeSlot = parseInt(t.getAttribute('data-bae-chip'), 10) || 0;
        state.activePhoto = 0;
        persist();
        renderGallery();
        return;
      }
      t = closestIn(e.target, '[data-bae-slot-view]');
      if (t) {
        state.activeSlot = parseInt(t.getAttribute('data-bae-slot-view'), 10) || 0;
        state.activePhoto = 0;
        if (state.tab !== 'gallery') setTab('gallery');
        persist();
        renderGallery();
        revealGalleryOnMobile();
        return;
      }
      t = closestIn(e.target, '[data-bae-tray-close]');
      if (t) { state.trayDismissed = true; renderTray(); return; }
      /* Auswahl-Tray im Drawer (zweites Bottom-Sheet) */
      t = closestIn(e.target, '[data-bae-tray-open]');
      if (t) { if (!t.disabled) openTray(); return; }
      t = closestIn(e.target, '[data-bae-tray-reset]');
      if (t) { clearAll(); closeTray(); return; }
      t = closestIn(e.target, '[data-bae-tray-dismiss]');
      if (t) { closeTray(); return; }
      t = closestIn(e.target, '[data-bae-filter-nav]');
      if (t) {
        var navShell = closestIn(t, '.drawer-filters-shell');
        var navRow = navShell ? navShell.querySelector('.drawer-filters') : null;
        if (navRow) {
          var navDelta = Math.max(120, Math.round(navRow.clientWidth * 0.7));
          if (t.getAttribute('data-bae-filter-nav') === 'prev') navDelta = -navDelta;
          try { navRow.scrollBy({ left: navDelta, behavior: 'smooth' }); }
          catch (err) { navRow.scrollLeft += navDelta; }
        }
        return;
      }
      /* ---- Zwei-Achsen-Modus (axes): Swatch-Tap, Groessen-Vorfilter,
         Slot-Editor, Gruppen-Stepper im Auswahl-Tray. ---- */
      t = closestIn(e.target, '[data-bae-swadd]');
      if (t) { axAddColor(t.getAttribute('data-bae-swadd'), t.getAttribute('data-color')); return; }
      t = closestIn(e.target, '[data-bae-size-pre]');
      if (t) { setSessionSize(t.getAttribute('data-size') || null); return; }
      t = closestIn(e.target, '[data-bae-slot-edit]');
      if (t) {
        var seIdx = parseInt(t.getAttribute('data-bae-slot-edit'), 10);
        state.slotEdit = state.slotEdit === seIdx ? -1 : seIdx;
        renderSlots();
        return;
      }
      t = closestIn(e.target, '[data-bae-slot-color]');
      if (t) { slotSet(parseInt(t.getAttribute('data-bae-slot-color'), 10), { color: t.getAttribute('data-color') }); return; }
      t = closestIn(e.target, '[data-bae-slot-size]');
      if (t) { slotSet(parseInt(t.getAttribute('data-bae-slot-size'), 10), { size: t.getAttribute('data-size') }); return; }
      t = closestIn(e.target, '[data-bae-gdec]');
      if (t) { removeOneOfGroup(parseInt(t.getAttribute('data-bae-gdec'), 10)); return; }
      t = closestIn(e.target, '[data-bae-ginc]');
      if (t) { if (!t.classList.contains('is-locked')) addOneOfGroup(parseInt(t.getAttribute('data-bae-ginc'), 10)); return; }

      t = closestIn(e.target, '[data-bae-remove-one]');
      if (t) { removeOne(t.getAttribute('data-bae-remove-one')); return; }
      t = closestIn(e.target, '[data-bae-remove]');
      if (t) { removeAt(parseInt(t.getAttribute('data-bae-remove'), 10)); return; }
      t = closestIn(e.target, '[data-bae-dec]');
      if (t) { if (!t.disabled) removeOne(t.getAttribute('data-bae-dec')); return; }
      t = closestIn(e.target, '[data-bae-inc]');
      if (t) { if (!t.disabled) addOne(t.getAttribute('data-bae-inc')); return; }
      t = closestIn(e.target, '[data-bae-add]');
      if (t) { if (!t.disabled) addOne(t.getAttribute('data-bae-add')); return; }
      /* Karten-Flaeche als grosses Tap-Ziel: Menge 0 -> ein Stueck hinzufuegen
         (wie das "+"-Badge). Ab Menge 1 steuert der Stepper die Menge.
         Ausverkaufte Karten geben kurzes Feedback statt stummem Nichts. */
      t = closestIn(e.target, '[data-bae-handle]');
      if (t && closestIn(t, '[data-bae-cards]')) {
        if (t.classList.contains('sold-out')) { showToast(i18n.soldOut); return; }
        var cardHandle = t.getAttribute('data-bae-handle');
        if (cardHandle && countOf(cardHandle) === 0) {
          /* axes: Karten-Tap = erstes Paar in der Standard-Farbe (mit
             Groessen-Gate); sonst klassisches addOne. */
          if (axes && axisInfo(designMap[cardHandle])) axAddColor(cardHandle, null);
          else addOne(cardHandle);
        }
        return;
      }
      t = closestIn(e.target, '[data-bae-filter-chip]');
      if (t) {
        var group = closestIn(t, '[data-bae-filter-group]');
        var g = group ? (parseInt(group.getAttribute('data-bae-filter-group'), 10) || 0) : 0;
        var raw = (t.getAttribute('data-value') || '').toLowerCase().trim();
        var chipVal = raw === '' ? 'all' : raw;
        state.filters[g] = chipVal;
        /* Achsen schliessen sich gegenseitig aus (Owner: nicht so stark einschraenken,
           „entweder Filter oben ODER unten"): eine aktive Achse setzt alle anderen auf
           'all' zurueck. So zeigt z.B. Cat Eye IMMER alle Cat-Eye-Designs statt der
           Schnittmenge mit der Farbwelt. */
        if (chipVal !== 'all') {
          for (var ofi = 0; ofi < state.filters.length; ofi++) {
            if (ofi !== g) state.filters[ofi] = 'all';
          }
        }
        renderDrawer();
        scrollChipIntoView(t); /* aktiver Chip bleibt sichtbar (Redesign 4a) */
        return;
      }
      t = closestIn(e.target, '[data-bae-clear]');
      if (t) { clearAll(); return; }
      t = closestIn(e.target, '[data-bae-drawer-close]');
      if (t) { closeDrawer(); return; }
      t = closestIn(e.target, '[data-bae-drawer-cta]');
      if (t) {
        /* R7 (opt-in): bei vollstaendiger Auswahl kann der Drawer-„Fertig"-Knopf
           direkt in den Warenkorb legen — spart die zweite Tipp-Runde. Standard
           aus (nur schliessen), damit der Add-on-Schritt sichtbar bleibt. */
        if (!t.disabled) {
          if (cfg.drawerDoneAdds && !isStaffel && complete() && !state.busy) {
            closeTray();
            submitCart();
          } else {
            closeTray();
            closeDrawer();
          }
        }
        return;
      }
      t = closestIn(e.target, '[data-bae-mb-cta]');
      if (t) {
        if (complete()) submitCart();
        else openDrawer();
        return;
      }
      /* Auswahl-Block der Handy-Leiste (Zeile + Preis) fuehrt zurueck in den
         Drawer — der Weg zurueck war vorher nur ueber den CTA erreichbar, und
         der legt bei vollstaendiger Auswahl in den Warenkorb. */
      t = closestIn(e.target, '[data-bae-mb-info]');
      if (t) { openDrawer(); return; }
      t = closestIn(e.target, '[data-bae-backdrop]');
      if (t) { closeDrawer(); return; }
      t = closestIn(e.target, '[data-bae-open-drawer]');
      if (t) { openDrawer(); return; }
    }

    function onFormSubmit(e) {
      e.preventDefault();
      if (complete()) submitCart();
      else openDrawer();
    }

    root.addEventListener('click', onRootClick);
    bindColorBar();
    bindGallerySwipe();

    /* Varianten-Picker (Groesse/Farbe) an den Drawer-Karten: Aenderung merken,
       Preise/Slots neu rendern, Fokus zurueck auf denselben Picker. */
    function onRootChange(e) {
      var t = closestIn(e.target, '[data-bae-variant]');
      if (!t) return;
      var h = t.getAttribute('data-bae-variant');
      if (!h || !designMap[h]) return;
      state.variantChoice[h] = String(t.value);
      state._focusHandle = h;
      state._focusCtl = 'variant';
      persist();
      renderAll();
      var d = designMap[h];
      var cv = chosenVariant(d);
      if (d && cv) announce((d.shortTitle || d.title) + ', ' + cv.title);
    }
    root.addEventListener('change', onRootChange);

    /* Drawer-Suche: Eingabe leicht entprellt übernehmen und nur die Karten
       neu rendern — das Suchfeld selbst ist server-gerendert und behält
       dadurch Fokus + Cursor. */
    var searchTimer = null;
    function onSearchInput() {
      if (searchTimer) clearTimeout(searchTimer);
      searchTimer = setTimeout(function () {
        searchTimer = null;
        state.search = normText(el.search ? el.search.value : '').replace(/^\s+|\s+$/g, '');
        renderCards();
        renderFilterChips();
      }, 120);
    }
    if (el.search) el.search.addEventListener('input', onSearchInput);

    /* Bottom-Sheet-Geste (nur mobil, Grip sichtbar): nach unten ziehen folgt dem
       Finger, > 90px loslassen schliesst. Desktop-Panel hat keinen Grip. */
    function bindSheetSwipe(grip, getPanel, onClose) {
      if (!grip) return;
      var startY = null;
      grip.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        startY = e.touches[0].clientY;
        var p = getPanel();
        if (p) p.style.transition = 'none';
      }, { passive: true });
      grip.addEventListener('touchmove', function (e) {
        if (startY === null) return;
        var dy = e.touches[0].clientY - startY;
        var p = getPanel();
        if (p && dy > 0) p.style.transform = 'translateY(' + dy + 'px)';
      }, { passive: true });
      grip.addEventListener('touchend', function (e) {
        if (startY === null) return;
        var endY = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientY : startY;
        var dy = endY - startY;
        startY = null;
        var p = getPanel();
        if (p) { p.style.transition = ''; p.style.transform = ''; }
        if (dy > 90) onClose();
      });
    }
    bindSheetSwipe(q('[data-bae-grip]'), function () { return el.drawer; }, closeDrawer);
    bindSheetSwipe(q('[data-bae-tray-grip]'), function () {
      return el.traySheet ? el.traySheet.querySelector('.drawer-tray-panel') : null;
    }, closeTray);

    /* Aktiven Filter-Chip in der scrollbaren Reihe sichtbar halten (Redesign 4a):
       horizontal nachziehen, ohne die Seite vertikal zu bewegen. */
    function scrollChipIntoView(chip) {
      var row = chip ? closestIn(chip, '.drawer-filters, .drawer-subfilters') : null;
      if (!row || row.scrollWidth <= row.clientWidth) return;
      var target = chip.offsetLeft - Math.round((row.clientWidth - chip.offsetWidth) / 2);
      if (target < 0) target = 0;
      var maxLeft = row.scrollWidth - row.clientWidth;
      if (target > maxLeft) target = maxLeft;
      try { row.scrollTo({ left: target, behavior: 'smooth' }); }
      catch (err) { row.scrollLeft = target; }
    }

    /* Tastatur: Slot-Kacheln (thumb+text) sind role=button — Enter/Space löst
       denselben Klick aus (gefüllt: Galerie zeigen, leer: Drawer öffnen).
       Gilt auch für die „Dein Set"-Chips im Staffel-Modus. */
    function onRootKeydown(e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var t = closestIn(e.target, '.slot-view[role="button"], .stf-chip-thumb[role="button"]');
      if (!t) return;
      e.preventDefault();
      t.click();
    }
    root.addEventListener('keydown', onRootKeydown);

    /* Contract 3: bfcache-Guard — bei Back-Navigation aus dem Cache Drawer schließen,
       damit kein hängender Scroll-Lock/offener Drawer restauriert wird. */
    function onPageShow(e) {
      if (e && e.persisted && state.drawerOpen) {
        try { closeDrawer(); } catch (err) { /* ignore */ }
      }
    }
    window.addEventListener('pageshow', onPageShow);

    var form = el.atc ? el.atc.closest('form') : null;
    if (form) form.addEventListener('submit', onFormSubmit);
    else if (el.atc) el.atc.addEventListener('click', onFormSubmit);

    /* ----------------------------------------------------------- boot */

    if (el.drawer) el.drawer.setAttribute('aria-hidden', 'true');
    initFilterScrollers();
    if (el.mobileBar) { mcbActiveCount++; document.body.classList.add('baesics-mcb-active'); }
    setTab(state.tab);
    persist();
    renderAll();
    voiceDestroy = initVoice(root);

    function destroy() {
      try { closeDrawer(); } catch (err) { /* ignore */ }
      try { closeInfo(); } catch (err) { /* ignore */ }
      /* Ref-Count: nur wenn diese Instanz eine Mobile-Leiste beigetragen hat, und
         die Body-Klasse erst bei der letzten entfernen (s. mcbActiveCount oben). */
      if (el.mobileBar) {
        mcbActiveCount = Math.max(0, mcbActiveCount - 1);
        if (!mcbActiveCount) document.body.classList.remove('baesics-mcb-active');
      }
      root.removeEventListener('click', onRootClick);
      root.removeEventListener('change', onRootChange);
      root.removeEventListener('keydown', onRootKeydown);
      if (el.search) el.search.removeEventListener('input', onSearchInput);
      if (searchTimer) clearTimeout(searchTimer);
      if (form) form.removeEventListener('submit', onFormSubmit);
      else if (el.atc) el.atc.removeEventListener('click', onFormSubmit);
      document.removeEventListener('keydown', onDocKeydown, true);
      window.removeEventListener('pageshow', onPageShow);
      if (filterShells.length) window.removeEventListener('resize', updateFilterNav);
      if (toastTimer) clearTimeout(toastTimer);
      if (voiceDestroy) {
        try { voiceDestroy(); } catch (err) { /* ignore */ }
      }
      /* srLive mit abbauen, sonst stapeln sich Live-Regionen bei Re-Init
         desselben Roots (data-bae-ready wird ja gerade freigegeben). */
      if (srLive && srLive.parentNode) srLive.parentNode.removeChild(srLive);
      root.removeAttribute('data-bae-ready');
    }

    return { sectionId: sectionId, destroy: destroy, forceClose: forceCloseDrawer };
  }

  /* ---------------------------------------------------- lifecycle wiring */

  function initRoot(root) {
    try {
      var inst = createBundle(root);
      if (inst) instances[inst.sectionId] = inst;
    } catch (err) { /* niemals global werfen */ }
  }

  function initScope(scope) {
    if (!scope) scope = document;
    if (scope.nodeType === 1 && scope.hasAttribute && scope.hasAttribute('data-baesics-bundle')) {
      initRoot(scope);
    }
    if (scope.querySelectorAll) {
      var roots = scope.querySelectorAll('[data-baesics-bundle]');
      for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
    }
  }

  /* Theme-Editor: Drawer NIE offen hängen lassen. Jede Editor-Interaktion
     (Sektion/Block auswählen, Setting ändern → Section-Reload) schließt alle
     Bundle-Drawer zwangsweise und räumt den Body-Scroll-Lock auf. Diese
     shopify:*-Events feuern ausschließlich im Editor, nie im Live-Shop. */
  function closeAllDrawers() {
    for (var id in instances) {
      if (instances.hasOwnProperty(id) && instances[id] && instances[id].forceClose) {
        try { instances[id].forceClose(); } catch (err) { /* ignore */ }
      }
    }
    /* Belt-and-braces: verwaiste offene Drawer/Backdrops + Body-Lock direkt. */
    try {
      var op = document.querySelectorAll('.baesics-bundle .drawer.open, .baesics-bundle .drawer-backdrop.open');
      for (var i = 0; i < op.length; i++) op[i].classList.remove('open');
      document.body.classList.remove('baesics-drawer-open');
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
    } catch (err) { /* ignore */ }
  }

  var editorEvents = ['shopify:section:select', 'shopify:section:deselect', 'shopify:block:select', 'shopify:block:deselect'];
  for (var ei = 0; ei < editorEvents.length; ei++) {
    document.addEventListener(editorEvents[ei], closeAllDrawers);
  }

  document.addEventListener('shopify:section:load', function (e) {
    closeAllDrawers();
    /* Vorherige Instanz derselben Sektion abbauen, bevor neu initialisiert wird.
       Der Editor feuert bei jeder Setting-Änderung nur section:load (kein unload)
       — sonst leaken pro Edit ein window-'pageshow'-Listener + verwaiste Closures. */
    var id = e.detail && e.detail.sectionId;
    if (id && instances[id]) {
      try { instances[id].destroy(); } catch (err) { /* ignore */ }
      delete instances[id];
    }
    initScope(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var id = e.detail && e.detail.sectionId;
    if (id && instances[id]) {
      try { instances[id].destroy(); } catch (err) { /* ignore */ }
      delete instances[id];
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initScope(document); });
  } else {
    initScope(document);
  }
})();
